export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type AcceptOrdersOutput = {
  __typename?: 'AcceptOrdersOutput';
  orders: Array<Maybe<CustomerOrder>>;
};

export type ActiveJsmRequest = {
  __typename?: 'ActiveJSMRequest';
  booking?: Maybe<StoreBooking>;
  status?: Maybe<JsmStatus>;
};

export type AddAdditionalItemInput = {
  additional_product_id: Scalars['Int'];
  additional_product_qty: Scalars['Float'];
  attribute_code?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  substitution_id: Scalars['Int'];
};

export type AddAdditionalMultipleItemInput = {
  additional_items: Array<InputMaybe<AddAdditionalItemInput>>;
  substitution_id: Scalars['Int'];
};

/** Defines the bundle products to add to the cart. */
export type AddBundleProductsToCartInput = {
  /** The ID of the cart. */
  cart_id: Scalars['String'];
  /** An array of bundle products to add. */
  cart_items: Array<InputMaybe<BundleProductCartItemInput>>;
};

/** Contains details about the cart after adding bundle products. */
export type AddBundleProductsToCartOutput = {
  __typename?: 'AddBundleProductsToCartOutput';
  /** The cart after adding products. */
  cart: Cart;
};

export type AddCommentToAdditionalItemInput = {
  additional_item_id: Scalars['Int'];
  comment: Scalars['String'];
  substitution_id: Scalars['Int'];
};

export type AddCommentToBookedServiceInput = {
  /** The ID of booking to update. */
  booking_uid: Scalars['ID'];
  /** The comment on a given booked service. */
  comment: Scalars['String'];
};

/** Defines the configurable products to add to the cart. */
export type AddConfigurableProductsToCartInput = {
  /** The ID of the cart. */
  cart_id: Scalars['String'];
  /** An array of configurable products to add. */
  cart_items: Array<InputMaybe<ConfigurableProductCartItemInput>>;
};

/** Contains details about the cart after adding configurable products. */
export type AddConfigurableProductsToCartOutput = {
  __typename?: 'AddConfigurableProductsToCartOutput';
  /** The cart after adding products. */
  cart: Cart;
};

export type AddDownloadableProductsToCartInput = {
  /** The ID of the cart. */
  cart_id: Scalars['String'];
  /** An array of downloadable products to add. */
  cart_items: Array<InputMaybe<DownloadableProductCartItemInput>>;
};

/** Contains details about the cart after adding downloadable products. */
export type AddDownloadableProductsToCartOutput = {
  __typename?: 'AddDownloadableProductsToCartOutput';
  /** The cart after adding products. */
  cart: Cart;
};

export type AddNewAdminUserInput = {
  email: Scalars['String'];
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  role_id?: InputMaybe<Scalars['Int']>;
  store_locator_id?: InputMaybe<Scalars['Int']>;
  store_locator_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  username: Scalars['String'];
};

/** Contains details about the cart after adding products to it. */
export type AddProductsToCartOutput = {
  __typename?: 'AddProductsToCartOutput';
  /** The cart after products have been added. */
  cart: Cart;
  /** Contains errors encountered while adding an item to the cart. */
  user_errors: Array<Maybe<CartUserInputError>>;
};

/** Contains products to add to an existing compare list. */
export type AddProductsToCompareListInput = {
  /** An array of product IDs to add to the compare list. */
  products: Array<InputMaybe<Scalars['ID']>>;
  /** The unique identifier of the compare list to modify. */
  uid: Scalars['ID'];
};

/** Contains the customer's wish list and any errors encountered. */
export type AddProductsToWishlistOutput = {
  __typename?: 'AddProductsToWishlistOutput';
  /** An array of errors encountered while adding products to a wish list. */
  user_errors: Array<Maybe<WishListUserInputError>>;
  /** Contains the wish list with all items that were successfully added. */
  wishlist: Wishlist;
};

export type AddServicesToStoreOutput = {
  __typename?: 'AddServicesToStoreOutput';
  store_locator: StoreLocator;
};

/** Defines the simple and group products to add to the cart. */
export type AddSimpleProductsToCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
  /** An array of simple and group items to add. */
  cart_items: Array<InputMaybe<SimpleProductCartItemInput>>;
};

/** Contains details about the cart after adding simple or group products. */
export type AddSimpleProductsToCartOutput = {
  __typename?: 'AddSimpleProductsToCartOutput';
  /** The cart after adding products. */
  cart: Cart;
};

export type AddToJumpStartOrderInput = {
  orderNumber: Scalars['String'];
  sku: Scalars['String'];
};

export type AddToVanServiceOrderInput = {
  items: Array<InputMaybe<AddableItem>>;
  orderNumber: Scalars['String'];
};

/** Defines the virtual products to add to the cart. */
export type AddVirtualProductsToCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
  /** An array of virtual products to add. */
  cart_items: Array<InputMaybe<VirtualProductCartItemInput>>;
};

/** Contains details about the cart after adding virtual products. */
export type AddVirtualProductsToCartOutput = {
  __typename?: 'AddVirtualProductsToCartOutput';
  /** The cart after adding products. */
  cart: Cart;
};

/** Contains the resultant wish list and any error information. */
export type AddWishlistItemsToCartOutput = {
  __typename?: 'AddWishlistItemsToCartOutput';
  /** An array of errors encountered while adding products to the customer's cart. */
  add_wishlist_items_to_cart_user_errors: Array<Maybe<WishlistCartUserInputError>>;
  /** Indicates whether the attempt to add items to the customer's cart was successful. */
  status: Scalars['Boolean'];
  /** Contains the wish list with all items that were successfully added. */
  wishlist: Wishlist;
};

export type AddableItem = {
  productSku: Scalars['String'];
  qty: Scalars['Int'];
};

export type AdditionalItem = {
  __typename?: 'AdditionalItem';
  attribute_code?: Maybe<Scalars['String']>;
  /** Information about the booking of this item */
  booking?: Maybe<BookedService>;
  comment?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  price: Scalars['Float'];
  product: ProductInterface;
  quantity: Scalars['Float'];
  row_total: Scalars['Float'];
  status: SubstitutionItemStatus;
};

export type AddressFilterInput = {
  is_active?: InputMaybe<Scalars['Boolean']>;
};

/** Admin defines the admin name and address and other details */
export type Admin = {
  __typename?: 'Admin';
  /** The current active JSM order that the rider is working on */
  active_jsm_request?: Maybe<ActiveJsmRequest>;
  /** The number of assigned JSM requests on the rider */
  assigned_jsm_requests: RiderRequestsOutput;
  /** The number of completed JSM requests by the rider */
  completed_jsm_requests: RiderRequestsOutput;
  /** Timestamp indicating when the account was created */
  created?: Maybe<Scalars['String']>;
  /** The admin's email address. Required */
  email?: Maybe<Scalars['String']>;
  /** The admin's first name */
  firstname?: Maybe<Scalars['String']>;
  /** The user id associated with the account */
  id?: Maybe<Scalars['Int']>;
  /** The admin's status. Required */
  isActive?: Maybe<Scalars['String']>;
  /** Indicates whether the user is a rider. */
  is_rider: Scalars['Boolean'];
  /** The admin's family name */
  lastname?: Maybe<Scalars['String']>;
  /** The admin's role. */
  role?: Maybe<AdminRole>;
  /** Get Stores that are assigned for current User */
  store_locators: StoreLocatorOutput;
  /** The admin's username. Required */
  username?: Maybe<Scalars['String']>;
  vanServiceRequests: RiderVsRequestsOutput;
};


/** Admin defines the admin name and address and other details */
export type AdminAssigned_Jsm_RequestsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


/** Admin defines the admin name and address and other details */
export type AdminCompleted_Jsm_RequestsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  duration?: InputMaybe<DurationEnum>;
  filter?: InputMaybe<JsmRequestFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


/** Admin defines the admin name and address and other details */
export type AdminStore_LocatorsArgs = {
  cityId?: InputMaybe<Scalars['Int']>;
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  regionId?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  services?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<StoreTypeEnum>;
};


/** Admin defines the admin name and address and other details */
export type AdminVanServiceRequestsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  duration?: InputMaybe<DurationEnum>;
  filter?: InputMaybe<JsmRequestFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
  status: RiderStatus;
};

export type AdminCustomerOrdersFilterInput = {
  /** Filters by order stock source. */
  source_code?: InputMaybe<FilterStringTypeInput>;
};

export enum AdminFcmChannel {
  /** @deprecated  */
  Android = 'ANDROID',
  /** @deprecated  */
  Web = 'WEB'
}

export type AdminOrderSourceOnCartInput = {
  cart_id: Scalars['String'];
  customer_id?: InputMaybe<Scalars['Int']>;
  order_source: Scalars['String'];
};

export type AdminOutput = {
  __typename?: 'AdminOutput';
  admin: Admin;
};

export type AdminRole = {
  __typename?: 'AdminRole';
  is_multi_branch_role: Scalars['Boolean'];
  is_rider: Scalars['Boolean'];
  is_single_branch_role: Scalars['Boolean'];
  is_van_rider: Scalars['Boolean'];
  label: Scalars['String'];
  value: Scalars['Int'];
};

export type AdminRoles = {
  __typename?: 'AdminRoles';
  items: Array<Maybe<AdminRole>>;
  total_count: Scalars['Int'];
};

export type AdminToken = {
  __typename?: 'AdminToken';
  /** The admin refresh token */
  refresh_token: Scalars['String'];
  /** in timestamp */
  refresh_token_expires_at?: Maybe<Scalars['String']>;
  /** The admin token */
  token: Scalars['String'];
  /** in timestamp */
  token_expires_at?: Maybe<Scalars['String']>;
};

export type Admins = {
  __typename?: 'Admins';
  items?: Maybe<Array<Maybe<Admin>>>;
  page_info?: Maybe<SearchResultPageInfo>;
  total_count?: Maybe<Scalars['Int']>;
};

/** Contains information for each filterable option (such as price, category `UID`, and custom attributes). */
export type Aggregation = {
  __typename?: 'Aggregation';
  /** Attribute code of the aggregation group. */
  attribute_code: Scalars['String'];
  /** The number of options in the aggregation group. */
  count?: Maybe<Scalars['Int']>;
  /** The aggregation display name. */
  label?: Maybe<Scalars['String']>;
  /** Array of options for the aggregation. */
  options?: Maybe<Array<Maybe<AggregationOption>>>;
  /** The relative position of the attribute in a layered navigation block. */
  position?: Maybe<Scalars['Int']>;
};

/** An implementation of `AggregationOptionInterface`. */
export type AggregationOption = AggregationOptionInterface & {
  __typename?: 'AggregationOption';
  /** The number of items that match the aggregation option. */
  count?: Maybe<Scalars['Int']>;
  /** The display label for an aggregation option. */
  label?: Maybe<Scalars['String']>;
  /** The internal ID that represents the value of the option. */
  value: Scalars['String'];
};

/** Defines aggregation option fields. */
export type AggregationOptionInterface = {
  /** The number of items that match the aggregation option. */
  count?: Maybe<Scalars['Int']>;
  /** The display label for an aggregation option. */
  label?: Maybe<Scalars['String']>;
  /** The internal ID that represents the value of the option. */
  value: Scalars['String'];
};

/** Filter category aggregations in layered navigation. */
export type AggregationsCategoryFilterInput = {
  /** Indicates whether to include only direct subcategories or all children categories at all levels. */
  includeDirectChildrenOnly?: InputMaybe<Scalars['Boolean']>;
};

/** An input object that specifies the filters used in product aggregations. */
export type AggregationsFilterInput = {
  /** Filter category aggregations in layered navigation. */
  category?: InputMaybe<AggregationsCategoryFilterInput>;
};

export type AheadworksBlogPost = {
  __typename?: 'AheadworksBlogPost';
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type AmastyBlogPost = {
  __typename?: 'AmastyBlogPost';
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type AmastyFaqQuestion = {
  __typename?: 'AmastyFaqQuestion';
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** Contains the applied coupon code. */
export type AppliedCoupon = {
  __typename?: 'AppliedCoupon';
  /** The coupon code the shopper applied to the card. */
  code: Scalars['String'];
};

/** Specifies the coupon code to apply to the cart. */
export type ApplyCouponToCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
  /** A valid coupon code. */
  coupon_code: Scalars['String'];
};

/** Contains details about the cart after applying a coupon. */
export type ApplyCouponToCartOutput = {
  __typename?: 'ApplyCouponToCartOutput';
  /** The cart after applying a coupon. */
  cart: Cart;
};

export type ApplyEvouchersToCartInput = {
  cart_id: Scalars['String'];
  evoucher_codes: Array<InputMaybe<Scalars['String']>>;
};

export type ApplyEvouchersToCartOutput = {
  __typename?: 'ApplyEvouchersToCartOutput';
  /** The cart after the evouchers have been applied. */
  cart: Cart;
  /** An array of errors that occurred from applying the evouchers. */
  invalid_evouchers: Array<Maybe<Scalars['String']>>;
};

export type ApproveAdditionalItemInput = {
  additional_item_id: Scalars['Int'];
  substitution_id: Scalars['Int'];
};

export type ApproveSubstitutionItemInput = {
  substitution_id: Scalars['Int'];
  substitution_item_id: Scalars['Int'];
};

/** AreaInput defines the parameters which will be used for filter by specified location. */
export type AreaInput = {
  /** The radius for the search in KM. */
  radius: Scalars['Int'];
  /** The country code where search must be performed. Required parameter together with region, city or postcode. */
  search_term: Scalars['String'];
};

/** Contains the results of the request to assign a compare list. */
export type AssignCompareListToCustomerOutput = {
  __typename?: 'AssignCompareListToCustomerOutput';
  /** The contents of the customer's compare list. */
  compare_list?: Maybe<CompareList>;
  /** Indicates whether the compare list was successfully assigned to the customer. */
  result: Scalars['Boolean'];
};

export type AssignJsmRiderInput = {
  bookingUid: Scalars['ID'];
  riderId: Scalars['Int'];
};

export type AssignVehicleToCartOutput = {
  __typename?: 'AssignVehicleToCartOutput';
  cart: Cart;
};

/** Contains details about the attribute, including the code and type. */
export type Attribute = {
  __typename?: 'Attribute';
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  attribute_code?: Maybe<Scalars['String']>;
  /** Attribute options list. */
  attribute_options?: Maybe<Array<Maybe<AttributeOption>>>;
  /** The data type of the attribute. */
  attribute_type?: Maybe<Scalars['String']>;
  /** The type of entity that defines the attribute. */
  entity_type?: Maybe<Scalars['String']>;
  entity_type_code?: Maybe<EntityType>;
  group?: Maybe<Scalars['String']>;
  /** The frontend input type of the attribute. */
  input_type?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  /** Details about the storefront properties configured for the attribute. */
  storefront_properties?: Maybe<StorefrontProperties>;
};

/** Defines the attribute characteristics to search for the `attribute_code` and `entity_type` to search. */
export type AttributeInput = {
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  attribute_code?: InputMaybe<Scalars['String']>;
  /** The type of entity that defines the attribute. */
  entity_type?: InputMaybe<Scalars['String']>;
};

/** Defines an attribute option. */
export type AttributeOption = {
  __typename?: 'AttributeOption';
  /** The label assigned to the attribute option. */
  label?: Maybe<Scalars['String']>;
  /** The attribute option value. */
  value?: Maybe<Scalars['String']>;
};

export type AttributeSetInformation = {
  __typename?: 'AttributeSetInformation';
  id: Scalars['Int'];
  name: Scalars['String'];
};

/** Describes a payment method that the shopper can use to pay for the order. */
export type AvailablePaymentMethod = {
  __typename?: 'AvailablePaymentMethod';
  /** The payment method code. */
  code: Scalars['String'];
  /** If the payment method is an online integration */
  is_deferred: Scalars['Boolean'];
  /** The payment method title. */
  title: Scalars['String'];
};

/** Contains details about the possible shipping methods and carriers. */
export type AvailableShippingMethod = {
  __typename?: 'AvailableShippingMethod';
  /** The cost of shipping using this shipping method. */
  amount: Money;
  /** Indicates whether this shipping method can be applied to the cart. */
  available: Scalars['Boolean'];
  /** @deprecated The field should not be used on the storefront. */
  base_amount?: Maybe<Money>;
  /** A string that identifies a commercial carrier or an offline shipping method. */
  carrier_code: Scalars['String'];
  /** The label for the carrier code. */
  carrier_title: Scalars['String'];
  /** Describes an error condition. */
  error_message?: Maybe<Scalars['String']>;
  /** A shipping method code associated with a carrier. The value could be null if no method is available. */
  method_code?: Maybe<Scalars['String']>;
  /** The label for the shipping method code. The value could be null if no method is available. */
  method_title?: Maybe<Scalars['String']>;
  /** The cost of shipping using this shipping method, excluding tax. */
  price_excl_tax: Money;
  /** The cost of shipping using this shipping method, including tax. */
  price_incl_tax: Money;
};

export enum BatchMutationStatus {
  /** @deprecated  */
  Failure = 'FAILURE',
  /** @deprecated  */
  MixedResults = 'MIXED_RESULTS',
  /** @deprecated  */
  Success = 'SUCCESS'
}

export type BestSellingProduct = {
  __typename?: 'BestSellingProduct';
  product: ProductInterface;
  quantity: Scalars['Float'];
};

export type BestsellersProductOutput = {
  __typename?: 'BestsellersProductOutput';
  /** Currency */
  currency?: Maybe<Scalars['String']>;
  /** Period. */
  period?: Maybe<Scalars['String']>;
  /** Product ID */
  product_id?: Maybe<Scalars['String']>;
  /** Product Image URL */
  product_image_url?: Maybe<Scalars['String']>;
  /** Product Name */
  product_name?: Maybe<Scalars['String']>;
  /** Product Price */
  product_price?: Maybe<Scalars['String']>;
  /** Product SKU */
  product_sku?: Maybe<Scalars['String']>;
  /** Product URL */
  product_url?: Maybe<Scalars['String']>;
  /** Order Quantity. */
  qty_ordered?: Maybe<Scalars['Int']>;
};

/** Defines the billing address. */
export type BillingAddressInput = {
  /** Defines a billing address. */
  address?: InputMaybe<CartAddressInput>;
  /** An ID from the customer's address book that uniquely identifies the address to be used for billing. */
  customer_address_id?: InputMaybe<Scalars['Int']>;
  /** Indicates whether to set the billing address to be the same as the existing shipping address on the cart. */
  same_as_shipping?: InputMaybe<Scalars['Boolean']>;
  /** Indicates whether to set the shipping address to be the same as this billing address. */
  use_for_shipping?: InputMaybe<Scalars['Boolean']>;
};

/** Contains details about the billing address. */
export type BillingCartAddress = CartAddressInterface & {
  __typename?: 'BillingCartAddress';
  /** An object containing the city name, city code, and city ID */
  city?: Maybe<City>;
  /** The company specified for the billing or shipping address. */
  company?: Maybe<Scalars['String']>;
  /** An object containing the country name, country code, and country ID */
  country?: Maybe<Country>;
  /** @deprecated The field is used only in shipping address. */
  customer_notes?: Maybe<Scalars['String']>;
  /** The first name of the customer or guest. */
  firstname: Scalars['String'];
  /** The last name of the customer or guest. */
  lastname: Scalars['String'];
  /** The ZIP or postal code of the billing or shipping address. */
  postcode?: Maybe<Scalars['String']>;
  region: Region;
  /** An array containing the street for the billing or shipping address. */
  street: Array<Maybe<Scalars['String']>>;
  /** The telephone number for the billing or shipping address. */
  telephone?: Maybe<Scalars['String']>;
  /** The unique id of the customer address. */
  uid: Scalars['String'];
  /** The VAT company number for billing or shipping address. */
  vat_id?: Maybe<Scalars['String']>;
};

export type BookAdditionalServiceInput = {
  attribute_code?: InputMaybe<Scalars['String']>;
  /** The ID of the choosen service on the store to book at. */
  bookable_service_uid: Scalars['ID'];
  /** The day to book at in the format `YYYY-MM-DD`. */
  booking_day?: InputMaybe<Scalars['String']>;
  /** The time to book at in the format `HH:MM`. */
  booking_time?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  substitution_id: Scalars['Int'];
};

export type BookAllCartServicesInput = {
  cart_id: Scalars['String'];
  /** The chosen day formatted as `YYYY-MM-DD`. */
  day: Scalars['String'];
  /** The chosen start time formatted as `HH:MM`. */
  start_time: Scalars['String'];
  store_locator_id: Scalars['Int'];
};

export type BookAllCartServicesOutput = {
  __typename?: 'BookAllCartServicesOutput';
  cart: Cart;
};

export type BookCartServicesSeparatelyOutput = {
  __typename?: 'BookCartServicesSeparatelyOutput';
  cart: Cart;
};

export type BookableCartServiceInput = {
  /** The ID of the choosen service on the store to book at. */
  bookable_service_uid: Scalars['ID'];
  /** The day to book at in the format `YYYY-MM-DD`. By default it's today if left empty. */
  booking_day?: InputMaybe<Scalars['String']>;
  /** The time to book at in the format `HH:MM`. If left empty it's set to the first available slot in the given day. */
  booking_time?: InputMaybe<Scalars['String']>;
  cart_item_uid: Scalars['ID'];
};

export type BookableService = {
  __typename?: 'BookableService';
  /** Get Array of times available for booking the given service formatted as `HH:MM` */
  available_times_for_booking: Array<Maybe<Scalars['String']>>;
  bookable_service_uid: Scalars['ID'];
  /** If this service is enabled in store. */
  is_enabled_in_store?: Maybe<Scalars['Boolean']>;
  /** Number of minutes before the booking time to allow booking. */
  lead_time?: Maybe<Scalars['Int']>;
  /** Service has same working hours as store. */
  same_as_store_times: Scalars['Boolean'];
  /** Number of cars the store can serve for this service at a time. */
  store_capacity?: Maybe<Scalars['Int']>;
  /** Number of slot durations the store takes. To calculate total duration check the one slot duration from `StoreConfig`. */
  store_duration_slots?: Maybe<Scalars['Int']>;
  working_from?: Maybe<Scalars['Int']>;
  working_to?: Maybe<Scalars['Int']>;
};


export type BookableServiceAvailable_Times_For_BookingArgs = {
  bookingDay?: InputMaybe<Scalars['String']>;
};

export type BookableServiceImportInput = {
  is_enabled_in_store?: InputMaybe<Scalars['Int']>;
  lead_time?: InputMaybe<Scalars['Int']>;
  sku: Scalars['String'];
  store_capacity?: InputMaybe<Scalars['Int']>;
  store_duration_slots?: InputMaybe<Scalars['Int']>;
  working_from?: InputMaybe<Scalars['Int']>;
  working_to?: InputMaybe<Scalars['Int']>;
};

export type BookableServiceInput = {
  /** By default any new added service is enabled. */
  is_enabled_in_store?: InputMaybe<Scalars['Boolean']>;
  /** Number of minutes before the booking time to allow booking. */
  lead_time?: InputMaybe<Scalars['Int']>;
  /** Set the service timings the same as store working hours. */
  same_as_store_times?: InputMaybe<Scalars['Boolean']>;
  sku: Scalars['String'];
  /** Number of cars the store can serve for this service at a time. */
  store_capacity?: InputMaybe<Scalars['Int']>;
  /** Number of slot durations the store takes. To calculate total duration check the one slot duration from `StoreConfig`. */
  store_duration_slots?: InputMaybe<Scalars['Int']>;
  working_times?: InputMaybe<WorkingTimesInput>;
};

export type BookedItem = {
  __typename?: 'BookedItem';
  /** Information about the booking of this item */
  booking?: Maybe<BookedService>;
  /** The final discount information for the service */
  discount?: Maybe<Discount>;
  /** The sale price of the base product, including selected options */
  price: Money;
  /** The name of the base product */
  product_name?: Maybe<Scalars['String']>;
  /** The SKU of the base product */
  product_sku: Scalars['String'];
  /** The number of units ordered for this item */
  quantity_ordered?: Maybe<Scalars['Float']>;
  /** The unique ID for a `BookedItem` object */
  uid: Scalars['ID'];
};

export type BookedService = {
  __typename?: 'BookedService';
  /** The admin who booked the service. */
  admin?: Maybe<Admin>;
  /** Get Array of views on a given booked service. */
  admin_views_for_booked_service?: Maybe<Array<Maybe<BookedServiceAdminViewOutput>>>;
  /** The unique ID for this bookable service at this store. */
  bookable_service_uid: Scalars['ID'];
  /** The booked day for the cart item as bookable service formatted as `YYYY-MM-DD`. */
  booked_day: Scalars['String'];
  /** The end time of this booking formatted as `HH:MM`. */
  booking_end_time: Scalars['String'];
  /** The start time of this booking formatted as `HH:MM`. */
  booking_start_time: Scalars['String'];
  /** The cancellation comment if the booking is `canceled`. */
  cancellation_comment?: Maybe<Scalars['String']>;
  /** The cancellation reason if the booking is `canceled`. */
  cancellation_reason?: Maybe<Scalars['String']>;
  /** The number of items ordered from this service */
  quantity: Scalars['Int'];
  /** The status of the booking */
  status?: Maybe<BookingStatus>;
  /** Get Array of comments on a given booked service. */
  status_history_for_booked_service?: Maybe<Array<Maybe<BookedServiceStatusHistoryOutput>>>;
  /** Number of slot durations the store takes. To calculate total duration check the one slot duration from `StoreConfig`. */
  store_duration_slots?: Maybe<Scalars['Int']>;
  /** The unique ID for the booking */
  uid: Scalars['ID'];
};

export type BookedServiceAdminViewOutput = {
  __typename?: 'BookedServiceAdminViewOutput';
  /** Admin defines the admin name and address and other details */
  admin?: Maybe<Admin>;
  /** The date the comment was created */
  created_at?: Maybe<Scalars['String']>;
};

export type BookedServiceStatusHistoryOutput = {
  __typename?: 'BookedServiceStatusHistoryOutput';
  /** Admin defines the admin name and address and other details */
  admin?: Maybe<Admin>;
  comment?: Maybe<Scalars['String']>;
  /** The date the comment was created */
  created_at?: Maybe<Scalars['String']>;
  status?: Maybe<BookingStatus>;
};

export type BookingCustomer = {
  __typename?: 'BookingCustomer';
  customer_id?: Maybe<Scalars['Int']>;
  email: Scalars['String'];
  is_guest: Scalars['Boolean'];
  name: Scalars['String'];
  telephone: Scalars['String'];
};

export enum BookingStatus {
  /** @deprecated  */
  Canceled = 'CANCELED',
  /** @deprecated  */
  Completed = 'COMPLETED',
  /** @deprecated  */
  Confirmed = 'CONFIRMED',
  /** @deprecated  */
  Dummy = 'DUMMY',
  /** @deprecated  */
  Missed = 'MISSED',
  /** @deprecated  */
  Pending = 'PENDING',
  /** @deprecated  */
  PendingCheckout = 'PENDING_CHECKOUT'
}

/** Contains details about the sales total amounts used to calculate the final price */
export type BookingTotal = {
  __typename?: 'BookingTotal';
  /** The applied discounts to the order */
  discount?: Maybe<Discount>;
  /** The final total amount, including discounts, and taxes */
  grand_total: Money;
  /** The subtotal of the order, excluding discounts, and taxes */
  subtotal: Money;
  /** The total amount cancelled. */
  total_canceled: Money;
  /** The total amount paid. */
  total_paid: Money;
};

export type Brand = {
  __typename?: 'Brand';
  footer_content?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  image_alt_value?: Maybe<Scalars['String']>;
  image_url?: Maybe<Scalars['String']>;
  is_in_slider?: Maybe<Scalars['Boolean']>;
  is_shown_in_homepage?: Maybe<Scalars['Int']>;
  meta_description?: Maybe<Scalars['String']>;
  meta_title?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** The brand offers. */
  offers: Array<Maybe<BrandOffer>>;
  slider_sort_order?: Maybe<Scalars['Int']>;
  url_key?: Maybe<Scalars['String']>;
};


export type BrandOffersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type BrandOffer = {
  __typename?: 'BrandOffer';
  button_text?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  image_url: Scalars['String'];
  is_featured: Scalars['Boolean'];
  link_object_url_key?: Maybe<Scalars['String']>;
  link_type?: Maybe<Scalars['String']>;
  mobile_image_url: Scalars['String'];
  offer_url: Scalars['String'];
  sort?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

/** Contains details about an individual category that comprises a breadcrumb. */
export type Breadcrumb = {
  __typename?: 'Breadcrumb';
  /**
   * The ID of the category.
   * @deprecated Use `category_uid` instead.
   */
  category_id?: Maybe<Scalars['Int']>;
  /** The category level. */
  category_level?: Maybe<Scalars['Int']>;
  /** The display name of the category. */
  category_name?: Maybe<Scalars['String']>;
  /** The unique ID for a `Breadcrumb` object. */
  category_uid: Scalars['ID'];
  /** The URL key of the category. */
  category_url_key?: Maybe<Scalars['String']>;
  /** The URL path of the category. */
  category_url_path?: Maybe<Scalars['String']>;
};

/** An implementation for bundle product cart items. */
export type BundleCartItem = CartItemInterface & {
  __typename?: 'BundleCartItem';
  /** Information about the booking of this item */
  booked_service?: Maybe<BookedService>;
  /** An array containing the bundle options the shopper selected. */
  bundle_options: Array<Maybe<SelectedBundleOption>>;
  /** An array containing the customizable options the shopper selected. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>;
  /** The entered gift message for the cart item */
  gift_message?: Maybe<GiftMessage>;
  /** @deprecated Use `uid` instead. */
  id: Scalars['String'];
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>;
  /** Details about an item in the cart. */
  product: ProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float'];
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID'];
};

/** Defines bundle product options for `CreditMemoItemInterface`. */
export type BundleCreditMemoItem = CreditMemoItemInterface & {
  __typename?: 'BundleCreditMemoItem';
  /** A list of bundle options that are assigned to a bundle product that is part of a credit memo. */
  bundle_options?: Maybe<Array<Maybe<ItemSelectedBundleOption>>>;
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars['ID'];
  /** The order item the credit memo is applied to. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price for the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']>;
};

/** Defines bundle product options for `InvoiceItemInterface`. */
export type BundleInvoiceItem = InvoiceItemInterface & {
  __typename?: 'BundleInvoiceItem';
  /** A list of bundle options that are assigned to an invoiced bundle product. */
  bundle_options?: Maybe<Array<Maybe<ItemSelectedBundleOption>>>;
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars['ID'];
  /** Details about an individual order item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price for the base product including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']>;
};

/** Defines an individual item within a bundle product. */
export type BundleItem = {
  __typename?: 'BundleItem';
  /**
   * An ID assigned to each type of item in a bundle product.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>;
  /** An array of additional options for this bundle item. */
  options?: Maybe<Array<Maybe<BundleItemOption>>>;
  /** A number indicating the sequence order of this item compared to the other bundle items. */
  position?: Maybe<Scalars['Int']>;
  /** The range of prices for the product */
  price_range: PriceRange;
  /** Indicates whether the item must be included in the bundle. */
  required?: Maybe<Scalars['Boolean']>;
  /** The SKU of the bundle product. */
  sku?: Maybe<Scalars['String']>;
  /** The display name of the item. */
  title?: Maybe<Scalars['String']>;
  /** The input type that the customer uses to select the item. Examples include radio button and checkbox. */
  type?: Maybe<Scalars['String']>;
  /** The unique ID for a `BundleItem` object. */
  uid?: Maybe<Scalars['ID']>;
};

/** Defines the characteristics that comprise a specific bundle item and its options. */
export type BundleItemOption = {
  __typename?: 'BundleItemOption';
  /** Indicates whether the customer can change the number of items for this option. */
  can_change_quantity?: Maybe<Scalars['Boolean']>;
  /**
   * The ID assigned to the bundled item option.
   * @deprecated Use `uid` instead
   */
  id?: Maybe<Scalars['Int']>;
  /** Indicates whether this option is the default option. */
  is_default?: Maybe<Scalars['Boolean']>;
  /** The text that identifies the bundled item option. */
  label?: Maybe<Scalars['String']>;
  /** When a bundle item contains multiple options, the relative position of this option compared to the other options. */
  position?: Maybe<Scalars['Int']>;
  /** The price of the selected option. */
  price?: Maybe<Scalars['Float']>;
  /** One of FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** Contains details about this product option. */
  product?: Maybe<ProductInterface>;
  /**
   * Indicates the quantity of this specific bundle item.
   * @deprecated Use `quantity` instead.
   */
  qty?: Maybe<Scalars['Float']>;
  /** The quantity of this specific bundle item. */
  quantity?: Maybe<Scalars['Float']>;
  /** The unique ID for a `BundleItemOption` object. */
  uid: Scalars['ID'];
};

/** Defines the input for a bundle option. */
export type BundleOptionInput = {
  /** The ID of the option. */
  id: Scalars['Int'];
  /** The number of the selected item to add to the cart. */
  quantity: Scalars['Float'];
  /** An array with the chosen value of the option. */
  value: Array<InputMaybe<Scalars['String']>>;
};

/** Defines bundle product options for `OrderItemInterface`. */
export type BundleOrderItem = OrderItemInterface & {
  __typename?: 'BundleOrderItem';
  /** Information about the booking of this item */
  booked_service?: Maybe<BookedService>;
  /** A list of bundle options that are assigned to the bundle product. */
  bundle_options?: Maybe<Array<Maybe<ItemSelectedBundleOption>>>;
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The entered option for the base product, such as a logo or image. */
  entered_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The selected gift message for the order item */
  gift_message?: Maybe<GiftMessage>;
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars['ID'];
  /** The categories assigned to the product. */
  product_categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** The URL of the main product image of the base product */
  product_image_url?: Maybe<Scalars['String']>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The original price of the base product */
  product_original_price: Money;
  /** The sale price of the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The URL of the thumbnail image of the base product */
  product_thumbnail_url?: Maybe<Scalars['String']>;
  /** The type of product, such as simple, configurable, etc. */
  product_type?: Maybe<Scalars['String']>;
  /** URL key of the base product. */
  product_url_key?: Maybe<Scalars['String']>;
  /** The number of canceled items. */
  quantity_canceled?: Maybe<Scalars['Float']>;
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']>;
  /** The number of units ordered for this item. */
  quantity_ordered?: Maybe<Scalars['Float']>;
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']>;
  /** The number of returned items. */
  quantity_returned?: Maybe<Scalars['Float']>;
  /** The number of shipped items. */
  quantity_shipped?: Maybe<Scalars['Float']>;
  /** The selected options for the base product, such as color or size. */
  selected_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The status of the order item. */
  status?: Maybe<Scalars['String']>;
};

/** Defines basic features of a bundle product and contains multiple BundleItems. */
export type BundleProduct = CustomizableProductInterface & PhysicalProductInterface & ProductInterface & RoutableInterface & {
  __typename?: 'BundleProduct';
  /** @deprecated Use the `custom_attributes` field instead. */
  ampere?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  aspect_ratio?: Maybe<Scalars['Int']>;
  /** Attribute set information */
  attribute_set?: Maybe<AttributeSetInformation>;
  /**
   * The attribute set assigned to the product.
   * @deprecated The field should not be used on the storefront.
   */
  attribute_set_id?: Maybe<Scalars['Int']>;
  /** List of product attributes */
  attributes?: Maybe<Array<Maybe<CustomAttribute>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  average_duration?: Maybe<Scalars['String']>;
  /** Attributes regarding this bookable service in the given store locator. */
  bookable_service?: Maybe<BookableService>;
  /** The product brand. */
  brand?: Maybe<Brand>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
  canonical_url?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  car_batteries_ampere?: Maybe<Scalars['Int']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  color?: Maybe<Scalars['Int']>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  country_of_origin?: Maybe<Scalars['Int']>;
  /**
   * Timestamp indicating when the product was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  creation_date?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  creation_id?: Maybe<Scalars['Int']>;
  /** Crosssell Products */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /**
   * List of product custom labels
   * @deprecated Use the `custom_attributes` field instead.
   */
  custom_labels: Array<Maybe<Label>>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  /** @deprecated Use the `custom_attributes` field instead. */
  diameter?: Maybe<Scalars['Int']>;
  /** Indicates whether the bundle product has a dynamic price. */
  dynamic_price?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the bundle product has a dynamic SKU. */
  dynamic_sku?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the bundle product has a dynamically calculated weight. */
  dynamic_weight?: Maybe<Scalars['Boolean']>;
  expected_shipping_fees?: Maybe<Scalars['Float']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  exterior_hand_wash?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_age_group?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_age_range?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_baby_food_stage?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_brand?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_capacity?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_color?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_compatible_devices?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_decor_style?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_digital_zoom?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_display_technology?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_finish?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_gemstone?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_gender?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_health_concern?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_ingredients?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_is_assembly_required?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_material?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_maximum_weight?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_megapixels?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_minimum_weight?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_model?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_number_of_licenses?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_operating_system?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_optical_zoom?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_package_quantity?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_pattern?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_depth?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_form?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_height?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_length?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_weight?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_width?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_recommended_use?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_resolution?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_scent?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_screen_size?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_shoe_width?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_size?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_storage_capacity?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_style?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_system_requirements?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_thread_count?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_video_game_platform?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  featured_order?: Maybe<Scalars['Int']>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  has_deal?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  hover_cleaning?: Maybe<Scalars['Int']>;
  /**
   * The ID number assigned to the product.
   * @deprecated Use the `uid` field instead.
   */
  id?: Maybe<Scalars['Int']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** @deprecated Use the `custom_attributes` field instead. */
  in_store_only?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  interior_cleaning?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  interior_vacuum_clean?: Maybe<Scalars['Int']>;
  /** Check if product is a best seller */
  is_best_seller?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  is_bookable_service?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  is_bookable_service_addon?: Maybe<Scalars['Int']>;
  /** if the product favorited by the logged in user */
  is_favorited?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  is_featured?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  is_featured_offer?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  is_november_deal?: Maybe<Scalars['Int']>;
  is_van_installment_enabled: Scalars['Boolean'];
  /** Indicates whether the product is the wiper that has the gift or not. */
  is_wiper: Scalars['Boolean'];
  /** An array containing information about individual bundle items. */
  items?: Maybe<Array<Maybe<BundleItem>>>;
  /** product labels */
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * A number representing the product's manufacturer.
   * @deprecated Use the `custom_attributes` field instead.
   */
  manufacturer?: Maybe<Scalars['Int']>;
  /** An array of media gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use `media_gallery` instead.
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  mileage_warranty?: Maybe<Scalars['String']>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']>;
  /** Quantity of product left in customer's choosen source */
  only_x_left_in_source?: Maybe<Scalars['Float']>;
  /** Product stock only x left count */
  only_x_left_in_stock?: Maybe<Scalars['Float']>;
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  pattern?: Maybe<Scalars['String']>;
  /**
   * Indicates the price of an item.
   * @deprecated Use `price_range` for product price information.
   */
  price?: Maybe<ProductPrices>;
  /** The range of prices for the product */
  price_range: PriceRange;
  /** An array of `TierPrice` objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** One of PRICE_RANGE or AS_LOW_AS. */
  price_view?: Maybe<PriceViewEnum>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_brand_id?: Maybe<Scalars['Int']>;
  /** An array of `ProductLinks` objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  product_offer_type?: Maybe<Scalars['Int']>;
  /** The average of all the ratings given to the product. */
  rating_summary: Scalars['Float'];
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int'];
  /** Related Products */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']>;
  /** The total count of all the reviews given to the product. */
  review_count: Scalars['Int'];
  /** The list of products reviews. */
  reviews: ProductReviews;
  /** @deprecated Use the `custom_attributes` field instead. */
  serving_order?: Maybe<Scalars['Int']>;
  /** Indicates whether to ship bundle items together or individually. */
  ship_bundle_items?: Maybe<ShipBundleItemsEnum>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  /**
   * The beginning date that a product has a special price.
   * @deprecated The field should not be used on the storefront.
   */
  special_from_date?: Maybe<Scalars['String']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']>;
  /** Time left for expiry of special price in seconds */
  special_price_time_left?: Maybe<Scalars['Int']>;
  /** The end date for a product with a special price. */
  special_to_date?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  speed?: Maybe<Scalars['String']>;
  /** List of product attributes */
  stockQtyTerm?: Maybe<Array<Maybe<ProductStockQty>>>;
  /** Stock status of the product */
  stock_status?: Maybe<ProductStockStatus>;
  /** The file name of a swatch image. */
  swatch_image?: Maybe<Scalars['String']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  type?: Maybe<Scalars['Int']>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use `__typename` instead.
   */
  type_id?: Maybe<Scalars['String']>;
  /** The unique ID for a `ProductInterface` object. */
  uid: Scalars['ID'];
  /**
   * Timestamp indicating when the product was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']>;
  /** Upsell Products */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
  /** The weight of the item, in units defined by the store. */
  weight?: Maybe<Scalars['Float']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  width?: Maybe<Scalars['Int']>;
};


/** Defines basic features of a bundle product and contains multiple BundleItems. */
export type BundleProductAttributesArgs = {
  groupCode?: InputMaybe<Scalars['String']>;
};


/** Defines basic features of a bundle product and contains multiple BundleItems. */
export type BundleProductBookable_ServiceArgs = {
  storeLocatorId?: InputMaybe<Scalars['Int']>;
};


/** Defines basic features of a bundle product and contains multiple BundleItems. */
export type BundleProductExpected_Shipping_FeesArgs = {
  sourceCode?: InputMaybe<Scalars['String']>;
};


/** Defines basic features of a bundle product and contains multiple BundleItems. */
export type BundleProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** Defines a single bundle product. */
export type BundleProductCartItemInput = {
  /** A mandatory array of options for the bundle product, including each chosen option and specified quantity. */
  bundle_options: Array<InputMaybe<BundleOptionInput>>;
  /** The ID and value of the option. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  /** The quantity and SKU of the bundle product. */
  data: CartItemInput;
};

/** Defines bundle product options for `ShipmentItemInterface`. */
export type BundleShipmentItem = ShipmentItemInterface & {
  __typename?: 'BundleShipmentItem';
  /** A list of bundle options that are assigned to a shipped product. */
  bundle_options?: Maybe<Array<Maybe<ItemSelectedBundleOption>>>;
  /** The unique ID for a `ShipmentItemInterface` object. */
  id: Scalars['ID'];
  /** The order item associated with the shipment item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price for the base product. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The number of shipped items. */
  quantity_shipped: Scalars['Float'];
};

/** Defines bundle product options for `WishlistItemInterface`. */
export type BundleWishlistItem = WishlistItemInterface & {
  __typename?: 'BundleWishlistItem';
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String'];
  /** An array containing information about the selected bundle items. */
  bundle_options?: Maybe<Array<Maybe<SelectedBundleOption>>>;
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars['String']>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID'];
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars['Float'];
};

export enum CancellationType {
  /** @deprecated  */
  Booking = 'BOOKING',
  /** @deprecated  */
  Order = 'ORDER',
  /** @deprecated  */
  Ride = 'RIDE',
  /** @deprecated  */
  Store = 'STORE',
  /** @deprecated  */
  VanRide = 'VAN_RIDE'
}

/** Contains the contents and other details about a guest or customer cart. */
export type Cart = {
  __typename?: 'Cart';
  acceptIframeUrl?: Maybe<Scalars['String']>;
  /** An array containing the customer's applicable evouchers. */
  applicableEvouchers?: Maybe<Array<Maybe<Evoucher>>>;
  /** An array containing the customer's applied evouchers. */
  appliedEvouchers?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** @deprecated Use `applied_coupons` instead. */
  applied_coupon?: Maybe<AppliedCoupon>;
  /** An array of `AppliedCoupon` objects. Each object contains the `code` text attribute, which specifies the coupon code. */
  applied_coupons?: Maybe<Array<Maybe<AppliedCoupon>>>;
  /** An array of available payment methods. */
  available_payment_methods?: Maybe<Array<Maybe<AvailablePaymentMethod>>>;
  /** The billing address assigned to the cart. */
  billing_address?: Maybe<BillingCartAddress>;
  delivery_details?: Maybe<DeliveryDetails>;
  /** The email address of the guest or customer. */
  email?: Maybe<Scalars['String']>;
  /** The entered gift message for the cart */
  gift_message?: Maybe<GiftMessage>;
  has_bookable_services: Scalars['Boolean'];
  has_in_store_only_services: Scalars['Boolean'];
  has_wiper?: Maybe<Scalars['Boolean']>;
  has_wipers_offer: Scalars['Boolean'];
  /** The unique ID for a `Cart` object. */
  id: Scalars['ID'];
  /** Indicates whether the cart contains only virtual products. */
  is_virtual: Scalars['Boolean'];
  /** An array of products that have been added to the cart. */
  items?: Maybe<Array<Maybe<CartItemInterface>>>;
  order_source?: Maybe<Scalars['String']>;
  paymentKey?: Maybe<Scalars['String']>;
  /** Pricing details for the quote. */
  prices?: Maybe<CartPrices>;
  /** Indicates which payment method was applied to the cart. */
  selected_payment_method?: Maybe<SelectedPaymentMethod>;
  /** An array of shipping addresses assigned to the cart. */
  shipping_addresses: Array<Maybe<ShippingCartAddress>>;
  /** The total number of items in the cart. */
  total_quantity: Scalars['Float'];
  vehicle?: Maybe<CustomerVehicle>;
};


/** Contains the contents and other details about a guest or customer cart. */
export type CartAcceptIframeUrlArgs = {
  phone_number?: InputMaybe<Scalars['String']>;
};

/** Contains details the country in a billing or shipping address. */
export type CartAddressCountry = {
  __typename?: 'CartAddressCountry';
  /** The country code. */
  code: Scalars['String'];
  /** The display label for the country. */
  label: Scalars['String'];
};

/** Defines the billing or shipping address to be applied to the cart. */
export type CartAddressInput = {
  /** The city specified for the billing or shipping address. */
  city: Scalars['String'];
  /** The company specified for the billing or shipping address. */
  company?: InputMaybe<Scalars['String']>;
  /** The country code and label for the billing or shipping address. */
  country_code: Scalars['String'];
  /** The first name of the customer or guest. */
  firstname: Scalars['String'];
  /** The last name of the customer or guest. */
  lastname: Scalars['String'];
  /** The ZIP or postal code of the billing or shipping address. */
  postcode?: InputMaybe<Scalars['String']>;
  /** A string that defines the state or province of the billing or shipping address. */
  region?: InputMaybe<Scalars['String']>;
  /** An integer that defines the state or province of the billing or shipping address. */
  region_id?: InputMaybe<Scalars['Int']>;
  /** Determines whether to save the address in the customer's address book. The default value is true. */
  save_in_address_book?: InputMaybe<Scalars['Boolean']>;
  /** An array containing the street for the billing or shipping address. */
  street: Array<InputMaybe<Scalars['String']>>;
  /** The telephone number for the billing or shipping address. */
  telephone?: InputMaybe<Scalars['String']>;
  /** The VAT company number for billing or shipping address. */
  vat_id?: InputMaybe<Scalars['String']>;
};

export type CartAddressInterface = {
  /** The city specified for the billing or shipping address. */
  city?: Maybe<City>;
  /** The company specified for the billing or shipping address. */
  company?: Maybe<Scalars['String']>;
  /** An object containing the country label and code. */
  country?: Maybe<Country>;
  /** The first name of the customer or guest. */
  firstname: Scalars['String'];
  /** The last name of the customer or guest. */
  lastname: Scalars['String'];
  /** The ZIP or postal code of the billing or shipping address. */
  postcode?: Maybe<Scalars['String']>;
  /** An object containing the region label and code. */
  region?: Maybe<Region>;
  /** An array containing the street for the billing or shipping address. */
  street: Array<Maybe<Scalars['String']>>;
  /** The telephone number for the billing or shipping address. */
  telephone?: Maybe<Scalars['String']>;
  /** The unique id of the customer address. */
  uid: Scalars['String'];
  /** The VAT company number for billing or shipping address. */
  vat_id?: Maybe<Scalars['String']>;
};

/** Contains details about the region in a billing or shipping address. */
export type CartAddressRegion = {
  __typename?: 'CartAddressRegion';
  /** The state or province code. */
  code?: Maybe<Scalars['String']>;
  /** The display label for the region. */
  label?: Maybe<Scalars['String']>;
  /** The unique ID for a pre-defined region. */
  region_id?: Maybe<Scalars['Int']>;
};

/** Contains information about discounts applied to the cart. */
export type CartDiscount = {
  __typename?: 'CartDiscount';
  /** The amount of the discount applied to the item. */
  amount: Money;
  /** The description of the discount. */
  label: Array<Maybe<Scalars['String']>>;
};

export type CartItemError = {
  __typename?: 'CartItemError';
  /** An error code that describes the error encountered */
  code: CartItemErrorType;
  /** A localized error message */
  message: Scalars['String'];
};

export enum CartItemErrorType {
  /** @deprecated  */
  ItemIncrements = 'ITEM_INCREMENTS',
  /** @deprecated  */
  ItemQty = 'ITEM_QTY',
  /** @deprecated  */
  Undefined = 'UNDEFINED'
}

/** Defines an item to be added to the cart. */
export type CartItemInput = {
  /** An array of entered options for the base product, such as personalization text. */
  entered_options?: InputMaybe<Array<InputMaybe<EnteredOptionInput>>>;
  /** For a child product, the SKU of its parent product. */
  parent_sku?: InputMaybe<Scalars['String']>;
  /** The amount or number of an item to add. */
  quantity: Scalars['Float'];
  /** The selected options for the base product, such as color or size, using the unique ID for an object such as `CustomizableRadioOption`, `CustomizableDropDownOption`, or `ConfigurableProductOptionsValues`. */
  selected_options?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** The SKU of the product. */
  sku: Scalars['String'];
};

/** An interface for products in a cart. */
export type CartItemInterface = {
  /** Information about the booking of this item */
  booked_service?: Maybe<BookedService>;
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>;
  /** @deprecated Use `uid` instead. */
  id: Scalars['String'];
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>;
  /** Details about an item in the cart. */
  product: ProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float'];
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID'];
};

/** Contains details about the price of the item, including taxes and discounts. */
export type CartItemPrices = {
  __typename?: 'CartItemPrices';
  /** An array of discounts to be applied to the cart item. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** An array of FPTs applied to the cart item. */
  fixed_product_taxes?: Maybe<Array<Maybe<FixedProductTax>>>;
  /** The price of the item before any discounts were applied. The price that might include tax, depending on the configured display settings for cart. */
  price: Money;
  /** The price of the item before any discounts were applied. The price that might include tax, depending on the configured display settings for cart. */
  price_including_tax: Money;
  /** The value of the price multiplied by the quantity of the item. */
  row_total: Money;
  /** The value of `row_total` plus the tax applied to the item. */
  row_total_including_tax: Money;
  /** The total of all discounts applied to the item. */
  total_item_discount?: Maybe<Money>;
};

/** Deprecated: The `ShippingCartAddress.cart_items` field now returns `CartItemInterface`. */
export type CartItemQuantity = {
  __typename?: 'CartItemQuantity';
  /** @deprecated The `ShippingCartAddress.cart_items` field now returns `CartItemInterface`. */
  cart_item_id: Scalars['Int'];
  /** @deprecated The `ShippingCartAddress.cart_items` field now returns `CartItemInterface`. */
  quantity: Scalars['Float'];
};

/** Contains details about the price of a selected customizable value. */
export type CartItemSelectedOptionValuePrice = {
  __typename?: 'CartItemSelectedOptionValuePrice';
  /** Indicates whether the price type is fixed, percent, or dynamic. */
  type: PriceTypeEnum;
  /** A string that describes the unit of the value. */
  units: Scalars['String'];
  /** A price value. */
  value: Scalars['Float'];
};

/** A single item to be updated. */
export type CartItemUpdateInput = {
  /** Deprecated. Use `cart_item_uid` instead. */
  cart_item_id?: InputMaybe<Scalars['Int']>;
  /** The unique ID for a `CartItemInterface` object. */
  cart_item_uid?: InputMaybe<Scalars['ID']>;
  /** An array that defines customizable options for the product. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  /** Gift message details for the cart item */
  gift_message?: InputMaybe<GiftMessageInput>;
  /** The new quantity of the item. */
  quantity?: InputMaybe<Scalars['Float']>;
};

/** Contains details about the final price of items in the cart, including discount and tax information. */
export type CartPrices = {
  __typename?: 'CartPrices';
  /** An array containing the names and amounts of taxes applied to each item in the cart. */
  applied_taxes?: Maybe<Array<Maybe<CartTaxItem>>>;
  /** @deprecated Use discounts instead. */
  discount?: Maybe<CartDiscount>;
  /** An array containing cart rule discounts, store credit and gift cards applied to the cart. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The total, including discounts, taxes, shipping, and other fees. */
  grand_total?: Maybe<Money>;
  /** The subtotal without any applied taxes. */
  subtotal_excluding_tax?: Maybe<Money>;
  /** The subtotal including any applied taxes. */
  subtotal_including_tax?: Maybe<Money>;
  /** The subtotal with any discounts applied, but not taxes. */
  subtotal_with_discount_excluding_tax?: Maybe<Money>;
};

/** Contains tax information about an item in the cart. */
export type CartTaxItem = {
  __typename?: 'CartTaxItem';
  /** The amount of tax applied to the item. */
  amount: Money;
  /** The description of the tax. */
  label: Scalars['String'];
};

/** An error encountered while adding an item to the the cart. */
export type CartUserInputError = {
  __typename?: 'CartUserInputError';
  /** A cart-specific error code. */
  code: CartUserInputErrorType;
  /** A localized error message. */
  message: Scalars['String'];
};

export enum CartUserInputErrorType {
  /** @deprecated  */
  InsufficientStock = 'INSUFFICIENT_STOCK',
  /** @deprecated  */
  NotSalable = 'NOT_SALABLE',
  /** @deprecated  */
  ProductNotFound = 'PRODUCT_NOT_FOUND',
  /** @deprecated  */
  Undefined = 'UNDEFINED'
}

/** Defines the filters to be used in the search. A filter contains at least one attribute, a comparison operator, and the value that is being searched for. */
export type CategoryFilterInput = {
  /** Filter by the unique category ID for a `CategoryInterface` object. */
  category_uid?: InputMaybe<FilterEqualTypeInput>;
  /** Deprecated: use 'category_uid' to filter uniquely identifiers of categories. */
  ids?: InputMaybe<FilterEqualTypeInput>;
  /** Filter by the display name of the category. */
  name?: InputMaybe<FilterMatchTypeInput>;
  /** Filter by the unique parent category ID for a `CategoryInterface` object. */
  parent_category_uid?: InputMaybe<FilterEqualTypeInput>;
  /** Filter by the unique parent category ID for a `CategoryInterface` object. */
  parent_id?: InputMaybe<FilterEqualTypeInput>;
  /** Filter by the part of the URL that identifies the category. */
  url_key?: InputMaybe<FilterEqualTypeInput>;
  /** Filter by the URL path for the category. */
  url_path?: InputMaybe<FilterEqualTypeInput>;
};

/** Contains the full set of attributes that can be returned in a category search. */
export type CategoryInterface = {
  available_sort_by?: Maybe<Array<Maybe<Scalars['String']>>>;
  brand_ids?: Maybe<Scalars['String']>;
  /** The Category Brands. */
  brands: Array<Maybe<Brand>>;
  /** An array of breadcrumb items. */
  breadcrumbs?: Maybe<Array<Maybe<Breadcrumb>>>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Categories' is enabled. */
  canonical_url?: Maybe<Scalars['String']>;
  children_count?: Maybe<Scalars['String']>;
  /** Contains a category CMS block. */
  cms_block?: Maybe<CmsBlock>;
  /**
   * The timestamp indicating when the category was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']>;
  custom_layout_update_file?: Maybe<Scalars['String']>;
  /** The attribute to use for sorting. */
  default_sort_by?: Maybe<Scalars['String']>;
  /** An optional description of the category. */
  description?: Maybe<Scalars['String']>;
  display_mode?: Maybe<Scalars['String']>;
  /** The category featured offers. */
  featured_offers: Array<Maybe<Offer>>;
  featured_order?: Maybe<Scalars['String']>;
  filter_price_range?: Maybe<Scalars['Float']>;
  /**
   * An ID that uniquely identifies the category.
   * @deprecated Use `uid` instead.
   */
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  include_in_menu?: Maybe<Scalars['Int']>;
  is_anchor?: Maybe<Scalars['Int']>;
  is_homepage_featured?: Maybe<Scalars['Int']>;
  is_van_installment_enabled: Scalars['Boolean'];
  landing_page?: Maybe<Scalars['Int']>;
  /** The depth of the category within the tree. */
  level?: Maybe<Scalars['Int']>;
  /** The category mega menu offer. */
  mega_menu_offer?: Maybe<Offer>;
  meta_description?: Maybe<Scalars['String']>;
  meta_keywords?: Maybe<Scalars['String']>;
  meta_title?: Maybe<Scalars['String']>;
  /** The display name of the category. */
  name?: Maybe<Scalars['String']>;
  /** The category page offer. */
  page_offer?: Maybe<Offer>;
  /** The full category path. */
  path?: Maybe<Scalars['String']>;
  /** The category path within the store. */
  path_in_store?: Maybe<Scalars['String']>;
  /** The position of the category relative to other categories at the same level in tree. */
  position?: Maybe<Scalars['Int']>;
  /** The number of products in the category that are marked as visible. By default, in complex products, parent products are visible, but their child products are not. */
  product_count?: Maybe<Scalars['Int']>;
  /** The list of products assigned to the category. */
  products?: Maybe<CategoryProducts>;
  sync_to_facebook_catalog?: Maybe<Scalars['Int']>;
  /** The unique ID for a `CategoryInterface` object. */
  uid: Scalars['ID'];
  /**
   * The timestamp indicating when the category was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']>;
  /** The URL key assigned to the category. */
  url_key?: Maybe<Scalars['String']>;
  /** The URL path assigned to the category. */
  url_path?: Maybe<Scalars['String']>;
  /** The part of the category URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']>;
  van_enabled?: Maybe<Scalars['Int']>;
};


/** Contains the full set of attributes that can be returned in a category search. */
export type CategoryInterfaceFeatured_OffersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


/** Contains the full set of attributes that can be returned in a category search. */
export type CategoryInterfaceProductsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ProductAttributeSortInput>;
};

/** Contains details about the products assigned to a category. */
export type CategoryProducts = {
  __typename?: 'CategoryProducts';
  /** An array of products that are assigned to the category. */
  items?: Maybe<Array<Maybe<ProductInterface>>>;
  /** Pagination metadata. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The number of products in the category that are marked as visible. By default, in complex products, parent products are visible, but their child products are not. */
  total_count?: Maybe<Scalars['Int']>;
};

/** Contains a collection of `CategoryTree` objects and pagination information. */
export type CategoryResult = {
  __typename?: 'CategoryResult';
  /** A list of categories that match the filter criteria. */
  items?: Maybe<Array<Maybe<CategoryTree>>>;
  /** An object that includes the `page_info` and `currentPage` values specified in the query. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The total number of categories that match the criteria. */
  total_count?: Maybe<Scalars['Int']>;
};

/** Contains the hierarchy of categories. */
export type CategoryTree = CategoryInterface & RoutableInterface & {
  __typename?: 'CategoryTree';
  available_sort_by?: Maybe<Array<Maybe<Scalars['String']>>>;
  brand_ids?: Maybe<Scalars['String']>;
  /** The Category Brands. */
  brands: Array<Maybe<Brand>>;
  /** An array of breadcrumb items. */
  breadcrumbs?: Maybe<Array<Maybe<Breadcrumb>>>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Categories' is enabled. */
  canonical_url?: Maybe<Scalars['String']>;
  /** A tree of child categories. */
  children?: Maybe<Array<Maybe<CategoryTree>>>;
  children_count?: Maybe<Scalars['String']>;
  /** Contains a category CMS block. */
  cms_block?: Maybe<CmsBlock>;
  /**
   * The timestamp indicating when the category was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']>;
  custom_layout_update_file?: Maybe<Scalars['String']>;
  /** The attribute to use for sorting. */
  default_sort_by?: Maybe<Scalars['String']>;
  /** An optional description of the category. */
  description?: Maybe<Scalars['String']>;
  display_mode?: Maybe<Scalars['String']>;
  /** The category featured offers. */
  featured_offers: Array<Maybe<Offer>>;
  featured_order?: Maybe<Scalars['String']>;
  filter_price_range?: Maybe<Scalars['Float']>;
  /**
   * An ID that uniquely identifies the category.
   * @deprecated Use `uid` instead.
   */
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  include_in_menu?: Maybe<Scalars['Int']>;
  is_anchor?: Maybe<Scalars['Int']>;
  is_homepage_featured?: Maybe<Scalars['Int']>;
  is_van_installment_enabled: Scalars['Boolean'];
  landing_page?: Maybe<Scalars['Int']>;
  /** The depth of the category within the tree. */
  level?: Maybe<Scalars['Int']>;
  /** The category mega menu offer. */
  mega_menu_offer?: Maybe<Offer>;
  meta_description?: Maybe<Scalars['String']>;
  meta_keywords?: Maybe<Scalars['String']>;
  meta_title?: Maybe<Scalars['String']>;
  /** The display name of the category. */
  name?: Maybe<Scalars['String']>;
  /** The category page offer. */
  page_offer?: Maybe<Offer>;
  /** The full category path. */
  path?: Maybe<Scalars['String']>;
  /** The category path within the store. */
  path_in_store?: Maybe<Scalars['String']>;
  /** The position of the category relative to other categories at the same level in tree. */
  position?: Maybe<Scalars['Int']>;
  /** The number of products in the category that are marked as visible. By default, in complex products, parent products are visible, but their child products are not. */
  product_count?: Maybe<Scalars['Int']>;
  /** The list of products assigned to the category. */
  products?: Maybe<CategoryProducts>;
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int'];
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']>;
  sync_to_facebook_catalog?: Maybe<Scalars['Int']>;
  /** The unique ID for a `CategoryInterface` object. */
  uid: Scalars['ID'];
  /**
   * The timestamp indicating when the category was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']>;
  /** The URL key assigned to the category. */
  url_key?: Maybe<Scalars['String']>;
  /** The URL path assigned to the category. */
  url_path?: Maybe<Scalars['String']>;
  /** The part of the category URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']>;
  van_enabled?: Maybe<Scalars['Int']>;
};


/** Contains the hierarchy of categories. */
export type CategoryTreeFeatured_OffersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


/** Contains the hierarchy of categories. */
export type CategoryTreeProductsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ProductAttributeSortInput>;
};

/** Defines details about an individual checkout agreement. */
export type CheckoutAgreement = {
  __typename?: 'CheckoutAgreement';
  /** The ID for a checkout agreement. */
  agreement_id: Scalars['Int'];
  /** The checkbox text for the checkout agreement. */
  checkbox_text: Scalars['String'];
  /** Required. The text of the agreement. */
  content: Scalars['String'];
  /** The height of the text box where the Terms and Conditions statement appears during checkout. */
  content_height?: Maybe<Scalars['String']>;
  /** Indicates whether the `content` text is in HTML format. */
  is_html: Scalars['Boolean'];
  /** Indicates whether agreements are accepted automatically or manually. */
  mode: CheckoutAgreementMode;
  /** The name given to the condition. */
  name: Scalars['String'];
};

/** Indicates how agreements are accepted. */
export enum CheckoutAgreementMode {
  /**
   * Conditions are automatically accepted upon checkout.
   * @deprecated
   */
  Auto = 'AUTO',
  /**
   * Shoppers must manually accept the conditions to place an order.
   * @deprecated
   */
  Manual = 'MANUAL'
}

export type CheckoutJumpStartAddonsInput = {
  methodCode: Scalars['String'];
  orderNumber: Scalars['String'];
};

/** An error encountered while adding an item to the cart. */
export type CheckoutUserInputError = {
  __typename?: 'CheckoutUserInputError';
  /** An error code that is specific to Checkout. */
  code: CheckoutUserInputErrorCodes;
  /** A localized error message. */
  message: Scalars['String'];
  /** The path to the input field that caused an error. See the GraphQL specification about path errors for details: http://spec.graphql.org/draft/#sec-Errors */
  path: Array<Maybe<Scalars['String']>>;
};

export enum CheckoutUserInputErrorCodes {
  /** @deprecated  */
  InsufficientStock = 'INSUFFICIENT_STOCK',
  /** @deprecated  */
  NotSalable = 'NOT_SALABLE',
  /** @deprecated  */
  ProductNotFound = 'PRODUCT_NOT_FOUND',
  /** @deprecated  */
  ReorderNotAvailable = 'REORDER_NOT_AVAILABLE',
  /** @deprecated  */
  Undefined = 'UNDEFINED'
}

export type CitiesInfo = {
  __typename?: 'CitiesInfo';
  city?: Maybe<City>;
  region?: Maybe<Region>;
};

export type City = {
  __typename?: 'City';
  available_store?: Maybe<StoreLocator>;
  available_store_id?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  is_active?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  region?: Maybe<Region>;
};

export type CloseStoreLocatorInput = {
  /** The start time of this period formatted as `YYYY-MM-DD HH:MM`. */
  from: Scalars['String'];
  /** The reason why the store will be closed at this time. */
  reason?: InputMaybe<Scalars['String']>;
  /** The unique Id of the store locator. */
  store_locator_id: Scalars['Int'];
  /** The end time of this period formatted as `YYYY-MM-DD HH:MM`. */
  to: Scalars['String'];
};

export type CloseStoreLocatorOutput = {
  __typename?: 'CloseStoreLocatorOutput';
  store_locator: StoreLocator;
};

export type ClosedPeriod = {
  __typename?: 'ClosedPeriod';
  /** The start time of this period formatted as `YYYY-MM-DD HH:MM`. */
  from: Scalars['String'];
  /** If this period is a buffer period for van bookings. */
  is_buffer: Scalars['Boolean'];
  /** The reason why the store is closed at this time. */
  reason?: Maybe<Scalars['String']>;
  /** The end time of this booking formatted as `YYYY-MM-DD HH:MM`. */
  to: Scalars['String'];
  /** The unique ID for the closed time */
  uid: Scalars['ID'];
};

/** Contains details about a specific CMS block. */
export type CmsBlock = {
  __typename?: 'CmsBlock';
  /** The content of the CMS block in raw HTML. */
  content?: Maybe<Scalars['String']>;
  /** The CMS block identifier. */
  identifier?: Maybe<Scalars['String']>;
  /** The title assigned to the CMS block. */
  title?: Maybe<Scalars['String']>;
};

/** Contains an array CMS block items. */
export type CmsBlocks = {
  __typename?: 'CmsBlocks';
  /** An array of CMS blocks. */
  items?: Maybe<Array<Maybe<CmsBlock>>>;
};

/** Contains details about a CMS page. */
export type CmsPage = RoutableInterface & {
  __typename?: 'CmsPage';
  /** The content of the CMS page in raw HTML. */
  content?: Maybe<Scalars['String']>;
  /** The heading that displays at the top of the CMS page. */
  content_heading?: Maybe<Scalars['String']>;
  /** The ID of a CMS page. */
  identifier?: Maybe<Scalars['String']>;
  /** A brief description of the page for search results listings. */
  meta_description?: Maybe<Scalars['String']>;
  /** A brief description of the page for search results listings. */
  meta_keywords?: Maybe<Scalars['String']>;
  /** A page title that is indexed by search engines and appears in search results listings. */
  meta_title?: Maybe<Scalars['String']>;
  /** The design layout of the page, indicating the number of columns and navigation features used on the page. */
  page_layout?: Maybe<Scalars['String']>;
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int'];
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']>;
  /** The name that appears in the breadcrumb trail navigation and in the browser title bar and tab. */
  title?: Maybe<Scalars['String']>;
  /** The URL key of the CMS page, which is often based on the `content_heading`. */
  url_key?: Maybe<Scalars['String']>;
};

export type Color = {
  __typename?: 'Color';
  code: Scalars['String'];
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type ColorSwatchData = SwatchDataInterface & {
  __typename?: 'ColorSwatchData';
  /** The value can be represented as color (HEX code), image link, or text. */
  value?: Maybe<Scalars['String']>;
};

/** Contains an attribute code that is used for product comparisons. */
export type ComparableAttribute = {
  __typename?: 'ComparableAttribute';
  /** An attribute code that is enabled for product comparisons. */
  code: Scalars['String'];
  /** The label of the attribute code. */
  label: Scalars['String'];
};

/** Defines an object used to iterate through items for product comparisons. */
export type ComparableItem = {
  __typename?: 'ComparableItem';
  /** An array of product attributes that can be used to compare products. */
  attributes: Array<Maybe<ProductAttribute>>;
  /** Details about a product in a compare list. */
  product: ProductInterface;
  /** The unique ID of an item in a compare list. */
  uid: Scalars['ID'];
};

/** Contains iterable information such as the array of items, the count, and attributes that represent the compare list. */
export type CompareList = {
  __typename?: 'CompareList';
  /** An array of attributes that can be used for comparing products. */
  attributes?: Maybe<Array<Maybe<ComparableAttribute>>>;
  /** The number of items in the compare list. */
  item_count: Scalars['Int'];
  /** An array of products to compare. */
  items?: Maybe<Array<Maybe<ComparableItem>>>;
  /** The unique ID assigned to the compare list. */
  uid: Scalars['ID'];
};

export type ComplexTextValue = {
  __typename?: 'ComplexTextValue';
  /** Text that can contain HTML tags. */
  html: Scalars['String'];
};

/** Contains details about a configurable product attribute option. */
export type ConfigurableAttributeOption = {
  __typename?: 'ConfigurableAttributeOption';
  /** The ID assigned to the attribute. */
  code?: Maybe<Scalars['String']>;
  /** A string that describes the configurable attribute option. */
  label?: Maybe<Scalars['String']>;
  /** The unique ID for a `ConfigurableAttributeOption` object. */
  uid: Scalars['ID'];
  /** A unique index number assigned to the configurable product option. */
  value_index?: Maybe<Scalars['Int']>;
};

/** An implementation for configurable product cart items. */
export type ConfigurableCartItem = CartItemInterface & {
  __typename?: 'ConfigurableCartItem';
  /** Information about the booking of this item */
  booked_service?: Maybe<BookedService>;
  /** An array containing the configuranle options the shopper selected. */
  configurable_options: Array<Maybe<SelectedConfigurableOption>>;
  /** Product details of the cart item. */
  configured_variant: ProductInterface;
  /** An array containing the customizable options the shopper selected. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>;
  /** The entered gift message for the cart item */
  gift_message?: Maybe<GiftMessage>;
  /** @deprecated Use `uid` instead. */
  id: Scalars['String'];
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>;
  /** Details about an item in the cart. */
  product: ProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float'];
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID'];
};

/** Describes configurable options that have been selected and can be selected as a result of the previous selections. */
export type ConfigurableOptionAvailableForSelection = {
  __typename?: 'ConfigurableOptionAvailableForSelection';
  /** An attribute code that uniquely identifies a configurable option. */
  attribute_code: Scalars['String'];
  /** An array of selectable option value IDs. */
  option_value_uids: Array<Maybe<Scalars['ID']>>;
};

/** Defines basic features of a configurable product and its simple product variants. */
export type ConfigurableProduct = CustomizableProductInterface & PhysicalProductInterface & ProductInterface & RoutableInterface & {
  __typename?: 'ConfigurableProduct';
  /** @deprecated Use the `custom_attributes` field instead. */
  ampere?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  aspect_ratio?: Maybe<Scalars['Int']>;
  /** Attribute set information */
  attribute_set?: Maybe<AttributeSetInformation>;
  /**
   * The attribute set assigned to the product.
   * @deprecated The field should not be used on the storefront.
   */
  attribute_set_id?: Maybe<Scalars['Int']>;
  /** List of product attributes */
  attributes?: Maybe<Array<Maybe<CustomAttribute>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  average_duration?: Maybe<Scalars['String']>;
  /** Attributes regarding this bookable service in the given store locator. */
  bookable_service?: Maybe<BookableService>;
  /** The product brand. */
  brand?: Maybe<Brand>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
  canonical_url?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  car_batteries_ampere?: Maybe<Scalars['Int']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  color?: Maybe<Scalars['Int']>;
  /** An array of options for the configurable product. */
  configurable_options?: Maybe<Array<Maybe<ConfigurableProductOptions>>>;
  /** An array of media gallery items and other details about selected configurable product options as well as details about remaining selectable options. */
  configurable_product_options_selection?: Maybe<ConfigurableProductOptionsSelection>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  country_of_origin?: Maybe<Scalars['Int']>;
  /**
   * Timestamp indicating when the product was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  creation_date?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  creation_id?: Maybe<Scalars['Int']>;
  /** Crosssell Products */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /**
   * List of product custom labels
   * @deprecated Use the `custom_attributes` field instead.
   */
  custom_labels: Array<Maybe<Label>>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  /** @deprecated Use the `custom_attributes` field instead. */
  diameter?: Maybe<Scalars['Int']>;
  expected_shipping_fees?: Maybe<Scalars['Float']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  exterior_hand_wash?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_age_group?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_age_range?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_baby_food_stage?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_brand?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_capacity?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_color?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_compatible_devices?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_decor_style?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_digital_zoom?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_display_technology?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_finish?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_gemstone?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_gender?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_health_concern?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_ingredients?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_is_assembly_required?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_material?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_maximum_weight?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_megapixels?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_minimum_weight?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_model?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_number_of_licenses?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_operating_system?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_optical_zoom?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_package_quantity?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_pattern?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_depth?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_form?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_height?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_length?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_weight?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_width?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_recommended_use?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_resolution?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_scent?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_screen_size?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_shoe_width?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_size?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_storage_capacity?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_style?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_system_requirements?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_thread_count?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_video_game_platform?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  featured_order?: Maybe<Scalars['Int']>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  has_deal?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  hover_cleaning?: Maybe<Scalars['Int']>;
  /**
   * The ID number assigned to the product.
   * @deprecated Use the `uid` field instead.
   */
  id?: Maybe<Scalars['Int']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** @deprecated Use the `custom_attributes` field instead. */
  in_store_only?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  interior_cleaning?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  interior_vacuum_clean?: Maybe<Scalars['Int']>;
  /** Check if product is a best seller */
  is_best_seller?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  is_bookable_service?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  is_bookable_service_addon?: Maybe<Scalars['Int']>;
  /** if the product favorited by the logged in user */
  is_favorited?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  is_featured?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  is_featured_offer?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  is_november_deal?: Maybe<Scalars['Int']>;
  is_van_installment_enabled: Scalars['Boolean'];
  /** Indicates whether the product is the wiper that has the gift or not. */
  is_wiper: Scalars['Boolean'];
  /** product labels */
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * A number representing the product's manufacturer.
   * @deprecated Use the `custom_attributes` field instead.
   */
  manufacturer?: Maybe<Scalars['Int']>;
  /** An array of media gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use `media_gallery` instead.
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  mileage_warranty?: Maybe<Scalars['String']>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']>;
  /** Quantity of product left in customer's choosen source */
  only_x_left_in_source?: Maybe<Scalars['Float']>;
  /** Product stock only x left count */
  only_x_left_in_stock?: Maybe<Scalars['Float']>;
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  pattern?: Maybe<Scalars['String']>;
  /**
   * Indicates the price of an item.
   * @deprecated Use `price_range` for product price information.
   */
  price?: Maybe<ProductPrices>;
  /** The range of prices for the product */
  price_range: PriceRange;
  /** An array of `TierPrice` objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_brand_id?: Maybe<Scalars['Int']>;
  /** An array of `ProductLinks` objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  product_offer_type?: Maybe<Scalars['Int']>;
  /** The average of all the ratings given to the product. */
  rating_summary: Scalars['Float'];
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int'];
  /** Related Products */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']>;
  /** The total count of all the reviews given to the product. */
  review_count: Scalars['Int'];
  /** The list of products reviews. */
  reviews: ProductReviews;
  /** @deprecated Use the `custom_attributes` field instead. */
  serving_order?: Maybe<Scalars['Int']>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  /**
   * The beginning date that a product has a special price.
   * @deprecated The field should not be used on the storefront.
   */
  special_from_date?: Maybe<Scalars['String']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']>;
  /** Time left for expiry of special price in seconds */
  special_price_time_left?: Maybe<Scalars['Int']>;
  /** The end date for a product with a special price. */
  special_to_date?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  speed?: Maybe<Scalars['String']>;
  /** List of product attributes */
  stockQtyTerm?: Maybe<Array<Maybe<ProductStockQty>>>;
  /** Stock status of the product */
  stock_status?: Maybe<ProductStockStatus>;
  /** The file name of a swatch image. */
  swatch_image?: Maybe<Scalars['String']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  type?: Maybe<Scalars['Int']>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use `__typename` instead.
   */
  type_id?: Maybe<Scalars['String']>;
  /** The unique ID for a `ProductInterface` object. */
  uid: Scalars['ID'];
  /**
   * Timestamp indicating when the product was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']>;
  /** Upsell Products */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']>;
  /** An array of simple product variants. */
  variants?: Maybe<Array<Maybe<ConfigurableVariant>>>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
  /** The weight of the item, in units defined by the store. */
  weight?: Maybe<Scalars['Float']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  width?: Maybe<Scalars['Int']>;
};


/** Defines basic features of a configurable product and its simple product variants. */
export type ConfigurableProductAttributesArgs = {
  groupCode?: InputMaybe<Scalars['String']>;
};


/** Defines basic features of a configurable product and its simple product variants. */
export type ConfigurableProductBookable_ServiceArgs = {
  storeLocatorId?: InputMaybe<Scalars['Int']>;
};


/** Defines basic features of a configurable product and its simple product variants. */
export type ConfigurableProductConfigurable_Product_Options_SelectionArgs = {
  configurableOptionValueUids?: InputMaybe<Array<Scalars['ID']>>;
};


/** Defines basic features of a configurable product and its simple product variants. */
export type ConfigurableProductExpected_Shipping_FeesArgs = {
  sourceCode?: InputMaybe<Scalars['String']>;
};


/** Defines basic features of a configurable product and its simple product variants. */
export type ConfigurableProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type ConfigurableProductCartItemInput = {
  /** The ID and value of the option. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  /** The quantity and SKU of the configurable product. */
  data: CartItemInput;
  /** The SKU of the parent configurable product. */
  parent_sku?: InputMaybe<Scalars['String']>;
  /** Deprecated. Use `CartItemInput.sku` instead. */
  variant_sku?: InputMaybe<Scalars['String']>;
};

/** Contains details about configurable product options. */
export type ConfigurableProductOption = {
  __typename?: 'ConfigurableProductOption';
  /** An attribute code that uniquely identifies a configurable option. */
  attribute_code: Scalars['String'];
  /** The display name of the option. */
  label: Scalars['String'];
  /** The unique ID of the configurable option. */
  uid: Scalars['ID'];
  /** An array of values that are applicable for this option. */
  values?: Maybe<Array<Maybe<ConfigurableProductOptionValue>>>;
};

/** Defines a value for a configurable product option. */
export type ConfigurableProductOptionValue = {
  __typename?: 'ConfigurableProductOptionValue';
  /** Indicates whether the product is available with this selected option. */
  is_available: Scalars['Boolean'];
  /** Indicates whether the value is the default. */
  is_use_default: Scalars['Boolean'];
  /** The display name of the value. */
  label: Scalars['String'];
  /** The URL assigned to the thumbnail of the swatch image. */
  swatch?: Maybe<SwatchDataInterface>;
  /** The unique ID of the value. */
  uid: Scalars['ID'];
};

/** Defines configurable attributes for the specified product. */
export type ConfigurableProductOptions = {
  __typename?: 'ConfigurableProductOptions';
  /** A string that identifies the attribute. */
  attribute_code?: Maybe<Scalars['String']>;
  /**
   * The ID assigned to the attribute.
   * @deprecated Use `attribute_uid` instead.
   */
  attribute_id?: Maybe<Scalars['String']>;
  /**
   * The ID assigned to the attribute.
   * @deprecated Use `attribute_uid` instead.
   */
  attribute_id_v2?: Maybe<Scalars['Int']>;
  /** The unique ID for an `Attribute` object. */
  attribute_uid: Scalars['ID'];
  /**
   * The configurable option ID number assigned by the system.
   * @deprecated Use `uid` instead.
   */
  id?: Maybe<Scalars['Int']>;
  /** A displayed string that describes the configurable product option. */
  label?: Maybe<Scalars['String']>;
  /** A number that indicates the order in which the attribute is displayed. */
  position?: Maybe<Scalars['Int']>;
  /**
   * This is the same as a product's `id` field.
   * @deprecated `product_id` is not needed and can be obtained from its parent.
   */
  product_id?: Maybe<Scalars['Int']>;
  /** The unique ID for a `ConfigurableProductOptions` object. */
  uid: Scalars['ID'];
  /** Indicates whether the option is the default. */
  use_default?: Maybe<Scalars['Boolean']>;
  /** An array that defines the `value_index` codes assigned to the configurable product. */
  values?: Maybe<Array<Maybe<ConfigurableProductOptionsValues>>>;
};

/** Contains metadata corresponding to the selected configurable options. */
export type ConfigurableProductOptionsSelection = {
  __typename?: 'ConfigurableProductOptionsSelection';
  /** An array of all possible configurable options. */
  configurable_options?: Maybe<Array<Maybe<ConfigurableProductOption>>>;
  /** Product images and videos corresponding to the specified configurable options selection. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /** The configurable options available for further selection based on the current selection. */
  options_available_for_selection?: Maybe<Array<Maybe<ConfigurableOptionAvailableForSelection>>>;
  /** A variant represented by the specified configurable options selection. The value is expected to be null until selections are made for each configurable option. */
  variant?: Maybe<SimpleProduct>;
};

/** Contains the index number assigned to a configurable product option. */
export type ConfigurableProductOptionsValues = {
  __typename?: 'ConfigurableProductOptionsValues';
  /** The label of the product on the default store. */
  default_label?: Maybe<Scalars['String']>;
  /** The label of the product. */
  label?: Maybe<Scalars['String']>;
  /** The label of the product on the current store. */
  store_label?: Maybe<Scalars['String']>;
  /** Swatch data for a configurable product option. */
  swatch_data?: Maybe<SwatchDataInterface>;
  /** The unique ID for a `ConfigurableProductOptionsValues` object. */
  uid?: Maybe<Scalars['ID']>;
  /** Indicates whether to use the default_label. */
  use_default_value?: Maybe<Scalars['Boolean']>;
  /**
   * A unique index number assigned to the configurable product option.
   * @deprecated Use `uid` instead.
   */
  value_index?: Maybe<Scalars['Int']>;
};

/** Contains all the simple product variants of a configurable product. */
export type ConfigurableVariant = {
  __typename?: 'ConfigurableVariant';
  /** An array of configurable attribute options. */
  attributes?: Maybe<Array<Maybe<ConfigurableAttributeOption>>>;
  /** An array of linked simple products. */
  product?: Maybe<SimpleProduct>;
};

/** A configurable product wish list item. */
export type ConfigurableWishlistItem = WishlistItemInterface & {
  __typename?: 'ConfigurableWishlistItem';
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String'];
  /**
   * The SKU of the simple product corresponding to a set of selected configurable options.
   * @deprecated Use `ConfigurableWishlistItem.configured_variant.sku` instead.
   */
  child_sku: Scalars['String'];
  /** An array of selected configurable options. */
  configurable_options?: Maybe<Array<Maybe<SelectedConfigurableOption>>>;
  /** Product details of the selected variant. The value is null if some options are not configured. */
  configured_variant?: Maybe<ProductInterface>;
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars['String']>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID'];
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars['Float'];
};

export type ContactFormInput = {
  attachment?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  email: Scalars['String'];
  name: Scalars['String'];
  phone_number: Scalars['String'];
  preferred_contact_method?: InputMaybe<Scalars['String']>;
  reason_of_contact: Scalars['String'];
};

export type ContactFormSubject = {
  __typename?: 'ContactFormSubject';
  id?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

export type Coordinates = {
  __typename?: 'Coordinates';
  address?: Maybe<Scalars['String']>;
  landmark?: Maybe<Scalars['String']>;
  lat: Scalars['Float'];
  long: Scalars['Float'];
  map_url?: Maybe<Scalars['String']>;
  sublocality?: Maybe<Scalars['String']>;
};

export type Country = {
  __typename?: 'Country';
  /** An array of regions within a particular country. */
  available_regions?: Maybe<Array<Maybe<Region>>>;
  /** The name of the country in English. */
  full_name_english?: Maybe<Scalars['String']>;
  /** The name of the country in the current locale. */
  full_name_locale?: Maybe<Scalars['String']>;
  /** The unique ID for a `Country` object. */
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** The three-letter abbreviation of the country, such as USA. */
  three_letter_abbreviation?: Maybe<Scalars['String']>;
  /** The two-letter abbreviation of the country, such as US. */
  two_letter_abbreviation?: Maybe<Scalars['String']>;
};


export type CountryAvailable_RegionsArgs = {
  filter?: InputMaybe<AddressFilterInput>;
};

/** The list of country codes. */
export enum CountryCodeEnum {
  /**
   * Andorra
   * @deprecated
   */
  Ad = 'AD',
  /**
   * United Arab Emirates
   * @deprecated
   */
  Ae = 'AE',
  /**
   * Afghanistan
   * @deprecated
   */
  Af = 'AF',
  /**
   * Antigua & Barbuda
   * @deprecated
   */
  Ag = 'AG',
  /**
   * Anguilla
   * @deprecated
   */
  Ai = 'AI',
  /**
   * Albania
   * @deprecated
   */
  Al = 'AL',
  /**
   * Armenia
   * @deprecated
   */
  Am = 'AM',
  /**
   * Netherlands Antilles
   * @deprecated
   */
  An = 'AN',
  /**
   * Angola
   * @deprecated
   */
  Ao = 'AO',
  /**
   * Antarctica
   * @deprecated
   */
  Aq = 'AQ',
  /**
   * Argentina
   * @deprecated
   */
  Ar = 'AR',
  /**
   * American Samoa
   * @deprecated
   */
  As = 'AS',
  /**
   * Austria
   * @deprecated
   */
  At = 'AT',
  /**
   * Australia
   * @deprecated
   */
  Au = 'AU',
  /**
   * Aruba
   * @deprecated
   */
  Aw = 'AW',
  /**
   * Åland Islands
   * @deprecated
   */
  Ax = 'AX',
  /**
   * Azerbaijan
   * @deprecated
   */
  Az = 'AZ',
  /**
   * Bosnia & Herzegovina
   * @deprecated
   */
  Ba = 'BA',
  /**
   * Barbados
   * @deprecated
   */
  Bb = 'BB',
  /**
   * Bangladesh
   * @deprecated
   */
  Bd = 'BD',
  /**
   * Belgium
   * @deprecated
   */
  Be = 'BE',
  /**
   * Burkina Faso
   * @deprecated
   */
  Bf = 'BF',
  /**
   * Bulgaria
   * @deprecated
   */
  Bg = 'BG',
  /**
   * Bahrain
   * @deprecated
   */
  Bh = 'BH',
  /**
   * Burundi
   * @deprecated
   */
  Bi = 'BI',
  /**
   * Benin
   * @deprecated
   */
  Bj = 'BJ',
  /**
   * St. Barthélemy
   * @deprecated
   */
  Bl = 'BL',
  /**
   * Bermuda
   * @deprecated
   */
  Bm = 'BM',
  /**
   * Brunei
   * @deprecated
   */
  Bn = 'BN',
  /**
   * Bolivia
   * @deprecated
   */
  Bo = 'BO',
  /**
   * Brazil
   * @deprecated
   */
  Br = 'BR',
  /**
   * Bahamas
   * @deprecated
   */
  Bs = 'BS',
  /**
   * Bhutan
   * @deprecated
   */
  Bt = 'BT',
  /**
   * Bouvet Island
   * @deprecated
   */
  Bv = 'BV',
  /**
   * Botswana
   * @deprecated
   */
  Bw = 'BW',
  /**
   * Belarus
   * @deprecated
   */
  By = 'BY',
  /**
   * Belize
   * @deprecated
   */
  Bz = 'BZ',
  /**
   * Canada
   * @deprecated
   */
  Ca = 'CA',
  /**
   * Cocos (Keeling) Islands
   * @deprecated
   */
  Cc = 'CC',
  /**
   * Congo-Kinshasa
   * @deprecated
   */
  Cd = 'CD',
  /**
   * Central African Republic
   * @deprecated
   */
  Cf = 'CF',
  /**
   * Congo-Brazzaville
   * @deprecated
   */
  Cg = 'CG',
  /**
   * Switzerland
   * @deprecated
   */
  Ch = 'CH',
  /**
   * Côte d’Ivoire
   * @deprecated
   */
  Ci = 'CI',
  /**
   * Cook Islands
   * @deprecated
   */
  Ck = 'CK',
  /**
   * Chile
   * @deprecated
   */
  Cl = 'CL',
  /**
   * Cameroon
   * @deprecated
   */
  Cm = 'CM',
  /**
   * China
   * @deprecated
   */
  Cn = 'CN',
  /**
   * Colombia
   * @deprecated
   */
  Co = 'CO',
  /**
   * Costa Rica
   * @deprecated
   */
  Cr = 'CR',
  /**
   * Cuba
   * @deprecated
   */
  Cu = 'CU',
  /**
   * Cape Verde
   * @deprecated
   */
  Cv = 'CV',
  /**
   * Christmas Island
   * @deprecated
   */
  Cx = 'CX',
  /**
   * Cyprus
   * @deprecated
   */
  Cy = 'CY',
  /**
   * Czech Republic
   * @deprecated
   */
  Cz = 'CZ',
  /**
   * Germany
   * @deprecated
   */
  De = 'DE',
  /**
   * Djibouti
   * @deprecated
   */
  Dj = 'DJ',
  /**
   * Denmark
   * @deprecated
   */
  Dk = 'DK',
  /**
   * Dominica
   * @deprecated
   */
  Dm = 'DM',
  /**
   * Dominican Republic
   * @deprecated
   */
  Do = 'DO',
  /**
   * Algeria
   * @deprecated
   */
  Dz = 'DZ',
  /**
   * Ecuador
   * @deprecated
   */
  Ec = 'EC',
  /**
   * Estonia
   * @deprecated
   */
  Ee = 'EE',
  /**
   * Egypt
   * @deprecated
   */
  Eg = 'EG',
  /**
   * Western Sahara
   * @deprecated
   */
  Eh = 'EH',
  /**
   * Eritrea
   * @deprecated
   */
  Er = 'ER',
  /**
   * Spain
   * @deprecated
   */
  Es = 'ES',
  /**
   * Ethiopia
   * @deprecated
   */
  Et = 'ET',
  /**
   * Finland
   * @deprecated
   */
  Fi = 'FI',
  /**
   * Fiji
   * @deprecated
   */
  Fj = 'FJ',
  /**
   * Falkland Islands
   * @deprecated
   */
  Fk = 'FK',
  /**
   * Micronesia
   * @deprecated
   */
  Fm = 'FM',
  /**
   * Faroe Islands
   * @deprecated
   */
  Fo = 'FO',
  /**
   * France
   * @deprecated
   */
  Fr = 'FR',
  /**
   * Gabon
   * @deprecated
   */
  Ga = 'GA',
  /**
   * United Kingdom
   * @deprecated
   */
  Gb = 'GB',
  /**
   * Grenada
   * @deprecated
   */
  Gd = 'GD',
  /**
   * Georgia
   * @deprecated
   */
  Ge = 'GE',
  /**
   * French Guiana
   * @deprecated
   */
  Gf = 'GF',
  /**
   * Guernsey
   * @deprecated
   */
  Gg = 'GG',
  /**
   * Ghana
   * @deprecated
   */
  Gh = 'GH',
  /**
   * Gibraltar
   * @deprecated
   */
  Gi = 'GI',
  /**
   * Greenland
   * @deprecated
   */
  Gl = 'GL',
  /**
   * Gambia
   * @deprecated
   */
  Gm = 'GM',
  /**
   * Guinea
   * @deprecated
   */
  Gn = 'GN',
  /**
   * Guadeloupe
   * @deprecated
   */
  Gp = 'GP',
  /**
   * Equatorial Guinea
   * @deprecated
   */
  Gq = 'GQ',
  /**
   * Greece
   * @deprecated
   */
  Gr = 'GR',
  /**
   * South Georgia & South Sandwich Islands
   * @deprecated
   */
  Gs = 'GS',
  /**
   * Guatemala
   * @deprecated
   */
  Gt = 'GT',
  /**
   * Guam
   * @deprecated
   */
  Gu = 'GU',
  /**
   * Guinea-Bissau
   * @deprecated
   */
  Gw = 'GW',
  /**
   * Guyana
   * @deprecated
   */
  Gy = 'GY',
  /**
   * Hong Kong SAR China
   * @deprecated
   */
  Hk = 'HK',
  /**
   * Heard &amp; McDonald Islands
   * @deprecated
   */
  Hm = 'HM',
  /**
   * Honduras
   * @deprecated
   */
  Hn = 'HN',
  /**
   * Croatia
   * @deprecated
   */
  Hr = 'HR',
  /**
   * Haiti
   * @deprecated
   */
  Ht = 'HT',
  /**
   * Hungary
   * @deprecated
   */
  Hu = 'HU',
  /**
   * Indonesia
   * @deprecated
   */
  Id = 'ID',
  /**
   * Ireland
   * @deprecated
   */
  Ie = 'IE',
  /**
   * Israel
   * @deprecated
   */
  Il = 'IL',
  /**
   * Isle of Man
   * @deprecated
   */
  Im = 'IM',
  /**
   * India
   * @deprecated
   */
  In = 'IN',
  /**
   * British Indian Ocean Territory
   * @deprecated
   */
  Io = 'IO',
  /**
   * Iraq
   * @deprecated
   */
  Iq = 'IQ',
  /**
   * Iran
   * @deprecated
   */
  Ir = 'IR',
  /**
   * Iceland
   * @deprecated
   */
  Is = 'IS',
  /**
   * Italy
   * @deprecated
   */
  It = 'IT',
  /**
   * Jersey
   * @deprecated
   */
  Je = 'JE',
  /**
   * Jamaica
   * @deprecated
   */
  Jm = 'JM',
  /**
   * Jordan
   * @deprecated
   */
  Jo = 'JO',
  /**
   * Japan
   * @deprecated
   */
  Jp = 'JP',
  /**
   * Kenya
   * @deprecated
   */
  Ke = 'KE',
  /**
   * Kyrgyzstan
   * @deprecated
   */
  Kg = 'KG',
  /**
   * Cambodia
   * @deprecated
   */
  Kh = 'KH',
  /**
   * Kiribati
   * @deprecated
   */
  Ki = 'KI',
  /**
   * Comoros
   * @deprecated
   */
  Km = 'KM',
  /**
   * St. Kitts & Nevis
   * @deprecated
   */
  Kn = 'KN',
  /**
   * North Korea
   * @deprecated
   */
  Kp = 'KP',
  /**
   * South Korea
   * @deprecated
   */
  Kr = 'KR',
  /**
   * Kuwait
   * @deprecated
   */
  Kw = 'KW',
  /**
   * Cayman Islands
   * @deprecated
   */
  Ky = 'KY',
  /**
   * Kazakhstan
   * @deprecated
   */
  Kz = 'KZ',
  /**
   * Laos
   * @deprecated
   */
  La = 'LA',
  /**
   * Lebanon
   * @deprecated
   */
  Lb = 'LB',
  /**
   * St. Lucia
   * @deprecated
   */
  Lc = 'LC',
  /**
   * Liechtenstein
   * @deprecated
   */
  Li = 'LI',
  /**
   * Sri Lanka
   * @deprecated
   */
  Lk = 'LK',
  /**
   * Liberia
   * @deprecated
   */
  Lr = 'LR',
  /**
   * Lesotho
   * @deprecated
   */
  Ls = 'LS',
  /**
   * Lithuania
   * @deprecated
   */
  Lt = 'LT',
  /**
   * Luxembourg
   * @deprecated
   */
  Lu = 'LU',
  /**
   * Latvia
   * @deprecated
   */
  Lv = 'LV',
  /**
   * Libya
   * @deprecated
   */
  Ly = 'LY',
  /**
   * Morocco
   * @deprecated
   */
  Ma = 'MA',
  /**
   * Monaco
   * @deprecated
   */
  Mc = 'MC',
  /**
   * Moldova
   * @deprecated
   */
  Md = 'MD',
  /**
   * Montenegro
   * @deprecated
   */
  Me = 'ME',
  /**
   * St. Martin
   * @deprecated
   */
  Mf = 'MF',
  /**
   * Madagascar
   * @deprecated
   */
  Mg = 'MG',
  /**
   * Marshall Islands
   * @deprecated
   */
  Mh = 'MH',
  /**
   * Macedonia
   * @deprecated
   */
  Mk = 'MK',
  /**
   * Mali
   * @deprecated
   */
  Ml = 'ML',
  /**
   * Myanmar (Burma)
   * @deprecated
   */
  Mm = 'MM',
  /**
   * Mongolia
   * @deprecated
   */
  Mn = 'MN',
  /**
   * Macau SAR China
   * @deprecated
   */
  Mo = 'MO',
  /**
   * Northern Mariana Islands
   * @deprecated
   */
  Mp = 'MP',
  /**
   * Martinique
   * @deprecated
   */
  Mq = 'MQ',
  /**
   * Mauritania
   * @deprecated
   */
  Mr = 'MR',
  /**
   * Montserrat
   * @deprecated
   */
  Ms = 'MS',
  /**
   * Malta
   * @deprecated
   */
  Mt = 'MT',
  /**
   * Mauritius
   * @deprecated
   */
  Mu = 'MU',
  /**
   * Maldives
   * @deprecated
   */
  Mv = 'MV',
  /**
   * Malawi
   * @deprecated
   */
  Mw = 'MW',
  /**
   * Mexico
   * @deprecated
   */
  Mx = 'MX',
  /**
   * Malaysia
   * @deprecated
   */
  My = 'MY',
  /**
   * Mozambique
   * @deprecated
   */
  Mz = 'MZ',
  /**
   * Namibia
   * @deprecated
   */
  Na = 'NA',
  /**
   * New Caledonia
   * @deprecated
   */
  Nc = 'NC',
  /**
   * Niger
   * @deprecated
   */
  Ne = 'NE',
  /**
   * Norfolk Island
   * @deprecated
   */
  Nf = 'NF',
  /**
   * Nigeria
   * @deprecated
   */
  Ng = 'NG',
  /**
   * Nicaragua
   * @deprecated
   */
  Ni = 'NI',
  /**
   * Netherlands
   * @deprecated
   */
  Nl = 'NL',
  /**
   * Norway
   * @deprecated
   */
  No = 'NO',
  /**
   * Nepal
   * @deprecated
   */
  Np = 'NP',
  /**
   * Nauru
   * @deprecated
   */
  Nr = 'NR',
  /**
   * Niue
   * @deprecated
   */
  Nu = 'NU',
  /**
   * New Zealand
   * @deprecated
   */
  Nz = 'NZ',
  /**
   * Oman
   * @deprecated
   */
  Om = 'OM',
  /**
   * Panama
   * @deprecated
   */
  Pa = 'PA',
  /**
   * Peru
   * @deprecated
   */
  Pe = 'PE',
  /**
   * French Polynesia
   * @deprecated
   */
  Pf = 'PF',
  /**
   * Papua New Guinea
   * @deprecated
   */
  Pg = 'PG',
  /**
   * Philippines
   * @deprecated
   */
  Ph = 'PH',
  /**
   * Pakistan
   * @deprecated
   */
  Pk = 'PK',
  /**
   * Poland
   * @deprecated
   */
  Pl = 'PL',
  /**
   * St. Pierre & Miquelon
   * @deprecated
   */
  Pm = 'PM',
  /**
   * Pitcairn Islands
   * @deprecated
   */
  Pn = 'PN',
  /**
   * Palestinian Territories
   * @deprecated
   */
  Ps = 'PS',
  /**
   * Portugal
   * @deprecated
   */
  Pt = 'PT',
  /**
   * Palau
   * @deprecated
   */
  Pw = 'PW',
  /**
   * Paraguay
   * @deprecated
   */
  Py = 'PY',
  /**
   * Qatar
   * @deprecated
   */
  Qa = 'QA',
  /**
   * Réunion
   * @deprecated
   */
  Re = 'RE',
  /**
   * Romania
   * @deprecated
   */
  Ro = 'RO',
  /**
   * Serbia
   * @deprecated
   */
  Rs = 'RS',
  /**
   * Russia
   * @deprecated
   */
  Ru = 'RU',
  /**
   * Rwanda
   * @deprecated
   */
  Rw = 'RW',
  /**
   * Saudi Arabia
   * @deprecated
   */
  Sa = 'SA',
  /**
   * Solomon Islands
   * @deprecated
   */
  Sb = 'SB',
  /**
   * Seychelles
   * @deprecated
   */
  Sc = 'SC',
  /**
   * Sudan
   * @deprecated
   */
  Sd = 'SD',
  /**
   * Sweden
   * @deprecated
   */
  Se = 'SE',
  /**
   * Singapore
   * @deprecated
   */
  Sg = 'SG',
  /**
   * St. Helena
   * @deprecated
   */
  Sh = 'SH',
  /**
   * Slovenia
   * @deprecated
   */
  Si = 'SI',
  /**
   * Svalbard & Jan Mayen
   * @deprecated
   */
  Sj = 'SJ',
  /**
   * Slovakia
   * @deprecated
   */
  Sk = 'SK',
  /**
   * Sierra Leone
   * @deprecated
   */
  Sl = 'SL',
  /**
   * San Marino
   * @deprecated
   */
  Sm = 'SM',
  /**
   * Senegal
   * @deprecated
   */
  Sn = 'SN',
  /**
   * Somalia
   * @deprecated
   */
  So = 'SO',
  /**
   * Suriname
   * @deprecated
   */
  Sr = 'SR',
  /**
   * São Tomé & Príncipe
   * @deprecated
   */
  St = 'ST',
  /**
   * El Salvador
   * @deprecated
   */
  Sv = 'SV',
  /**
   * Syria
   * @deprecated
   */
  Sy = 'SY',
  /**
   * Swaziland
   * @deprecated
   */
  Sz = 'SZ',
  /**
   * Turks & Caicos Islands
   * @deprecated
   */
  Tc = 'TC',
  /**
   * Chad
   * @deprecated
   */
  Td = 'TD',
  /**
   * French Southern Territories
   * @deprecated
   */
  Tf = 'TF',
  /**
   * Togo
   * @deprecated
   */
  Tg = 'TG',
  /**
   * Thailand
   * @deprecated
   */
  Th = 'TH',
  /**
   * Tajikistan
   * @deprecated
   */
  Tj = 'TJ',
  /**
   * Tokelau
   * @deprecated
   */
  Tk = 'TK',
  /**
   * Timor-Leste
   * @deprecated
   */
  Tl = 'TL',
  /**
   * Turkmenistan
   * @deprecated
   */
  Tm = 'TM',
  /**
   * Tunisia
   * @deprecated
   */
  Tn = 'TN',
  /**
   * Tonga
   * @deprecated
   */
  To = 'TO',
  /**
   * Turkey
   * @deprecated
   */
  Tr = 'TR',
  /**
   * Trinidad & Tobago
   * @deprecated
   */
  Tt = 'TT',
  /**
   * Tuvalu
   * @deprecated
   */
  Tv = 'TV',
  /**
   * Taiwan
   * @deprecated
   */
  Tw = 'TW',
  /**
   * Tanzania
   * @deprecated
   */
  Tz = 'TZ',
  /**
   * Ukraine
   * @deprecated
   */
  Ua = 'UA',
  /**
   * Uganda
   * @deprecated
   */
  Ug = 'UG',
  /**
   * U.S. Outlying Islands
   * @deprecated
   */
  Um = 'UM',
  /**
   * United States
   * @deprecated
   */
  Us = 'US',
  /**
   * Uruguay
   * @deprecated
   */
  Uy = 'UY',
  /**
   * Uzbekistan
   * @deprecated
   */
  Uz = 'UZ',
  /**
   * Vatican City
   * @deprecated
   */
  Va = 'VA',
  /**
   * St. Vincent & Grenadines
   * @deprecated
   */
  Vc = 'VC',
  /**
   * Venezuela
   * @deprecated
   */
  Ve = 'VE',
  /**
   * British Virgin Islands
   * @deprecated
   */
  Vg = 'VG',
  /**
   * U.S. Virgin Islands
   * @deprecated
   */
  Vi = 'VI',
  /**
   * Vietnam
   * @deprecated
   */
  Vn = 'VN',
  /**
   * Vanuatu
   * @deprecated
   */
  Vu = 'VU',
  /**
   * Wallis & Futuna
   * @deprecated
   */
  Wf = 'WF',
  /**
   * Samoa
   * @deprecated
   */
  Ws = 'WS',
  /**
   * Yemen
   * @deprecated
   */
  Ye = 'YE',
  /**
   * Mayotte
   * @deprecated
   */
  Yt = 'YT',
  /**
   * South Africa
   * @deprecated
   */
  Za = 'ZA',
  /**
   * Zambia
   * @deprecated
   */
  Zm = 'ZM',
  /**
   * Zimbabwe
   * @deprecated
   */
  Zw = 'ZW'
}

/** Contains an array of product IDs to use for creating a compare list. */
export type CreateCompareListInput = {
  /** An array of product IDs to add to the compare list. */
  products?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type CreateCustomerAndAddressInput = {
  addressInput: CustomerAddressInput;
  customerInput: CustomerCreateInput;
};

export type CreateCustomerInput = {
  /** Customer registration source */
  customer_source?: InputMaybe<Scalars['String']>;
  /** The customer's date of birth */
  date_of_birth?: InputMaybe<Scalars['String']>;
  /** Deprecated: Use `date_of_birth` instead */
  dob?: InputMaybe<Scalars['String']>;
  /** The customer's email address. Required for customer creation */
  email?: InputMaybe<Scalars['String']>;
  /** The customer's first name */
  firstname?: InputMaybe<Scalars['String']>;
  /** The customer's gender (Male - 1, Female - 2) */
  gender?: InputMaybe<Scalars['Int']>;
  /** Indicates whether the customer is subscribed to the company's newsletter */
  is_subscribed?: InputMaybe<Scalars['Boolean']>;
  /** The customer's family name */
  lastname?: InputMaybe<Scalars['String']>;
  /** The customer's middle name */
  middlename?: InputMaybe<Scalars['String']>;
  /** The customer's password */
  password?: InputMaybe<Scalars['String']>;
  /** Customer phone number */
  phone_number: Scalars['String'];
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: InputMaybe<Scalars['String']>;
  /** A value such as Sr., Jr., or III */
  suffix?: InputMaybe<Scalars['String']>;
  /** The customer's Tax/VAT number (for corporate customers) */
  taxvat?: InputMaybe<Scalars['String']>;
};

export type CreateOrderAndVisitInput = {
  customer_id: Scalars['ID'];
  customer_vehicle_uid: Scalars['ID'];
  store_locator_id: Scalars['Int'];
};

/** Contains the secure information used to authorize transaction. Applies to Payflow Pro and Payments Pro payment methods. */
export type CreatePayflowProTokenOutput = {
  __typename?: 'CreatePayflowProTokenOutput';
  /** The RESPMSG returned by PayPal. If the `result` is `0`, then `response_message` is `Approved`. */
  response_message: Scalars['String'];
  /** A non-zero value if any errors occurred. */
  result: Scalars['Int'];
  /** The RESULT returned by PayPal. A value of `0` indicates the transaction was approved. */
  result_code: Scalars['Int'];
  /** A secure token generated by PayPal. */
  secure_token: Scalars['String'];
  /** A secure token ID generated by PayPal. */
  secure_token_id: Scalars['String'];
};

/** Defines a new product review. */
export type CreateProductReviewInput = {
  /** The customer's nickname. Defaults to the customer name, if logged in. */
  nickname: Scalars['String'];
  /** The ratings details by category. For example, Price: 5 stars, Quality: 4 stars, etc. */
  ratings: Array<InputMaybe<ProductReviewRatingInput>>;
  /** The SKU of the reviewed product. */
  sku: Scalars['String'];
  /** The summary (title) of the review. */
  summary: Scalars['String'];
  /** The review text. */
  text: Scalars['String'];
};

/** Contains the completed product review. */
export type CreateProductReviewOutput = {
  __typename?: 'CreateProductReviewOutput';
  /** Product review details. */
  review: ProductReview;
};

export type CreateSubstitutionInput = {
  visit_id: Scalars['ID'];
};

/** Required fields for Payflow Pro and Payments Pro credit card payments. */
export type CreditCardDetailsInput = {
  /** The credit card expiration month. */
  cc_exp_month: Scalars['Int'];
  /** The credit card expiration year. */
  cc_exp_year: Scalars['Int'];
  /** The last 4 digits of the credit card. */
  cc_last_4: Scalars['Int'];
  /** The credit card type. */
  cc_type: Scalars['String'];
};

/** Contains credit memo details. */
export type CreditMemo = {
  __typename?: 'CreditMemo';
  /** Comments on the credit memo. */
  comments?: Maybe<Array<Maybe<SalesCommentItem>>>;
  /** The unique ID for a `CreditMemo` object. */
  id: Scalars['ID'];
  /** An array containing details about refunded items. */
  items?: Maybe<Array<Maybe<CreditMemoItemInterface>>>;
  /** The sequential credit memo number. */
  number: Scalars['String'];
  /** Details about the total refunded amount. */
  total?: Maybe<CreditMemoTotal>;
};

export type CreditMemoItem = CreditMemoItemInterface & {
  __typename?: 'CreditMemoItem';
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars['ID'];
  /** The order item the credit memo is applied to. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price for the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']>;
};

/** Credit memo item details. */
export type CreditMemoItemInterface = {
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars['ID'];
  /** The order item the credit memo is applied to. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price for the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']>;
};

/** Contains credit memo price details. */
export type CreditMemoTotal = {
  __typename?: 'CreditMemoTotal';
  /** An adjustment manually applied to the order. */
  adjustment: Money;
  /** The final base grand total amount in the base currency. */
  base_grand_total: Money;
  /** The applied discounts to the credit memo. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The final total amount, including shipping, discounts, and taxes. */
  grand_total: Money;
  /** Details about the shipping and handling costs for the credit memo. */
  shipping_handling?: Maybe<ShippingHandling>;
  /** The subtotal of the invoice, excluding shipping, discounts, and taxes. */
  subtotal: Money;
  /** The credit memo tax details. */
  taxes?: Maybe<Array<Maybe<TaxItem>>>;
  /** The shipping amount for the credit memo. */
  total_shipping: Money;
  /** The amount of tax applied to the credit memo. */
  total_tax: Money;
};

export type Currency = {
  __typename?: 'Currency';
  /** An array of three-letter currency codes accepted by the store, such as USD and EUR. */
  available_currency_codes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The base currency set for the store, such as USD. */
  base_currency_code?: Maybe<Scalars['String']>;
  /** The symbol for the specified base currency, such as $. */
  base_currency_symbol?: Maybe<Scalars['String']>;
  /** @deprecated Symbol was missed. Use `default_display_currency_code`. */
  default_display_currecy_code?: Maybe<Scalars['String']>;
  /** @deprecated Symbol was missed. Use `default_display_currency_code`. */
  default_display_currecy_symbol?: Maybe<Scalars['String']>;
  /** The currency that is displayed by default, such as USD. */
  default_display_currency_code?: Maybe<Scalars['String']>;
  /** The currency symbol that is displayed by default, such as $. */
  default_display_currency_symbol?: Maybe<Scalars['String']>;
  /** An array of exchange rates for currencies defined in the store. */
  exchange_rates?: Maybe<Array<Maybe<ExchangeRate>>>;
};

/** The list of available currency codes. */
export enum CurrencyEnum {
  /** @deprecated  */
  Aed = 'AED',
  /** @deprecated  */
  Afn = 'AFN',
  /** @deprecated  */
  All = 'ALL',
  /** @deprecated  */
  Amd = 'AMD',
  /** @deprecated  */
  Ang = 'ANG',
  /** @deprecated  */
  Aoa = 'AOA',
  /** @deprecated  */
  Ars = 'ARS',
  /** @deprecated  */
  Aud = 'AUD',
  /** @deprecated  */
  Awg = 'AWG',
  /** @deprecated  */
  Azm = 'AZM',
  /** @deprecated  */
  Azn = 'AZN',
  /** @deprecated  */
  Bam = 'BAM',
  /** @deprecated  */
  Bbd = 'BBD',
  /** @deprecated  */
  Bdt = 'BDT',
  /** @deprecated  */
  Bgn = 'BGN',
  /** @deprecated  */
  Bhd = 'BHD',
  /** @deprecated  */
  Bif = 'BIF',
  /** @deprecated  */
  Bmd = 'BMD',
  /** @deprecated  */
  Bnd = 'BND',
  /** @deprecated  */
  Bob = 'BOB',
  /** @deprecated  */
  Brl = 'BRL',
  /** @deprecated  */
  Bsd = 'BSD',
  /** @deprecated  */
  Btn = 'BTN',
  /** @deprecated  */
  Buk = 'BUK',
  /** @deprecated  */
  Bwp = 'BWP',
  /** @deprecated  */
  Byn = 'BYN',
  /** @deprecated  */
  Bzd = 'BZD',
  /** @deprecated  */
  Cad = 'CAD',
  /** @deprecated  */
  Cdf = 'CDF',
  /** @deprecated  */
  Che = 'CHE',
  /** @deprecated  */
  Chf = 'CHF',
  /** @deprecated  */
  Chw = 'CHW',
  /** @deprecated  */
  Clp = 'CLP',
  /** @deprecated  */
  Cny = 'CNY',
  /** @deprecated  */
  Cop = 'COP',
  /** @deprecated  */
  Crc = 'CRC',
  /** @deprecated  */
  Cup = 'CUP',
  /** @deprecated  */
  Cve = 'CVE',
  /** @deprecated  */
  Czk = 'CZK',
  /** @deprecated  */
  Djf = 'DJF',
  /** @deprecated  */
  Dkk = 'DKK',
  /** @deprecated  */
  Dop = 'DOP',
  /** @deprecated  */
  Dzd = 'DZD',
  /** @deprecated  */
  Eek = 'EEK',
  /** @deprecated  */
  Egp = 'EGP',
  /** @deprecated  */
  Ern = 'ERN',
  /** @deprecated  */
  Etb = 'ETB',
  /** @deprecated  */
  Eur = 'EUR',
  /** @deprecated  */
  Fjd = 'FJD',
  /** @deprecated  */
  Fkp = 'FKP',
  /** @deprecated  */
  Gbp = 'GBP',
  /** @deprecated  */
  Gek = 'GEK',
  /** @deprecated  */
  Gel = 'GEL',
  /** @deprecated  */
  Ghs = 'GHS',
  /** @deprecated  */
  Gip = 'GIP',
  /** @deprecated  */
  Gmd = 'GMD',
  /** @deprecated  */
  Gnf = 'GNF',
  /** @deprecated  */
  Gqe = 'GQE',
  /** @deprecated  */
  Gtq = 'GTQ',
  /** @deprecated  */
  Gyd = 'GYD',
  /** @deprecated  */
  Hkd = 'HKD',
  /** @deprecated  */
  Hnl = 'HNL',
  /** @deprecated  */
  Hrk = 'HRK',
  /** @deprecated  */
  Htg = 'HTG',
  /** @deprecated  */
  Huf = 'HUF',
  /** @deprecated  */
  Idr = 'IDR',
  /** @deprecated  */
  Ils = 'ILS',
  /** @deprecated  */
  Inr = 'INR',
  /** @deprecated  */
  Iqd = 'IQD',
  /** @deprecated  */
  Irr = 'IRR',
  /** @deprecated  */
  Isk = 'ISK',
  /** @deprecated  */
  Jmd = 'JMD',
  /** @deprecated  */
  Jod = 'JOD',
  /** @deprecated  */
  Jpy = 'JPY',
  /** @deprecated  */
  Kes = 'KES',
  /** @deprecated  */
  Kgs = 'KGS',
  /** @deprecated  */
  Khr = 'KHR',
  /** @deprecated  */
  Kmf = 'KMF',
  /** @deprecated  */
  Kpw = 'KPW',
  /** @deprecated  */
  Krw = 'KRW',
  /** @deprecated  */
  Kwd = 'KWD',
  /** @deprecated  */
  Kyd = 'KYD',
  /** @deprecated  */
  Kzt = 'KZT',
  /** @deprecated  */
  Lak = 'LAK',
  /** @deprecated  */
  Lbp = 'LBP',
  /** @deprecated  */
  Lkr = 'LKR',
  /** @deprecated  */
  Lrd = 'LRD',
  /** @deprecated  */
  Lsl = 'LSL',
  /** @deprecated  */
  Lsm = 'LSM',
  /** @deprecated  */
  Ltl = 'LTL',
  /** @deprecated  */
  Lvl = 'LVL',
  /** @deprecated  */
  Lyd = 'LYD',
  /** @deprecated  */
  Mad = 'MAD',
  /** @deprecated  */
  Mdl = 'MDL',
  /** @deprecated  */
  Mga = 'MGA',
  /** @deprecated  */
  Mkd = 'MKD',
  /** @deprecated  */
  Mmk = 'MMK',
  /** @deprecated  */
  Mnt = 'MNT',
  /** @deprecated  */
  Mop = 'MOP',
  /** @deprecated  */
  Mro = 'MRO',
  /** @deprecated  */
  Mur = 'MUR',
  /** @deprecated  */
  Mvr = 'MVR',
  /** @deprecated  */
  Mwk = 'MWK',
  /** @deprecated  */
  Mxn = 'MXN',
  /** @deprecated  */
  Myr = 'MYR',
  /** @deprecated  */
  Mzn = 'MZN',
  /** @deprecated  */
  Nad = 'NAD',
  /** @deprecated  */
  Ngn = 'NGN',
  /** @deprecated  */
  Nic = 'NIC',
  /** @deprecated  */
  Nok = 'NOK',
  /** @deprecated  */
  Npr = 'NPR',
  /** @deprecated  */
  Nzd = 'NZD',
  /** @deprecated  */
  Omr = 'OMR',
  /** @deprecated  */
  Pab = 'PAB',
  /** @deprecated  */
  Pen = 'PEN',
  /** @deprecated  */
  Pgk = 'PGK',
  /** @deprecated  */
  Php = 'PHP',
  /** @deprecated  */
  Pkr = 'PKR',
  /** @deprecated  */
  Pln = 'PLN',
  /** @deprecated  */
  Pyg = 'PYG',
  /** @deprecated  */
  Qar = 'QAR',
  /** @deprecated  */
  Rhd = 'RHD',
  /** @deprecated  */
  Rol = 'ROL',
  /** @deprecated  */
  Ron = 'RON',
  /** @deprecated  */
  Rsd = 'RSD',
  /** @deprecated  */
  Rub = 'RUB',
  /** @deprecated  */
  Rwf = 'RWF',
  /** @deprecated  */
  Sar = 'SAR',
  /** @deprecated  */
  Sbd = 'SBD',
  /** @deprecated  */
  Scr = 'SCR',
  /** @deprecated  */
  Sdg = 'SDG',
  /** @deprecated  */
  Sek = 'SEK',
  /** @deprecated  */
  Sgd = 'SGD',
  /** @deprecated  */
  Shp = 'SHP',
  /** @deprecated  */
  Skk = 'SKK',
  /** @deprecated  */
  Sll = 'SLL',
  /** @deprecated  */
  Sos = 'SOS',
  /** @deprecated  */
  Srd = 'SRD',
  /** @deprecated  */
  Std = 'STD',
  /** @deprecated  */
  Svc = 'SVC',
  /** @deprecated  */
  Syp = 'SYP',
  /** @deprecated  */
  Szl = 'SZL',
  /** @deprecated  */
  Thb = 'THB',
  /** @deprecated  */
  Tjs = 'TJS',
  /** @deprecated  */
  Tmm = 'TMM',
  /** @deprecated  */
  Tnd = 'TND',
  /** @deprecated  */
  Top = 'TOP',
  /** @deprecated  */
  Trl = 'TRL',
  /** @deprecated  */
  Try = 'TRY',
  /** @deprecated  */
  Ttd = 'TTD',
  /** @deprecated  */
  Twd = 'TWD',
  /** @deprecated  */
  Tzs = 'TZS',
  /** @deprecated  */
  Uah = 'UAH',
  /** @deprecated  */
  Ugx = 'UGX',
  /** @deprecated  */
  Usd = 'USD',
  /** @deprecated  */
  Uyu = 'UYU',
  /** @deprecated  */
  Uzs = 'UZS',
  /** @deprecated  */
  Veb = 'VEB',
  /** @deprecated  */
  Vef = 'VEF',
  /** @deprecated  */
  Vnd = 'VND',
  /** @deprecated  */
  Vuv = 'VUV',
  /** @deprecated  */
  Wst = 'WST',
  /** @deprecated  */
  Xcd = 'XCD',
  /** @deprecated  */
  Xof = 'XOF',
  /** @deprecated  */
  Xpf = 'XPF',
  /** @deprecated  */
  Yer = 'YER',
  /** @deprecated  */
  Ytl = 'YTL',
  /** @deprecated  */
  Zar = 'ZAR',
  /** @deprecated  */
  Zmk = 'ZMK',
  /** @deprecated  */
  Zwd = 'ZWD'
}

export type CustomAttribute = {
  __typename?: 'CustomAttribute';
  key: Scalars['String'];
  label: Scalars['String'];
  value: Scalars['String'];
};

/** Defines an array of custom attributes. */
export type CustomAttributeMetadata = {
  __typename?: 'CustomAttributeMetadata';
  /** An array of attributes. */
  items?: Maybe<Array<Maybe<Attribute>>>;
};

/** Customer defines the customer name and address and other details */
export type Customer = {
  __typename?: 'Customer';
  /** An array containing the customer's shipping and billing addresses. */
  addresses?: Maybe<Array<Maybe<CustomerAddress>>>;
  /** Indicates whether the customer has enabled remote shopping assistance. */
  allow_remote_shopping_assistance: Scalars['Boolean'];
  /** The contents of the customer's compare list. */
  compare_list?: Maybe<CompareList>;
  /** Timestamp indicating when the account was created. */
  created_at?: Maybe<Scalars['String']>;
  /** Customer registration source */
  customer_source?: Maybe<Scalars['String']>;
  /** The customer's date of birth. */
  date_of_birth?: Maybe<Scalars['String']>;
  /** The ID assigned to the billing address. */
  default_billing?: Maybe<Scalars['String']>;
  /** The ID assigned to the shipping address. */
  default_shipping?: Maybe<Scalars['String']>;
  /**
   * The customer's date of birth.
   * @deprecated Use `date_of_birth` instead.
   */
  dob?: Maybe<Scalars['String']>;
  /** The customer's email address. Required. */
  email?: Maybe<Scalars['String']>;
  /** An array containing the customer's evouchers. Filterable by status */
  evouchers?: Maybe<CustomerEvoucher>;
  /** The customer's first name. */
  firstname?: Maybe<Scalars['String']>;
  /** The customer's gender (Male - 1, Female - 2). */
  gender?: Maybe<Scalars['Int']>;
  /** @deprecated Customer group should not be exposed in the storefront scenarios. */
  group_id?: Maybe<Scalars['Int']>;
  /**
   * The ID assigned to the customer.
   * @deprecated `id` is not needed as part of `Customer`, because on the server side, it can be identified based on the customer token used for authentication. There is no need to know customer ID on the client side.
   */
  id?: Maybe<Scalars['Int']>;
  is_email_dummy?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the customer is subscribed to the company's newsletter. */
  is_subscribed?: Maybe<Scalars['Boolean']>;
  /** The customer's family name. */
  lastname?: Maybe<Scalars['String']>;
  /** The customer's middle name. */
  middlename?: Maybe<Scalars['String']>;
  /** Get nearest upcoming booking for the customer. */
  nearest_upcoming_booking?: Maybe<StoreBooking>;
  orders?: Maybe<CustomerOrders>;
  /** The customer's custom phone number */
  phone_number?: Maybe<Scalars['String']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars['String']>;
  /** Contains the customer's product reviews. */
  reviews: ProductReviews;
  selected_stock_source?: Maybe<Scalars['String']>;
  /** A value such as Sr., Jr., or III. */
  suffix?: Maybe<Scalars['String']>;
  /** The customer's Value-added tax (VAT) number (for corporate customers). */
  taxvat?: Maybe<Scalars['String']>;
  /** Get all vehicles */
  vehicles: Array<Maybe<CustomerVehicle>>;
  verified?: Maybe<Scalars['Boolean']>;
  visits?: Maybe<CustomerVisits>;
  /**
   * Return a customer's wish lists.
   * @deprecated Use `Customer.wishlists` or `Customer.wishlist_v2` instead.
   */
  wishlist: Wishlist;
  /** Retrieve the wish list identified by the unique ID for a `Wishlist` object. */
  wishlist_v2?: Maybe<Wishlist>;
  /** An array of wishlists. In Magento Open Source, customers are limited to one wish list. The number of wish lists is configurable for Adobe Commerce. */
  wishlists: Array<Maybe<Wishlist>>;
};


/** Customer defines the customer name and address and other details */
export type CustomerEvouchersArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<EvouchersFilterInput>;
  informClient?: InputMaybe<Scalars['Boolean']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


/** Customer defines the customer name and address and other details */
export type CustomerOrdersArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<CustomerOrdersFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
  scope?: InputMaybe<ScopeTypeEnum>;
  sort?: InputMaybe<CustomerOrderSortInput>;
};


/** Customer defines the customer name and address and other details */
export type CustomerReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


/** Customer defines the customer name and address and other details */
export type CustomerVehiclesArgs = {
  vehicleUid?: InputMaybe<Scalars['ID']>;
};


/** Customer defines the customer name and address and other details */
export type CustomerVisitsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<StoreVisitsFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


/** Customer defines the customer name and address and other details */
export type CustomerWishlist_V2Args = {
  id: Scalars['ID'];
};


/** Customer defines the customer name and address and other details */
export type CustomerWishlistsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** CustomerAddress contains detailed information about a customer's billing and shipping addresses */
export type CustomerAddress = {
  __typename?: 'CustomerAddress';
  /** An object containing the city name, city code, and city ID */
  city?: Maybe<City>;
  /** The customer's company. */
  company?: Maybe<Scalars['String']>;
  /** An object containing the country name, country code, and country ID */
  country?: Maybe<Country>;
  /** The customer's country. */
  country_code?: Maybe<CountryCodeEnum>;
  /**
   * The customer's country.
   * @deprecated Use `country_code` instead.
   */
  country_id?: Maybe<Scalars['String']>;
  /** @deprecated Custom attributes should not be put into a container. */
  custom_attributes?: Maybe<Array<Maybe<CustomerAddressAttribute>>>;
  /**
   * The customer ID
   * @deprecated `customer_id` is not needed as part of `CustomerAddress`. The `id` is a unique identifier for the addresses.
   */
  customer_id?: Maybe<Scalars['Int']>;
  /** Indicates whether the address is the customer's default billing address. */
  default_billing?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the address is the customer's default shipping address. */
  default_shipping?: Maybe<Scalars['Boolean']>;
  /** Contains any extension attributes for the address. */
  extension_attributes?: Maybe<Array<Maybe<CustomerAddressAttribute>>>;
  /** The customer's fax number. */
  fax?: Maybe<Scalars['String']>;
  /** The first name of the person associated with the shipping/billing address. */
  firstname?: Maybe<Scalars['String']>;
  /** The ID of a `CustomerAddress` object. */
  id?: Maybe<Scalars['Int']>;
  /** if phone number is verified */
  is_phone_verified: Scalars['Boolean'];
  /** The family name of the person associated with the shipping/billing address. */
  lastname?: Maybe<Scalars['String']>;
  /** The middle name of the person associated with the shipping/billing address. */
  middlename?: Maybe<Scalars['String']>;
  /** The customer's ZIP or postal code. */
  postcode?: Maybe<Scalars['String']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars['String']>;
  /** An object containing the region name, region code, and region ID. */
  region?: Maybe<CustomerAddressRegion>;
  /** The unique ID for a pre-defined region. */
  region_id?: Maybe<Scalars['Int']>;
  /** An array of strings that define the street number and name. */
  street?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A value such as Sr., Jr., or III. */
  suffix?: Maybe<Scalars['String']>;
  /** The customer's telephone number. */
  telephone?: Maybe<Scalars['String']>;
  /** The customer's Value-added tax (VAT) number (for corporate customers). */
  vat_id?: Maybe<Scalars['String']>;
};

/** Specifies the attribute code and value of a customer address attribute. */
export type CustomerAddressAttribute = {
  __typename?: 'CustomerAddressAttribute';
  /** The name assigned to the customer address attribute. */
  attribute_code?: Maybe<Scalars['String']>;
  /** The valuue assigned to the customer address attribute. */
  value?: Maybe<Scalars['String']>;
};

/** Specifies the attribute code and value of a customer attribute. */
export type CustomerAddressAttributeInput = {
  /** The name assigned to the attribute. */
  attribute_code: Scalars['String'];
  /** The value assigned to the attribute. */
  value: Scalars['String'];
};

/** Contains details about a billing or shipping address. */
export type CustomerAddressInput = {
  /** The customer's city or town. */
  city?: InputMaybe<Scalars['String']>;
  /** The customer's company. */
  company?: InputMaybe<Scalars['String']>;
  /** The two-letter code representing the customer's country. */
  country_code?: InputMaybe<CountryCodeEnum>;
  /** Deprecated: use `country_code` instead. */
  country_id?: InputMaybe<CountryCodeEnum>;
  /** Deprecated: Custom attributes should not be put into container. */
  custom_attributes?: InputMaybe<Array<InputMaybe<CustomerAddressAttributeInput>>>;
  /** Indicates whether the address is the default billing address. */
  default_billing?: InputMaybe<Scalars['Boolean']>;
  /** Indicates whether the address is the default shipping address. */
  default_shipping?: InputMaybe<Scalars['Boolean']>;
  /** The customer's fax number. */
  fax?: InputMaybe<Scalars['String']>;
  /** The first name of the person associated with the billing/shipping address. */
  firstname?: InputMaybe<Scalars['String']>;
  /** The family name of the person associated with the billing/shipping address. */
  lastname?: InputMaybe<Scalars['String']>;
  /** The middle name of the person associated with the billing/shipping address. */
  middlename?: InputMaybe<Scalars['String']>;
  /** The customer's ZIP or postal code. */
  postcode?: InputMaybe<Scalars['String']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: InputMaybe<Scalars['String']>;
  /** An object containing the region name, region code, and region ID. */
  region?: InputMaybe<CustomerAddressRegionInput>;
  /** An array of strings that define the street number and name. */
  street?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** A value such as Sr., Jr., or III. */
  suffix?: InputMaybe<Scalars['String']>;
  /** The customer's telephone number. */
  telephone?: InputMaybe<Scalars['String']>;
  /** The customer's Tax/VAT number (for corporate customers). */
  vat_id?: InputMaybe<Scalars['String']>;
};

/** Defines the customer's state or province. */
export type CustomerAddressRegion = {
  __typename?: 'CustomerAddressRegion';
  /** The state or province name. */
  region?: Maybe<Scalars['String']>;
  /** The address region code. */
  region_code?: Maybe<Scalars['String']>;
  /** The unique ID for a pre-defined region. */
  region_id?: Maybe<Scalars['Int']>;
};

/** Defines the customer's state or province. */
export type CustomerAddressRegionInput = {
  /** The state or province name. */
  region?: InputMaybe<Scalars['String']>;
  /** The address region code. */
  region_code?: InputMaybe<Scalars['String']>;
  /** The unique ID for a pre-defined region. */
  region_id?: InputMaybe<Scalars['Int']>;
};

/** An input object for creating a customer. */
export type CustomerCreateInput = {
  /** Indicates whether the customer has enabled remote shopping assistance. */
  allow_remote_shopping_assistance?: InputMaybe<Scalars['Boolean']>;
  /** The customer's date of birth. */
  date_of_birth?: InputMaybe<Scalars['String']>;
  /** Deprecated: Use `date_of_birth` instead. */
  dob?: InputMaybe<Scalars['String']>;
  /** The customer's email address. */
  email?: InputMaybe<Scalars['String']>;
  /** The customer's first name. */
  firstname: Scalars['String'];
  /** The customer's gender (Male - 1, Female - 2). */
  gender?: InputMaybe<Scalars['Int']>;
  /** Indicates whether the customer is subscribed to the company's newsletter. */
  is_subscribed?: InputMaybe<Scalars['Boolean']>;
  /** The customer's family name. */
  lastname: Scalars['String'];
  /** The customer's middle name. */
  middlename?: InputMaybe<Scalars['String']>;
  /** The customer's password. */
  password?: InputMaybe<Scalars['String']>;
  /** Customer phone number */
  phone_number: Scalars['String'];
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: InputMaybe<Scalars['String']>;
  /** A value such as Sr., Jr., or III. */
  suffix?: InputMaybe<Scalars['String']>;
  /** The customer's Tax/VAT number (for corporate customers). */
  taxvat?: InputMaybe<Scalars['String']>;
};

/** Contains details about a single downloadable product. */
export type CustomerDownloadableProduct = {
  __typename?: 'CustomerDownloadableProduct';
  /** The date and time the purchase was made. */
  date?: Maybe<Scalars['String']>;
  /** The fully qualified URL to the download file. */
  download_url?: Maybe<Scalars['String']>;
  /** The unique ID assigned to the item. */
  order_increment_id?: Maybe<Scalars['String']>;
  /** The remaining number of times the customer can download the product. */
  remaining_downloads?: Maybe<Scalars['String']>;
  /** Indicates when the product becomes available for download. Options are `Pending` and `Invoiced`. */
  status?: Maybe<Scalars['String']>;
};

/** Contains a list of downloadable products. */
export type CustomerDownloadableProducts = {
  __typename?: 'CustomerDownloadableProducts';
  /** An array of purchased downloadable items. */
  items?: Maybe<Array<Maybe<CustomerDownloadableProduct>>>;
};

export type CustomerEvoucher = {
  __typename?: 'CustomerEvoucher';
  items?: Maybe<Array<Maybe<Evoucher>>>;
  page_info?: Maybe<SearchResultPageInfo>;
  total_count?: Maybe<Scalars['Int']>;
};

export type CustomerInformationInput = {
  newEmail: Scalars['String'];
  newPassword: Scalars['String'];
};

/** An input object that assigns or updates customer attributes. */
export type CustomerInput = {
  /** The customer's date of birth. */
  date_of_birth?: InputMaybe<Scalars['String']>;
  /** Deprecated: Use `date_of_birth` instead. */
  dob?: InputMaybe<Scalars['String']>;
  /** The customer's email address. Required when creating a customer. */
  email?: InputMaybe<Scalars['String']>;
  /** The customer's first name. */
  firstname?: InputMaybe<Scalars['String']>;
  /** The customer's gender (Male - 1, Female - 2). */
  gender?: InputMaybe<Scalars['Int']>;
  /** Indicates whether the customer is subscribed to the company's newsletter. */
  is_subscribed?: InputMaybe<Scalars['Boolean']>;
  /** The customer's family name. */
  lastname?: InputMaybe<Scalars['String']>;
  /** The customer's middle name. */
  middlename?: InputMaybe<Scalars['String']>;
  /** The customer's password. */
  password?: InputMaybe<Scalars['String']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: InputMaybe<Scalars['String']>;
  /** A value such as Sr., Jr., or III. */
  suffix?: InputMaybe<Scalars['String']>;
  /** The customer's Tax/VAT number (for corporate customers). */
  taxvat?: InputMaybe<Scalars['String']>;
};

/** Contains details about each of the customer's orders. */
export type CustomerOrder = {
  __typename?: 'CustomerOrder';
  acceptIframeUrl?: Maybe<Scalars['String']>;
  acceptPaymentId?: Maybe<Scalars['String']>;
  /** The billing address for the order. */
  billing_address?: Maybe<OrderAddress>;
  /** The shipping carrier for the order delivery. */
  carrier?: Maybe<Scalars['String']>;
  /** Comments about the order. */
  comments?: Maybe<Array<Maybe<SalesCommentItem>>>;
  /** The timestamp of order completion after sync with ERP */
  completed_at?: Maybe<Scalars['String']>;
  coupon_code?: Maybe<Scalars['String']>;
  /** @deprecated Use the `order_date` field instead. */
  created_at?: Maybe<Scalars['String']>;
  /** A list of credit memos. */
  credit_memos?: Maybe<Array<Maybe<CreditMemo>>>;
  delivery_details?: Maybe<DeliveryDetails>;
  details?: Maybe<CustomerOrderDetails>;
  email: Scalars['String'];
  /** An array of the gained evouchers on any order. */
  gainedEvouchers?: Maybe<CustomerEvoucher>;
  /** The entered gift message for the order */
  gift_message?: Maybe<GiftMessage>;
  /** @deprecated Use the `totals.grand_total` field instead. */
  grand_total?: Maybe<Scalars['Float']>;
  has_addons?: Maybe<Scalars['Boolean']>;
  has_booking: Scalars['Boolean'];
  /** The unique ID for a `CustomerOrder` object. */
  id: Scalars['ID'];
  /** @deprecated Use the `id` field instead. */
  increment_id?: Maybe<Scalars['String']>;
  /** A list of invoices for the order. */
  invoices: Array<Maybe<Invoice>>;
  is_jump_start_order?: Maybe<Scalars['Boolean']>;
  is_van_service_order?: Maybe<Scalars['Boolean']>;
  /** An array containing the items purchased in this order. */
  items?: Maybe<Array<Maybe<OrderItemInterface>>>;
  jump_start_me?: Maybe<JsmInfo>;
  /** Reference number used with `robusta_accept_kiosk` payment method. */
  kiosk_reference_number?: Maybe<Scalars['String']>;
  /** The order number. */
  number: Scalars['String'];
  /** The date the order was placed. */
  order_date: Scalars['String'];
  /** @deprecated Use the `number` field instead. */
  order_number: Scalars['String'];
  order_source?: Maybe<Scalars['String']>;
  /** Payment details for the order. */
  payment_methods?: Maybe<Array<Maybe<OrderPaymentMethod>>>;
  products?: Maybe<CustomerOrderProducts>;
  seen?: Maybe<Scalars['Boolean']>;
  /** A list of shipments for the order. */
  shipments?: Maybe<Array<Maybe<OrderShipment>>>;
  /** The shipping address for the order. */
  shipping_address?: Maybe<OrderAddress>;
  /** The delivery method for the order. */
  shipping_method?: Maybe<Scalars['String']>;
  /** The current status of the order. */
  status: Scalars['String'];
  status_label?: Maybe<Scalars['String']>;
  stock_source?: Maybe<StockSourceItem>;
  /** Details about the calculated totals for this order. */
  total?: Maybe<OrderTotal>;
  van_service_info?: Maybe<JsmInfo>;
  vehicle?: Maybe<OrderVehicle>;
};


/** Contains details about each of the customer's orders. */
export type CustomerOrderGainedEvouchersArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type CustomerOrderDetails = {
  __typename?: 'CustomerOrderDetails';
  discount?: Maybe<Scalars['Float']>;
  payment_details?: Maybe<CustomerOrderDetailsPaymentMethod>;
  shipping_details?: Maybe<CustomerOrderDetailsShippingDetails>;
  subtotal?: Maybe<Scalars['Float']>;
};

export type CustomerOrderDetailsPaymentMethod = {
  __typename?: 'CustomerOrderDetailsPaymentMethod';
  code?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type CustomerOrderDetailsShippingAddress = {
  __typename?: 'CustomerOrderDetailsShippingAddress';
  address?: Maybe<Scalars['String']>;
  mobile_number?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type CustomerOrderDetailsShippingDetails = {
  __typename?: 'CustomerOrderDetailsShippingDetails';
  address?: Maybe<CustomerOrderDetailsShippingAddress>;
  cost?: Maybe<Scalars['Float']>;
  method?: Maybe<Scalars['String']>;
  method_code?: Maybe<Scalars['String']>;
};

export type CustomerOrderProduct = {
  __typename?: 'CustomerOrderProduct';
  /** Information about the booking of this item */
  booked_service?: Maybe<BookedService>;
  id: Scalars['Int'];
  name: Scalars['String'];
  price_after: Scalars['Float'];
  price_after_including_tax: Scalars['Float'];
  price_before: Scalars['Float'];
  price_before_including_tax: Scalars['Float'];
  product?: Maybe<ProductInterface>;
  quantity: Scalars['Float'];
  row_total: Scalars['Float'];
  row_total_including_tax: Scalars['Float'];
  sku: Scalars['String'];
};

export type CustomerOrderProducts = {
  __typename?: 'CustomerOrderProducts';
  count: Scalars['Int'];
  items: Array<Maybe<CustomerOrderProduct>>;
};

export type CustomerOrderSearchOutput = {
  __typename?: 'CustomerOrderSearchOutput';
  items: Array<Maybe<CustomerOrder>>;
  page_info: SearchResultPageInfo;
  total_count: Scalars['Int'];
};

/** CustomerOrderSortInput specifies the field to use for sorting search results and indicates whether the results are sorted in ascending or descending order. */
export type CustomerOrderSortInput = {
  /** This enumeration indicates whether to return results in ascending or descending order */
  sort_direction: SortEnum;
  /** Specifies the field to use for sorting */
  sort_field: CustomerOrderSortableField;
};

/** Specifies the field to use for sorting */
export enum CustomerOrderSortableField {
  /**
   * Sorts customer orders by created_at field
   * @deprecated
   */
  CreatedAt = 'CREATED_AT',
  /**
   * Sorts customer orders by number
   * @deprecated
   */
  Number = 'NUMBER'
}

/** The collection of orders that match the conditions defined in the filter. */
export type CustomerOrders = {
  __typename?: 'CustomerOrders';
  /** An array of customer orders. */
  items: Array<Maybe<CustomerOrder>>;
  /** Contains pagination metadata. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The total count of customer orders. */
  total_count?: Maybe<Scalars['Int']>;
};

/** Identifies the filter to use for filtering orders. */
export type CustomerOrdersFilterInput = {
  /** Filters bookings/orders only. */
  has_booking?: InputMaybe<FilterEqualTypeInput>;
  /** Filters by order number. */
  number?: InputMaybe<FilterStringTypeInput>;
};

/** Contains details about a newly-created or updated customer. */
export type CustomerOutput = {
  __typename?: 'CustomerOutput';
  /** Customer details after creating or updating a customer. */
  customer: Customer;
};

/** Contains payment tokens stored in the customer's vault. */
export type CustomerPaymentTokens = {
  __typename?: 'CustomerPaymentTokens';
  /** An array of payment tokens. */
  items: Array<Maybe<PaymentToken>>;
};

/** Contains a customer authorization token. */
export type CustomerToken = {
  __typename?: 'CustomerToken';
  refreshToken: Scalars['String'];
  /** in timestamp */
  refresh_token_expires_at?: Maybe<Scalars['String']>;
  /** The customer authorization token. */
  token?: Maybe<Scalars['String']>;
  /** in timestamp */
  token_expires_at?: Maybe<Scalars['String']>;
  verified?: Maybe<Scalars['Boolean']>;
};

export type CustomerUpdateAsAdminInput = {
  /** The customer's updated email */
  email?: InputMaybe<Scalars['String']>;
  /** The customer's first name */
  firstname?: InputMaybe<Scalars['String']>;
  /** The customer's family name */
  lastname?: InputMaybe<Scalars['String']>;
};

/** An input object for updating a customer. */
export type CustomerUpdateInput = {
  /** Indicates whether the customer has enabled remote shopping assistance. */
  allow_remote_shopping_assistance?: InputMaybe<Scalars['Boolean']>;
  /** The customer's date of birth. */
  date_of_birth?: InputMaybe<Scalars['String']>;
  /** Deprecated: Use `date_of_birth` instead. */
  dob?: InputMaybe<Scalars['String']>;
  /** The customer's first name. */
  firstname?: InputMaybe<Scalars['String']>;
  /** The customer's gender (Male - 1, Female - 2). */
  gender?: InputMaybe<Scalars['Int']>;
  /** Indicates whether the customer is subscribed to the company's newsletter. */
  is_subscribed?: InputMaybe<Scalars['Boolean']>;
  /** The customer's family name. */
  lastname?: InputMaybe<Scalars['String']>;
  /** The customer's middle name. */
  middlename?: InputMaybe<Scalars['String']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: InputMaybe<Scalars['String']>;
  /** A value such as Sr., Jr., or III. */
  suffix?: InputMaybe<Scalars['String']>;
  /** The customer's Tax/VAT number (for corporate customers). */
  taxvat?: InputMaybe<Scalars['String']>;
};

export type CustomerVehicle = {
  __typename?: 'CustomerVehicle';
  /** Vehicle Brand */
  brand: VehicleBrand;
  /** Vehicle color */
  color?: Maybe<Color>;
  completedVisits?: Maybe<CustomerVisits>;
  /** Customer ID */
  customerId?: Maybe<Scalars['Int']>;
  /** Customer Email */
  email?: Maybe<Scalars['String']>;
  /** Is this the customer's default vehicle */
  is_default?: Maybe<Scalars['Boolean']>;
  /** License Plate number */
  license_number?: Maybe<Scalars['String']>;
  /** Vehicle model mileage */
  mileage?: Maybe<Scalars['String']>;
  /** Vehicle Model */
  model: VehicleModel;
  /** Customer Name */
  name?: Maybe<Scalars['String']>;
  /** Get nearest upcoming booking for the vehicle. */
  nearest_upcoming_booking?: Maybe<StoreBooking>;
  /** Customer Phone number */
  phone_number?: Maybe<Scalars['String']>;
  /** All reminders for the upcoming/past visits */
  reminders?: Maybe<UpcomingVisitsReminders>;
  /** The UID of the customer vehicle, it identifies both the vehicle and the customer */
  uid: Scalars['ID'];
  /** Get upcoming bookings for the vehicle. */
  upcoming_bookings: Array<Maybe<StoreBooking>>;
  /** An array containing the unused upcoming reminders for the upcoming visits */
  upcoming_reminders: Array<Maybe<UpcomingVisitReminder>>;
  /** VIN */
  vin?: Maybe<Scalars['String']>;
  visits?: Maybe<CustomerVisits>;
  /** Vehicle model year */
  year?: Maybe<Scalars['String']>;
};


export type CustomerVehicleCompletedVisitsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type CustomerVehicleRemindersArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type CustomerVehicleVisitsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<StoreVisitsFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type CustomerVehicleSpecificInput = {
  /** Vehicle Color ID */
  color_id?: InputMaybe<Scalars['ID']>;
  /** Make this vehicle default vehicle for the customer */
  is_default?: InputMaybe<Scalars['Boolean']>;
  /** License plate number */
  license_number?: InputMaybe<Scalars['String']>;
  /** Vehicle model mileage */
  mileage?: InputMaybe<Scalars['String']>;
  /** Vehicle model year */
  model_year?: InputMaybe<Scalars['String']>;
  /** Vehicle Identification Number */
  vin?: InputMaybe<Scalars['String']>;
};

export type CustomerVehiclesOutput = {
  __typename?: 'CustomerVehiclesOutput';
  items?: Maybe<Array<Maybe<CustomerVehicle>>>;
  page_info?: Maybe<SearchResultPageInfo>;
  total_count?: Maybe<Scalars['Int']>;
};

export type CustomerVisits = {
  __typename?: 'CustomerVisits';
  /** An array containing the visits of the customer */
  items?: Maybe<Array<Maybe<Visit>>>;
  /** An object that includes the current_page, page_info, and page_size values specified in the query */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The total count of customer visits */
  total_count?: Maybe<Scalars['Int']>;
};

export type Customers = {
  __typename?: 'Customers';
  items?: Maybe<Array<Maybe<Customer>>>;
  page_info?: Maybe<SearchResultPageInfo>;
  total_count?: Maybe<Scalars['Int']>;
};

export type CustomersFilterInput = {
  email?: InputMaybe<FilterStringTypeInput>;
  id?: InputMaybe<FilterEqualTypeInput>;
  name?: InputMaybe<FilterStringTypeInput>;
  phone_number?: InputMaybe<FilterStringTypeInput>;
};

/** Contains information about a text area that is defined as part of a customizable option. */
export type CustomizableAreaOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableAreaOption';
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>;
  /** The Stock Keeping Unit of the base product. */
  product_sku?: Maybe<Scalars['String']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID'];
  /** An object that defines a text area. */
  value?: Maybe<CustomizableAreaValue>;
};

/** Defines the price and sku of a product whose page contains a customized text area. */
export type CustomizableAreaValue = {
  __typename?: 'CustomizableAreaValue';
  /** The maximum number of characters that can be entered for this customizable option. */
  max_characters?: Maybe<Scalars['Int']>;
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableAreaValue` object. */
  uid: Scalars['ID'];
};

/** Contains information about a set of checkbox values that are defined as part of a customizable option. */
export type CustomizableCheckboxOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableCheckboxOption';
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID'];
  /** An array that defines a set of checkbox values. */
  value?: Maybe<Array<Maybe<CustomizableCheckboxValue>>>;
};

/** Defines the price and sku of a product whose page contains a customized set of checkbox values. */
export type CustomizableCheckboxValue = {
  __typename?: 'CustomizableCheckboxValue';
  /** The ID assigned to the value. */
  option_type_id?: Maybe<Scalars['Int']>;
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']>;
  /** The order in which the checkbox value is displayed. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableCheckboxValue` object. */
  uid: Scalars['ID'];
};

/** Contains information about a date picker that is defined as part of a customizable option. */
export type CustomizableDateOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableDateOption';
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>;
  /** The Stock Keeping Unit of the base product. */
  product_sku?: Maybe<Scalars['String']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID'];
  /** An object that defines a date field in a customizable option. */
  value?: Maybe<CustomizableDateValue>;
};

/** Defines the customizable date type. */
export enum CustomizableDateTypeEnum {
  /** @deprecated  */
  Date = 'DATE',
  /** @deprecated  */
  DateTime = 'DATE_TIME',
  /** @deprecated  */
  Time = 'TIME'
}

/** Defines the price and sku of a product whose page contains a customized date picker. */
export type CustomizableDateValue = {
  __typename?: 'CustomizableDateValue';
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']>;
  /** DATE, DATE_TIME or TIME */
  type?: Maybe<CustomizableDateTypeEnum>;
  /** The unique ID for a `CustomizableDateValue` object. */
  uid: Scalars['ID'];
};

/** Contains information about a drop down menu that is defined as part of a customizable option. */
export type CustomizableDropDownOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableDropDownOption';
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID'];
  /** An array that defines the set of options for a drop down menu. */
  value?: Maybe<Array<Maybe<CustomizableDropDownValue>>>;
};

/** Defines the price and sku of a product whose page contains a customized drop down menu. */
export type CustomizableDropDownValue = {
  __typename?: 'CustomizableDropDownValue';
  /** The ID assigned to the value. */
  option_type_id?: Maybe<Scalars['Int']>;
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableDropDownValue` object. */
  uid: Scalars['ID'];
};

/** Contains information about a text field that is defined as part of a customizable option. */
export type CustomizableFieldOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableFieldOption';
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>;
  /** The Stock Keeping Unit of the base product. */
  product_sku?: Maybe<Scalars['String']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID'];
  /** An object that defines a text field. */
  value?: Maybe<CustomizableFieldValue>;
};

/** Defines the price and sku of a product whose page contains a customized text field. */
export type CustomizableFieldValue = {
  __typename?: 'CustomizableFieldValue';
  /** The maximum number of characters that can be entered for this customizable option. */
  max_characters?: Maybe<Scalars['Int']>;
  /** The price of the custom value. */
  price?: Maybe<Scalars['Float']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableFieldValue` object. */
  uid: Scalars['ID'];
};

/** Contains information about a file picker that is defined as part of a customizable option. */
export type CustomizableFileOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableFileOption';
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>;
  /** The Stock Keeping Unit of the base product. */
  product_sku?: Maybe<Scalars['String']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID'];
  /** An object that defines a file value. */
  value?: Maybe<CustomizableFileValue>;
};

/** Defines the price and sku of a product whose page contains a customized file picker. */
export type CustomizableFileValue = {
  __typename?: 'CustomizableFileValue';
  /** The file extension to accept. */
  file_extension?: Maybe<Scalars['String']>;
  /** The maximum width of an image. */
  image_size_x?: Maybe<Scalars['Int']>;
  /** The maximum height of an image. */
  image_size_y?: Maybe<Scalars['Int']>;
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableFileValue` object. */
  uid: Scalars['ID'];
};

/** Contains information about a multiselect that is defined as part of a customizable option. */
export type CustomizableMultipleOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableMultipleOption';
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID'];
  /** An array that defines the set of options for a multiselect. */
  value?: Maybe<Array<Maybe<CustomizableMultipleValue>>>;
};

/** Defines the price and sku of a product whose page contains a customized multiselect. */
export type CustomizableMultipleValue = {
  __typename?: 'CustomizableMultipleValue';
  /** The ID assigned to the value. */
  option_type_id?: Maybe<Scalars['Int']>;
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableMultipleValue` object. */
  uid: Scalars['ID'];
};

/** Defines a customizable option. */
export type CustomizableOptionInput = {
  /** The customizable option ID of the product. */
  id?: InputMaybe<Scalars['Int']>;
  /** The string value of the option. */
  value_string: Scalars['String'];
};

/** Contains basic information about a customizable option. It can be implemented by several types of configurable options. */
export type CustomizableOptionInterface = {
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID'];
};

/** Contains information about customizable product options. */
export type CustomizableProductInterface = {
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
};

/** Contains information about a set of radio buttons that are defined as part of a customizable option. */
export type CustomizableRadioOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableRadioOption';
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID'];
  /** An array that defines a set of radio buttons. */
  value?: Maybe<Array<Maybe<CustomizableRadioValue>>>;
};

/** Defines the price and sku of a product whose page contains a customized set of radio buttons. */
export type CustomizableRadioValue = {
  __typename?: 'CustomizableRadioValue';
  /** The ID assigned to the value. */
  option_type_id?: Maybe<Scalars['Int']>;
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']>;
  /** The order in which the radio button is displayed. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableRadioValue` object. */
  uid: Scalars['ID'];
};

export type Day = {
  __typename?: 'Day';
  intervals?: Maybe<Array<Maybe<Interval>>>;
  timestamp: Scalars['String'];
};

/** Contains the results of the request to delete a compare list. */
export type DeleteCompareListOutput = {
  __typename?: 'DeleteCompareListOutput';
  /** Indicates whether the compare list was successfully deleted. */
  result: Scalars['Boolean'];
};

/** Indicates whether the request succeeded and returns the remaining customer payment tokens. */
export type DeletePaymentTokenOutput = {
  __typename?: 'DeletePaymentTokenOutput';
  /** A container for the customer's remaining payment tokens. */
  customerPaymentTokens?: Maybe<CustomerPaymentTokens>;
  /** Indicates whether the request succeeded. */
  result: Scalars['Boolean'];
};

export type DeliveryBounds = {
  __typename?: 'DeliveryBounds';
  /** In days */
  lower_limit?: Maybe<Scalars['Int']>;
  /** In days */
  upper_limit?: Maybe<Scalars['Int']>;
};

export type DeliveryDetails = {
  __typename?: 'DeliveryDetails';
  comment?: Maybe<Scalars['String']>;
  delivery_day_timestamp?: Maybe<Scalars['String']>;
  delivery_interval_option?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
};

/** Defines an individual discount. A discount can be applied to the cart as a whole or to an item. */
export type Discount = {
  __typename?: 'Discount';
  /** The amount of the discount. */
  amount: Money;
  /** A description of the discount. */
  label: Scalars['String'];
};

export enum DiscountType {
  /** @deprecated  */
  Fixed = 'FIXED',
  /** @deprecated  */
  Percentage = 'PERCENTAGE'
}

/** An implementation for downloadable product cart items. */
export type DownloadableCartItem = CartItemInterface & {
  __typename?: 'DownloadableCartItem';
  /** Information about the booking of this item */
  booked_service?: Maybe<BookedService>;
  /** An array containing the customizable options the shopper selected. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>;
  /** @deprecated Use `uid` instead. */
  id: Scalars['String'];
  /** An array containing information about the links for the downloadable product added to the cart. */
  links?: Maybe<Array<Maybe<DownloadableProductLinks>>>;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>;
  /** Details about an item in the cart. */
  product: ProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float'];
  /** An array containing information about samples of the selected downloadable product. */
  samples?: Maybe<Array<Maybe<DownloadableProductSamples>>>;
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID'];
};

/** Defines downloadable product options for `CreditMemoItemInterface`. */
export type DownloadableCreditMemoItem = CreditMemoItemInterface & {
  __typename?: 'DownloadableCreditMemoItem';
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** A list of downloadable links that are refunded from the downloadable product. */
  downloadable_links?: Maybe<Array<Maybe<DownloadableItemsLinks>>>;
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars['ID'];
  /** The order item the credit memo is applied to. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price for the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']>;
};

export enum DownloadableFileTypeEnum {
  /** @deprecated `sample_url` serves to get the downloadable sample */
  File = 'FILE',
  /** @deprecated `sample_url` serves to get the downloadable sample */
  Url = 'URL'
}

/** Defines downloadable product options for `InvoiceItemInterface`. */
export type DownloadableInvoiceItem = InvoiceItemInterface & {
  __typename?: 'DownloadableInvoiceItem';
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** A list of downloadable links that are invoiced from the downloadable product. */
  downloadable_links?: Maybe<Array<Maybe<DownloadableItemsLinks>>>;
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars['ID'];
  /** Details about an individual order item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price for the base product including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']>;
};

/** Defines characteristics of the links for downloadable product. */
export type DownloadableItemsLinks = {
  __typename?: 'DownloadableItemsLinks';
  /** A number indicating the sort order. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name of the link. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `DownloadableItemsLinks` object. */
  uid: Scalars['ID'];
};

/** Defines downloadable product options for `OrderItemInterface`. */
export type DownloadableOrderItem = OrderItemInterface & {
  __typename?: 'DownloadableOrderItem';
  /** Information about the booking of this item */
  booked_service?: Maybe<BookedService>;
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** A list of downloadable links that are ordered from the downloadable product. */
  downloadable_links?: Maybe<Array<Maybe<DownloadableItemsLinks>>>;
  /** The entered option for the base product, such as a logo or image. */
  entered_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The selected gift message for the order item */
  gift_message?: Maybe<GiftMessage>;
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars['ID'];
  /** The categories assigned to the product. */
  product_categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** The URL of the main product image of the base product */
  product_image_url?: Maybe<Scalars['String']>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The original price of the base product */
  product_original_price: Money;
  /** The sale price of the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The URL of the thumbnail image of the base product */
  product_thumbnail_url?: Maybe<Scalars['String']>;
  /** The type of product, such as simple, configurable, etc. */
  product_type?: Maybe<Scalars['String']>;
  /** URL key of the base product. */
  product_url_key?: Maybe<Scalars['String']>;
  /** The number of canceled items. */
  quantity_canceled?: Maybe<Scalars['Float']>;
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']>;
  /** The number of units ordered for this item. */
  quantity_ordered?: Maybe<Scalars['Float']>;
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']>;
  /** The number of returned items. */
  quantity_returned?: Maybe<Scalars['Float']>;
  /** The number of shipped items. */
  quantity_shipped?: Maybe<Scalars['Float']>;
  /** The selected options for the base product, such as color or size. */
  selected_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The status of the order item. */
  status?: Maybe<Scalars['String']>;
};

/** Defines a product that the shopper downloads. */
export type DownloadableProduct = CustomizableProductInterface & ProductInterface & RoutableInterface & {
  __typename?: 'DownloadableProduct';
  /** @deprecated Use the `custom_attributes` field instead. */
  ampere?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  aspect_ratio?: Maybe<Scalars['Int']>;
  /** Attribute set information */
  attribute_set?: Maybe<AttributeSetInformation>;
  /**
   * The attribute set assigned to the product.
   * @deprecated The field should not be used on the storefront.
   */
  attribute_set_id?: Maybe<Scalars['Int']>;
  /** List of product attributes */
  attributes?: Maybe<Array<Maybe<CustomAttribute>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  average_duration?: Maybe<Scalars['String']>;
  /** Attributes regarding this bookable service in the given store locator. */
  bookable_service?: Maybe<BookableService>;
  /** The product brand. */
  brand?: Maybe<Brand>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
  canonical_url?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  car_batteries_ampere?: Maybe<Scalars['Int']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  color?: Maybe<Scalars['Int']>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  country_of_origin?: Maybe<Scalars['Int']>;
  /**
   * Timestamp indicating when the product was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  creation_date?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  creation_id?: Maybe<Scalars['Int']>;
  /** Crosssell Products */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /**
   * List of product custom labels
   * @deprecated Use the `custom_attributes` field instead.
   */
  custom_labels: Array<Maybe<Label>>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  /** @deprecated Use the `custom_attributes` field instead. */
  diameter?: Maybe<Scalars['Int']>;
  /** An array containing information about the links for this downloadable product. */
  downloadable_product_links?: Maybe<Array<Maybe<DownloadableProductLinks>>>;
  /** An array containing information about samples of this downloadable product. */
  downloadable_product_samples?: Maybe<Array<Maybe<DownloadableProductSamples>>>;
  expected_shipping_fees?: Maybe<Scalars['Float']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  exterior_hand_wash?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_age_group?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_age_range?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_baby_food_stage?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_brand?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_capacity?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_color?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_compatible_devices?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_decor_style?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_digital_zoom?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_display_technology?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_finish?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_gemstone?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_gender?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_health_concern?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_ingredients?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_is_assembly_required?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_material?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_maximum_weight?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_megapixels?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_minimum_weight?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_model?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_number_of_licenses?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_operating_system?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_optical_zoom?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_package_quantity?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_pattern?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_depth?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_form?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_height?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_length?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_weight?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_width?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_recommended_use?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_resolution?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_scent?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_screen_size?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_shoe_width?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_size?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_storage_capacity?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_style?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_system_requirements?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_thread_count?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_video_game_platform?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  featured_order?: Maybe<Scalars['Int']>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  has_deal?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  hover_cleaning?: Maybe<Scalars['Int']>;
  /**
   * The ID number assigned to the product.
   * @deprecated Use the `uid` field instead.
   */
  id?: Maybe<Scalars['Int']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** @deprecated Use the `custom_attributes` field instead. */
  in_store_only?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  interior_cleaning?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  interior_vacuum_clean?: Maybe<Scalars['Int']>;
  /** Check if product is a best seller */
  is_best_seller?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  is_bookable_service?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  is_bookable_service_addon?: Maybe<Scalars['Int']>;
  /** if the product favorited by the logged in user */
  is_favorited?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  is_featured?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  is_featured_offer?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  is_november_deal?: Maybe<Scalars['Int']>;
  is_van_installment_enabled: Scalars['Boolean'];
  /** Indicates whether the product is the wiper that has the gift or not. */
  is_wiper: Scalars['Boolean'];
  /** product labels */
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A value of 1 indicates that each link in the array must be purchased separately. */
  links_purchased_separately?: Maybe<Scalars['Int']>;
  /** The heading above the list of downloadable products. */
  links_title?: Maybe<Scalars['String']>;
  /**
   * A number representing the product's manufacturer.
   * @deprecated Use the `custom_attributes` field instead.
   */
  manufacturer?: Maybe<Scalars['Int']>;
  /** An array of media gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use `media_gallery` instead.
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  mileage_warranty?: Maybe<Scalars['String']>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']>;
  /** Quantity of product left in customer's choosen source */
  only_x_left_in_source?: Maybe<Scalars['Float']>;
  /** Product stock only x left count */
  only_x_left_in_stock?: Maybe<Scalars['Float']>;
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  pattern?: Maybe<Scalars['String']>;
  /**
   * Indicates the price of an item.
   * @deprecated Use `price_range` for product price information.
   */
  price?: Maybe<ProductPrices>;
  /** The range of prices for the product */
  price_range: PriceRange;
  /** An array of `TierPrice` objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_brand_id?: Maybe<Scalars['Int']>;
  /** An array of `ProductLinks` objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  product_offer_type?: Maybe<Scalars['Int']>;
  /** The average of all the ratings given to the product. */
  rating_summary: Scalars['Float'];
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int'];
  /** Related Products */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']>;
  /** The total count of all the reviews given to the product. */
  review_count: Scalars['Int'];
  /** The list of products reviews. */
  reviews: ProductReviews;
  /** @deprecated Use the `custom_attributes` field instead. */
  serving_order?: Maybe<Scalars['Int']>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  /**
   * The beginning date that a product has a special price.
   * @deprecated The field should not be used on the storefront.
   */
  special_from_date?: Maybe<Scalars['String']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']>;
  /** Time left for expiry of special price in seconds */
  special_price_time_left?: Maybe<Scalars['Int']>;
  /** The end date for a product with a special price. */
  special_to_date?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  speed?: Maybe<Scalars['String']>;
  /** List of product attributes */
  stockQtyTerm?: Maybe<Array<Maybe<ProductStockQty>>>;
  /** Stock status of the product */
  stock_status?: Maybe<ProductStockStatus>;
  /** The file name of a swatch image. */
  swatch_image?: Maybe<Scalars['String']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  type?: Maybe<Scalars['Int']>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use `__typename` instead.
   */
  type_id?: Maybe<Scalars['String']>;
  /** The unique ID for a `ProductInterface` object. */
  uid: Scalars['ID'];
  /**
   * Timestamp indicating when the product was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']>;
  /** Upsell Products */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  width?: Maybe<Scalars['Int']>;
};


/** Defines a product that the shopper downloads. */
export type DownloadableProductAttributesArgs = {
  groupCode?: InputMaybe<Scalars['String']>;
};


/** Defines a product that the shopper downloads. */
export type DownloadableProductBookable_ServiceArgs = {
  storeLocatorId?: InputMaybe<Scalars['Int']>;
};


/** Defines a product that the shopper downloads. */
export type DownloadableProductExpected_Shipping_FeesArgs = {
  sourceCode?: InputMaybe<Scalars['String']>;
};


/** Defines a product that the shopper downloads. */
export type DownloadableProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** Defines a single downloadable product. */
export type DownloadableProductCartItemInput = {
  /** The ID and value of the option. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  /** The quantity and SKU of the downloadable product. */
  data: CartItemInput;
  /** An array of objects containing the link_id of the downloadable product link. */
  downloadable_product_links?: InputMaybe<Array<InputMaybe<DownloadableProductLinksInput>>>;
};

/** Defines characteristics of a downloadable product. */
export type DownloadableProductLinks = {
  __typename?: 'DownloadableProductLinks';
  /** @deprecated This information should not be exposed on frontend. */
  id?: Maybe<Scalars['Int']>;
  /** @deprecated This information should not be exposed on frontend. */
  is_shareable?: Maybe<Scalars['Boolean']>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  link_type?: Maybe<DownloadableFileTypeEnum>;
  /** @deprecated This information should not be exposed on frontend. */
  number_of_downloads?: Maybe<Scalars['Int']>;
  /** The price of the downloadable product. */
  price?: Maybe<Scalars['Float']>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sample_file?: Maybe<Scalars['String']>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sample_type?: Maybe<DownloadableFileTypeEnum>;
  /** The full URL to the downloadable sample. */
  sample_url?: Maybe<Scalars['String']>;
  /** A number indicating the sort order. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name of the link. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `DownloadableProductLinks` object. */
  uid: Scalars['ID'];
};

/** Contains the link ID for the downloadable product. */
export type DownloadableProductLinksInput = {
  /** The unique ID of the downloadable product link. */
  link_id: Scalars['Int'];
};

/** Defines characteristics of a downloadable product. */
export type DownloadableProductSamples = {
  __typename?: 'DownloadableProductSamples';
  /** @deprecated This information should not be exposed on frontend. */
  id?: Maybe<Scalars['Int']>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sample_file?: Maybe<Scalars['String']>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sample_type?: Maybe<DownloadableFileTypeEnum>;
  /** The full URL to the downloadable sample. */
  sample_url?: Maybe<Scalars['String']>;
  /** A number indicating the sort order. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name of the sample. */
  title?: Maybe<Scalars['String']>;
};

/** A downloadable product wish list item. */
export type DownloadableWishlistItem = WishlistItemInterface & {
  __typename?: 'DownloadableWishlistItem';
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String'];
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars['String']>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID'];
  /** An array containing information about the selected links. */
  links_v2?: Maybe<Array<Maybe<DownloadableProductLinks>>>;
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars['Float'];
  /** An array containing information about the selected samples. */
  samples?: Maybe<Array<Maybe<DownloadableProductSamples>>>;
};

export enum DurationEnum {
  /** @deprecated  */
  Last_7Days = 'LAST_7_DAYS',
  /** @deprecated  */
  Last_30Days = 'LAST_30_DAYS',
  /** @deprecated  */
  Today = 'TODAY',
  /** @deprecated  */
  Yesterday = 'YESTERDAY'
}

export type EditOrderOutput = {
  __typename?: 'EditOrderOutput';
  order?: Maybe<CustomerOrder>;
};

export type EditUpcomingVisitReminderInput = {
  comment?: InputMaybe<Scalars['String']>;
  reminder_date?: InputMaybe<Scalars['String']>;
  service_sku?: InputMaybe<Scalars['String']>;
};

/** Defines a customer-entered option. */
export type EnteredOptionInput = {
  /** The unique ID for a `CustomizableOptionInterface` object, such as a `CustomizableFieldOption`, `CustomizableFileOption`, or `CustomizableAreaOption` object. */
  uid: Scalars['ID'];
  /** Text the customer entered. */
  value: Scalars['String'];
};

export enum EntityType {
  /** @deprecated  */
  CatalogCategory = 'CATALOG_CATEGORY',
  /** @deprecated  */
  CatalogProduct = 'CATALOG_PRODUCT',
  /** @deprecated  */
  Creditmemo = 'CREDITMEMO',
  /** @deprecated  */
  Customer = 'CUSTOMER',
  /** @deprecated  */
  CustomerAddress = 'CUSTOMER_ADDRESS',
  /** @deprecated  */
  Inspection = 'INSPECTION',
  /** @deprecated  */
  Invoice = 'INVOICE',
  /** @deprecated  */
  Order = 'ORDER',
  /** @deprecated  */
  Shipment = 'SHIPMENT',
  /** @deprecated  */
  UsedVehicleInspection = 'USED_VEHICLE_INSPECTION'
}

/** Contains the `uid`, `relative_url`, and `type` attributes. */
export type EntityUrl = {
  __typename?: 'EntityUrl';
  /** @deprecated Use `relative_url` instead. */
  canonical_url?: Maybe<Scalars['String']>;
  /** The unique ID for a `ProductInterface`, `CategoryInterface`, `CmsPage`, or similar object associated with the specified URL. This could be a product, category, or CMS page UID. */
  entity_uid?: Maybe<Scalars['ID']>;
  /**
   * The ID assigned to the object associated with the specified url. This could be a product ID, category ID, or page ID.
   * @deprecated Use `entity_uid` instead.
   */
  id?: Maybe<Scalars['Int']>;
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirectCode?: Maybe<Scalars['Int']>;
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
};

export type ErrorInterface = {
  /** The returned error message. */
  message: Scalars['String'];
};

export type Evoucher = {
  __typename?: 'Evoucher';
  code?: Maybe<Scalars['String']>;
  coupon_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expires_on?: Maybe<Scalars['String']>;
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  ready_on?: Maybe<Scalars['String']>;
  redeemed_in?: Maybe<Scalars['String']>;
  redeemed_on?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  to_date?: Maybe<Scalars['String']>;
};

/** Identifies the filter to use for filtering evouchers. */
export type EvouchersFilterInput = {
  client_informed?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Status>;
};

/** Lists the exchange rate. */
export type ExchangeRate = {
  __typename?: 'ExchangeRate';
  /** Specifies the store’s default currency to exchange to. */
  currency_to?: Maybe<Scalars['String']>;
  /** The exchange rate for the store’s default currency. */
  rate?: Maybe<Scalars['Float']>;
};

export type ExternalWordpressPost = {
  __typename?: 'ExternalWordpressPost';
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type Faq = {
  __typename?: 'FAQ';
  body: Scalars['String'];
  category?: Maybe<FaqCategory>;
  code?: Maybe<FaqCode>;
  id: Scalars['Int'];
  slug?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type FaqCategory = {
  __typename?: 'FAQCategory';
  icon?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  slug?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type FaqCode = {
  __typename?: 'FAQCode';
  code: Scalars['String'];
  id: Scalars['Int'];
};

export enum FcmChannelEnum {
  /** @deprecated  */
  Android = 'ANDROID',
  /** @deprecated  */
  Ios = 'IOS',
  /** @deprecated  */
  Web = 'WEB'
}

export type FilterBookingStatusInput = {
  eq?: InputMaybe<BookingStatus>;
  in?: InputMaybe<Array<InputMaybe<BookingStatus>>>;
  neq?: InputMaybe<BookingStatus>;
  nin?: InputMaybe<Array<InputMaybe<BookingStatus>>>;
};

/** Defines a filter that matches the input exactly. */
export type FilterEqualTypeInput = {
  /** Use this attribute to exactly match the specified string. For example, to filter on a specific category ID, specify a value such as `5`. */
  eq?: InputMaybe<Scalars['String']>;
  /** Use this attribute to filter on an array of values. For example, to filter on category IDs 4, 5, and 6, specify a value of `["4", "5", "6"]`. */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Defines a filter that performs a fuzzy search. */
export type FilterMatchTypeInput = {
  /** Use this attribute to exactly match the specified string. For example, to filter on a specific SKU, specify a value such as `24-MB01`. */
  match?: InputMaybe<Scalars['String']>;
};

/** Defines a filter that matches a range of values, such as prices or dates. */
export type FilterRangeTypeInput = {
  /** Use this attribute to specify the lowest possible value in the range. */
  from?: InputMaybe<Scalars['String']>;
  /** Use this attribute to specify the highest possible value in the range. */
  to?: InputMaybe<Scalars['String']>;
};

/** Defines a filter for an input string. */
export type FilterStringTypeInput = {
  /** Filters items that are exactly the same as the specified string. */
  eq?: InputMaybe<Scalars['String']>;
  /** Filters items that are exactly the same as entries specified in an array of strings. */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Defines a filter that performs a fuzzy search using the specified string. */
  match?: InputMaybe<Scalars['String']>;
};

/** Defines the comparison operators that can be used in a filter. */
export type FilterTypeInput = {
  /** Equals. */
  eq?: InputMaybe<Scalars['String']>;
  finset?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** From. Must be used with the `to` field. */
  from?: InputMaybe<Scalars['String']>;
  /** Greater than. */
  gt?: InputMaybe<Scalars['String']>;
  /** Greater than or equal to. */
  gteq?: InputMaybe<Scalars['String']>;
  /** In. The value can contain a set of comma-separated values. */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Like. The specified value can contain % (percent signs) to allow matching of 0 or more characters. */
  like?: InputMaybe<Scalars['String']>;
  /** Less than. */
  lt?: InputMaybe<Scalars['String']>;
  /** Less than or equal to. */
  lteq?: InputMaybe<Scalars['String']>;
  /** More than or equal to. */
  moreq?: InputMaybe<Scalars['String']>;
  /** Not equal to. */
  neq?: InputMaybe<Scalars['String']>;
  /** Not in. The value can contain a set of comma-separated values. */
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Not null. */
  notnull?: InputMaybe<Scalars['String']>;
  /** Is null. */
  null?: InputMaybe<Scalars['String']>;
  /** To. Must be used with the `from` field. */
  to?: InputMaybe<Scalars['String']>;
};

export type FindStoreOutput = {
  __typename?: 'FindStoreOutput';
  store?: Maybe<StoreLocator>;
};

/** A single FPT that can be applied to a product price. */
export type FixedProductTax = {
  __typename?: 'FixedProductTax';
  /** The amount of the Fixed Product Tax. */
  amount?: Maybe<Money>;
  /** The display label assigned to the Fixed Product Tax. */
  label?: Maybe<Scalars['String']>;
};

/** Lists display settings for the Fixed Product Tax. */
export enum FixedProductTaxDisplaySettings {
  /**
   * The displayed price does not include the FPT amount. The values of `ProductPrice.fixed_product_taxes` and the price including the FPT are displayed separately. This value corresponds to 'Excluding FPT, Including FPT description and final price.'
   * @deprecated
   */
  ExcludeFptAndIncludeWithDetails = 'EXCLUDE_FPT_AND_INCLUDE_WITH_DETAILS',
  /**
   * The displayed price does not include the FPT amount. The values from `ProductPrice.fixed_product_taxes` are not displayed. This value corresponds to 'Excluding FPT'.
   * @deprecated
   */
  ExcludeFptWithoutDetails = 'EXCLUDE_FPT_WITHOUT_DETAILS',
  /**
   * The FPT feature is not enabled. You can omit `ProductPrice.fixed_product_taxes` from your query.
   * @deprecated
   */
  FptDisabled = 'FPT_DISABLED',
  /**
   * The displayed price includes the FPT amount without displaying the `ProductPrice.fixed_product_taxes` values. This value corresponds to 'Including FPT only'.
   * @deprecated
   */
  IncludeFptWithoutDetails = 'INCLUDE_FPT_WITHOUT_DETAILS',
  /**
   * The displayed price includes the FPT amount while displaying the values of `ProductPrice.fixed_product_taxes` separately. This value corresponds to 'Including FPT and FPT description'.
   * @deprecated
   */
  IncludeFptWithDetails = 'INCLUDE_FPT_WITH_DETAILS'
}

export type GarageAnalytics = {
  __typename?: 'GarageAnalytics';
  /** The best selling products for the given period */
  bestSellingProducts: Array<Maybe<BestSellingProduct>>;
  /** The best selling services for the given period */
  bestSellingServices: Array<Maybe<BestSellingProduct>>;
  /** The total number of bookings */
  bookingsCount: Scalars['Int'];
  /** The revenue for the given period */
  revenue: Array<Maybe<PeriodCount>>;
  /** The number of vehicles for the given period */
  vehiclesCount: Array<Maybe<PeriodCount>>;
  /** The total number of visits */
  visitsCount: Scalars['Int'];
};

/** Identifies which customer requires remote shopping assistance. */
export type GenerateCustomerTokenAsAdminInput = {
  /** The email address of the customer requesting remote shopping assistance. */
  customer_email: Scalars['String'];
};

/** Contains the generated customer token. */
export type GenerateCustomerTokenAsAdminOutput = {
  __typename?: 'GenerateCustomerTokenAsAdminOutput';
  /** The generated customer token. */
  customer_token: Scalars['String'];
};

export type GetPhoneNumberByEmailOutput = {
  __typename?: 'GetPhoneNumberByEmailOutput';
  phone_number: Scalars['String'];
};

/** Contains the text of a gift message, its sender, and recipient */
export type GiftMessage = {
  __typename?: 'GiftMessage';
  /** Sender name */
  from: Scalars['String'];
  /** Gift message text */
  message: Scalars['String'];
  /** Recipient name */
  to: Scalars['String'];
};

/** Contains the text of a gift message, its sender, and recipient */
export type GiftMessageInput = {
  /** Sender name */
  from: Scalars['String'];
  /** Gift message text */
  message: Scalars['String'];
  /** Recipient name */
  to: Scalars['String'];
};

/** Defines a grouped product, which consists of simple standalone products that are presented as a group. */
export type GroupedProduct = PhysicalProductInterface & ProductInterface & RoutableInterface & {
  __typename?: 'GroupedProduct';
  /** @deprecated Use the `custom_attributes` field instead. */
  ampere?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  aspect_ratio?: Maybe<Scalars['Int']>;
  /** Attribute set information */
  attribute_set?: Maybe<AttributeSetInformation>;
  /**
   * The attribute set assigned to the product.
   * @deprecated The field should not be used on the storefront.
   */
  attribute_set_id?: Maybe<Scalars['Int']>;
  /** List of product attributes */
  attributes?: Maybe<Array<Maybe<CustomAttribute>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  average_duration?: Maybe<Scalars['String']>;
  /** Attributes regarding this bookable service in the given store locator. */
  bookable_service?: Maybe<BookableService>;
  /** The product brand. */
  brand?: Maybe<Brand>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
  canonical_url?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  car_batteries_ampere?: Maybe<Scalars['Int']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  color?: Maybe<Scalars['Int']>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  country_of_origin?: Maybe<Scalars['Int']>;
  /**
   * Timestamp indicating when the product was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  creation_date?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  creation_id?: Maybe<Scalars['Int']>;
  /** Crosssell Products */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /**
   * List of product custom labels
   * @deprecated Use the `custom_attributes` field instead.
   */
  custom_labels: Array<Maybe<Label>>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  /** @deprecated Use the `custom_attributes` field instead. */
  diameter?: Maybe<Scalars['Int']>;
  expected_shipping_fees?: Maybe<Scalars['Float']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  exterior_hand_wash?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_age_group?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_age_range?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_baby_food_stage?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_brand?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_capacity?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_color?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_compatible_devices?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_decor_style?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_digital_zoom?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_display_technology?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_finish?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_gemstone?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_gender?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_health_concern?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_ingredients?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_is_assembly_required?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_material?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_maximum_weight?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_megapixels?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_minimum_weight?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_model?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_number_of_licenses?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_operating_system?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_optical_zoom?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_package_quantity?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_pattern?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_depth?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_form?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_height?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_length?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_weight?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_width?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_recommended_use?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_resolution?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_scent?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_screen_size?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_shoe_width?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_size?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_storage_capacity?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_style?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_system_requirements?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_thread_count?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_video_game_platform?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  featured_order?: Maybe<Scalars['Int']>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  has_deal?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  hover_cleaning?: Maybe<Scalars['Int']>;
  /**
   * The ID number assigned to the product.
   * @deprecated Use the `uid` field instead.
   */
  id?: Maybe<Scalars['Int']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** @deprecated Use the `custom_attributes` field instead. */
  in_store_only?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  interior_cleaning?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  interior_vacuum_clean?: Maybe<Scalars['Int']>;
  /** Check if product is a best seller */
  is_best_seller?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  is_bookable_service?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  is_bookable_service_addon?: Maybe<Scalars['Int']>;
  /** if the product favorited by the logged in user */
  is_favorited?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  is_featured?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  is_featured_offer?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  is_november_deal?: Maybe<Scalars['Int']>;
  is_van_installment_enabled: Scalars['Boolean'];
  /** Indicates whether the product is the wiper that has the gift or not. */
  is_wiper: Scalars['Boolean'];
  /** An array containing grouped product items. */
  items?: Maybe<Array<Maybe<GroupedProductItem>>>;
  /** product labels */
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * A number representing the product's manufacturer.
   * @deprecated Use the `custom_attributes` field instead.
   */
  manufacturer?: Maybe<Scalars['Int']>;
  /** An array of media gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use `media_gallery` instead.
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  mileage_warranty?: Maybe<Scalars['String']>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']>;
  /** Quantity of product left in customer's choosen source */
  only_x_left_in_source?: Maybe<Scalars['Float']>;
  /** Product stock only x left count */
  only_x_left_in_stock?: Maybe<Scalars['Float']>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  pattern?: Maybe<Scalars['String']>;
  /**
   * Indicates the price of an item.
   * @deprecated Use `price_range` for product price information.
   */
  price?: Maybe<ProductPrices>;
  /** The range of prices for the product */
  price_range: PriceRange;
  /** An array of `TierPrice` objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_brand_id?: Maybe<Scalars['Int']>;
  /** An array of `ProductLinks` objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  product_offer_type?: Maybe<Scalars['Int']>;
  /** The average of all the ratings given to the product. */
  rating_summary: Scalars['Float'];
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int'];
  /** Related Products */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']>;
  /** The total count of all the reviews given to the product. */
  review_count: Scalars['Int'];
  /** The list of products reviews. */
  reviews: ProductReviews;
  /** @deprecated Use the `custom_attributes` field instead. */
  serving_order?: Maybe<Scalars['Int']>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  /**
   * The beginning date that a product has a special price.
   * @deprecated The field should not be used on the storefront.
   */
  special_from_date?: Maybe<Scalars['String']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']>;
  /** Time left for expiry of special price in seconds */
  special_price_time_left?: Maybe<Scalars['Int']>;
  /** The end date for a product with a special price. */
  special_to_date?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  speed?: Maybe<Scalars['String']>;
  /** List of product attributes */
  stockQtyTerm?: Maybe<Array<Maybe<ProductStockQty>>>;
  /** Stock status of the product */
  stock_status?: Maybe<ProductStockStatus>;
  /** The file name of a swatch image. */
  swatch_image?: Maybe<Scalars['String']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  type?: Maybe<Scalars['Int']>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use `__typename` instead.
   */
  type_id?: Maybe<Scalars['String']>;
  /** The unique ID for a `ProductInterface` object. */
  uid: Scalars['ID'];
  /**
   * Timestamp indicating when the product was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']>;
  /** Upsell Products */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
  /** The weight of the item, in units defined by the store. */
  weight?: Maybe<Scalars['Float']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  width?: Maybe<Scalars['Int']>;
};


/** Defines a grouped product, which consists of simple standalone products that are presented as a group. */
export type GroupedProductAttributesArgs = {
  groupCode?: InputMaybe<Scalars['String']>;
};


/** Defines a grouped product, which consists of simple standalone products that are presented as a group. */
export type GroupedProductBookable_ServiceArgs = {
  storeLocatorId?: InputMaybe<Scalars['Int']>;
};


/** Defines a grouped product, which consists of simple standalone products that are presented as a group. */
export type GroupedProductExpected_Shipping_FeesArgs = {
  sourceCode?: InputMaybe<Scalars['String']>;
};


/** Defines a grouped product, which consists of simple standalone products that are presented as a group. */
export type GroupedProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** Contains information about an individual grouped product item. */
export type GroupedProductItem = {
  __typename?: 'GroupedProductItem';
  /** The relative position of this item compared to the other group items. */
  position?: Maybe<Scalars['Int']>;
  /** Details about this product option. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this grouped product item. */
  qty?: Maybe<Scalars['Float']>;
};

/** A grouped product wish list item. */
export type GroupedProductWishlistItem = WishlistItemInterface & {
  __typename?: 'GroupedProductWishlistItem';
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String'];
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars['String']>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID'];
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars['Float'];
};

/** Contains a set of relative URLs that PayPal uses in response to various actions during the authorization process. Magento prepends the base URL to this value to create a full URL. For example, if the full URL is https://www.example.com/path/to/page.html, the relative URL is path/to/page.html. Use this input for Payments Pro Hosted Solution payment method. */
export type HostedProInput = {
  /** The relative URL of the page that PayPal redirects to when the buyer cancels the transaction in order to choose a different payment method. For example, if the full URL to this page is https://www.example.com/paypal/action/cancel.html, the relative URL is paypal/action/cancel.html. */
  cancel_url: Scalars['String'];
  /** The relative URL of the final confirmation page that PayPal redirects to upon payment success. For example, if the full URL to this page is https://www.example.com/paypal/action/return.html, the relative URL is paypal/action/return.html. */
  return_url: Scalars['String'];
};

/** Contains the secure URL used for the Payments Pro Hosted Solution payment method. */
export type HostedProUrl = {
  __typename?: 'HostedProUrl';
  /** The secure URL generated by PayPal. */
  secure_form_url?: Maybe<Scalars['String']>;
};

/** Contains the required input to request the secure URL for Payments Pro Hosted Solution payment. */
export type HostedProUrlInput = {
  /** The unique ID that identifies the shopper's cart. */
  cart_id: Scalars['String'];
};

/** Contains target path parameters. */
export type HttpQueryParameter = {
  __typename?: 'HttpQueryParameter';
  /** A parameter name. */
  name?: Maybe<Scalars['String']>;
  /** A parameter value. */
  value?: Maybe<Scalars['String']>;
};

export type ImageSwatchData = SwatchDataInterface & {
  __typename?: 'ImageSwatchData';
  /** The URL assigned to the thumbnail of the swatch image. */
  thumbnail?: Maybe<Scalars['String']>;
  /** The value can be represented as color (HEX code), image link, or text. */
  value?: Maybe<Scalars['String']>;
};

export type InitiateJumpStartInput = {
  comment?: InputMaybe<Scalars['String']>;
  full_name: Scalars['String'];
  landmark?: InputMaybe<Scalars['String']>;
  lat: Scalars['Float'];
  long: Scalars['Float'];
  phone_number: Scalars['String'];
  /** Base64 representation of the battery photo */
  photo?: InputMaybe<Scalars['String']>;
};

export type InitiateJumpStartOutput = {
  __typename?: 'InitiateJumpStartOutput';
  cart: Cart;
  request_id: Scalars['ID'];
};

export type Inspection = {
  __typename?: 'Inspection';
  created_at: Scalars['String'];
  /** Inspection entity custom attributes metadata by attribute set. */
  customAttributeMetadata?: Maybe<CustomAttributeMetadata>;
  entity_id: Scalars['ID'];
  fields?: Maybe<Array<Maybe<InspectionField>>>;
  /** Initial Inspection entity custom attributes metadata. */
  initialCustomAttributeMetadata?: Maybe<CustomAttributeMetadata>;
  pdf_url?: Maybe<Scalars['String']>;
  updated_at: Scalars['String'];
  visit_id: Scalars['ID'];
};


export type InspectionCustomAttributeMetadataArgs = {
  attributeSet?: InputMaybe<Scalars['String']>;
};

export type InspectionAdditionalDataInput = {
  attribute_code: Scalars['String'];
  comment?: InputMaybe<Scalars['String']>;
  /** Base64 representation of image */
  image?: InputMaybe<Scalars['String']>;
  /** Base64 representation of images */
  images?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type InspectionField = {
  __typename?: 'InspectionField';
  attribute_code: Scalars['String'];
  comment?: Maybe<Scalars['String']>;
  /** Filepaths containing images */
  images?: Maybe<Array<Maybe<Scalars['String']>>>;
  value: Scalars['String'];
};

export type InspectionFieldInput = {
  attribute_code: Scalars['String'];
  comment?: InputMaybe<Scalars['String']>;
  /** Base64 representation of image */
  image?: InputMaybe<Scalars['String']>;
  /** Base64 representation of images */
  images?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value: Scalars['String'];
};

/** Contains an error message when an internal error occurred. */
export type InternalError = ErrorInterface & {
  __typename?: 'InternalError';
  /** The returned error message. */
  message: Scalars['String'];
};

export type Interval = {
  __typename?: 'Interval';
  availability: Scalars['Boolean'];
  from: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  to: Scalars['Int'];
};

/** Contains invoice details. */
export type Invoice = {
  __typename?: 'Invoice';
  /** Comments on the invoice. */
  comments?: Maybe<Array<Maybe<SalesCommentItem>>>;
  /** The unique ID for a `Invoice` object. */
  id: Scalars['ID'];
  /** Invoiced product details. */
  items?: Maybe<Array<Maybe<InvoiceItemInterface>>>;
  /** Sequential invoice number. */
  number: Scalars['String'];
  /** Invoice total amount details. */
  total?: Maybe<InvoiceTotal>;
};

export type InvoiceItem = InvoiceItemInterface & {
  __typename?: 'InvoiceItem';
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars['ID'];
  /** Details about an individual order item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price for the base product including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']>;
};

/** Contains detailes about invoiced items. */
export type InvoiceItemInterface = {
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars['ID'];
  /** Details about an individual order item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price for the base product including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']>;
};

/** Contains price details from an invoice. */
export type InvoiceTotal = {
  __typename?: 'InvoiceTotal';
  /** The final base grand total amount in the base currency. */
  base_grand_total: Money;
  /** The applied discounts to the invoice. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The final total amount, including shipping, discounts, and taxes. */
  grand_total: Money;
  /** Details about the shipping and handling costs for the invoice. */
  shipping_handling?: Maybe<ShippingHandling>;
  /** The subtotal of the invoice, excluding shipping, discounts, and taxes. */
  subtotal: Money;
  /** The invoice tax details. */
  taxes?: Maybe<Array<Maybe<TaxItem>>>;
  /** The shipping amount for the invoice. */
  total_shipping: Money;
  /** The amount of tax applied to the invoice. */
  total_tax: Money;
};

/** Contains the result of the `isEmailAvailable` query. */
export type IsEmailAvailableOutput = {
  __typename?: 'IsEmailAvailableOutput';
  /** Indicates whether the specified email address can be used to create a customer. */
  is_email_available?: Maybe<Scalars['Boolean']>;
};

/** A list of options of the selected bundle product. */
export type ItemSelectedBundleOption = {
  __typename?: 'ItemSelectedBundleOption';
  /**
   * The unique ID for a `ItemSelectedBundleOption` object.
   * @deprecated Use `uid` instead.
   */
  id: Scalars['ID'];
  /** The label of the option. */
  label: Scalars['String'];
  /** The unique ID for a `ItemSelectedBundleOption` object. */
  uid: Scalars['ID'];
  /** A list of products that represent the values of the parent option. */
  values?: Maybe<Array<Maybe<ItemSelectedBundleOptionValue>>>;
};

/** A list of values for the selected bundle product. */
export type ItemSelectedBundleOptionValue = {
  __typename?: 'ItemSelectedBundleOptionValue';
  /**
   * The unique ID for a `ItemSelectedBundleOptionValue` object.
   * @deprecated Use `uid` instead.
   */
  id: Scalars['ID'];
  /** The price of the child bundle product. */
  price: Money;
  /** The name of the child bundle product. */
  product_name: Scalars['String'];
  /** The SKU of the child bundle product. */
  product_sku: Scalars['String'];
  /** The number of this bundle product that were ordered. */
  quantity: Scalars['Float'];
  /** The unique ID for a `ItemSelectedBundleOptionValue` object. */
  uid: Scalars['ID'];
};

export type JsmInfo = {
  __typename?: 'JSMInfo';
  /** Available payment methods for paying for addons in the riders app */
  addons_payment_methods?: Maybe<Array<Maybe<AvailablePaymentMethod>>>;
  /** The image URL of the battery image if the order is JSM order */
  battery_image?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  /** The full name of the customer creating the request. */
  customer_fullname?: Maybe<Scalars['String']>;
  /** The phone number of the customer creating the request. */
  customer_phonenumber?: Maybe<Scalars['String']>;
  is_rescheduled: Scalars['Boolean'];
  /** The coordinates of the JSM customer */
  location?: Maybe<Coordinates>;
  /** The duration between request duration and current time in minutes. */
  order_age?: Maybe<Scalars['Int']>;
  /** The order number associated with the request. */
  order_number?: Maybe<Scalars['String']>;
  /** The remaining amount to be paid for the JSM request */
  outstanding_amount?: Maybe<Scalars['Float']>;
  /** The amount paid for the JSM request */
  paid_amount?: Maybe<Scalars['Float']>;
  request_id?: Maybe<Scalars['ID']>;
  /** The rider assigned to the JSM booking */
  rider?: Maybe<Admin>;
  /** The status of the request rider */
  status?: Maybe<JsmStatus>;
  status_history?: Maybe<Array<Maybe<JsmStatusHistory>>>;
  /** The store locator information for the JSM request */
  store_locator?: Maybe<StoreLocator>;
  /** The image URL of the tire image if the order is VS order */
  tire_image?: Maybe<Scalars['String']>;
  /** Get Used payment method for paying for Jump Start Me addons */
  used_addons_payment_method?: Maybe<OrderPaymentMethod>;
};


export type JsmInfoStatus_HistoryArgs = {
  sort?: InputMaybe<SortEnum>;
};

export type JsmRequestFilterInput = {
  from?: InputMaybe<Scalars['String']>;
  request_id?: InputMaybe<Scalars['ID']>;
  to?: InputMaybe<Scalars['String']>;
};

export type JsmRequestsStatusHistoryFilterInput = {
  booking_id?: InputMaybe<FilterStringTypeInput>;
  order_number?: InputMaybe<FilterStringTypeInput>;
  request_id?: InputMaybe<FilterStringTypeInput>;
  status?: InputMaybe<FilterStringTypeInput>;
  store_locator_id?: InputMaybe<FilterStringTypeInput>;
  user_id?: InputMaybe<FilterStringTypeInput>;
};

export enum JsmStatus {
  /** @deprecated  */
  Assigned = 'ASSIGNED',
  /** @deprecated  */
  Canceled = 'CANCELED',
  /** @deprecated  */
  Completed = 'COMPLETED',
  /** @deprecated  */
  Invoiced = 'INVOICED',
  /** @deprecated  */
  Moving = 'MOVING',
  /** @deprecated  */
  PendingCheckout = 'PENDING_CHECKOUT',
  /** @deprecated  */
  Rescheduled = 'RESCHEDULED',
  /** @deprecated  */
  Unassigned = 'UNASSIGNED',
  /** @deprecated  */
  WithClient = 'WITH_CLIENT'
}

export type JsmStatusHistory = {
  __typename?: 'JSMStatusHistory';
  admin?: Maybe<Admin>;
  booking_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['String']>;
  order_number?: Maybe<Scalars['String']>;
  request_id?: Maybe<Scalars['Int']>;
  status?: Maybe<JsmStatus>;
  store_locator_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

export type JsmStatusHistoryOutput = {
  __typename?: 'JSMStatusHistoryOutput';
  items?: Maybe<Array<Maybe<JsmStatusHistory>>>;
  page_info?: Maybe<SearchResultPageInfo>;
  total_count?: Maybe<Scalars['Int']>;
};

export type JumpStartCart = {
  __typename?: 'JumpStartCart';
  cart: Cart;
};

/** Contains a key-value pair. */
export type KeyValue = {
  __typename?: 'KeyValue';
  /** The name part of the key/value pair. */
  name?: Maybe<Scalars['String']>;
  /** The value part of the key/value pair. */
  value?: Maybe<Scalars['String']>;
};

export type Label = {
  __typename?: 'Label';
  background_color?: Maybe<Scalars['String']>;
  default_name?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  text_color?: Maybe<Scalars['String']>;
};

/** Contains information for rendering layered navigation. */
export type LayerFilter = {
  __typename?: 'LayerFilter';
  /**
   * An array of filter items.
   * @deprecated Use `Aggregation.options` instead.
   */
  filter_items?: Maybe<Array<Maybe<LayerFilterItemInterface>>>;
  /**
   * The count of filter items in filter group.
   * @deprecated Use `Aggregation.count` instead.
   */
  filter_items_count?: Maybe<Scalars['Int']>;
  /**
   * The name of a layered navigation filter.
   * @deprecated Use `Aggregation.label` instead.
   */
  name?: Maybe<Scalars['String']>;
  /**
   * The request variable name for a filter query.
   * @deprecated Use `Aggregation.attribute_code` instead.
   */
  request_var?: Maybe<Scalars['String']>;
};

export type LayerFilterItem = LayerFilterItemInterface & {
  __typename?: 'LayerFilterItem';
  /**
   * The count of items per filter.
   * @deprecated Use `AggregationOption.count` instead.
   */
  items_count?: Maybe<Scalars['Int']>;
  /**
   * The label for a filter.
   * @deprecated Use `AggregationOption.label` instead.
   */
  label?: Maybe<Scalars['String']>;
  /**
   * The value of a filter request variable to be used in query.
   * @deprecated Use `AggregationOption.value` instead.
   */
  value_string?: Maybe<Scalars['String']>;
};

export type LayerFilterItemInterface = {
  /**
   * The count of items per filter.
   * @deprecated Use `AggregationOption.count` instead.
   */
  items_count?: Maybe<Scalars['Int']>;
  /**
   * The label for a filter.
   * @deprecated Use `AggregationOption.label` instead.
   */
  label?: Maybe<Scalars['String']>;
  /**
   * The value of a filter request variable to be used in query.
   * @deprecated Use `AggregationOption.value` instead.
   */
  value_string?: Maybe<Scalars['String']>;
};

export type MagefanBlogPost = {
  __typename?: 'MagefanBlogPost';
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type MageplazaBlogPost = {
  __typename?: 'MageplazaBlogPost';
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** Defines characteristics about images and videos associated with a specific product. */
export type MediaGalleryEntry = {
  __typename?: 'MediaGalleryEntry';
  /** Details about the content of the media gallery item. */
  content?: Maybe<ProductMediaGalleryEntriesContent>;
  /** Indicates whether the image is hidden from view. */
  disabled?: Maybe<Scalars['Boolean']>;
  /** The path of the image on the server. */
  file?: Maybe<Scalars['String']>;
  /**
   * The identifier assigned to the object.
   * @deprecated Use `uid` instead.
   */
  id?: Maybe<Scalars['Int']>;
  /** The alt text displayed on the storefront when the user points to the image. */
  label?: Maybe<Scalars['String']>;
  /** Either `image` or `video`. */
  media_type?: Maybe<Scalars['String']>;
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars['Int']>;
  /** Array of image types. It can have the following values: image, small_image, thumbnail. */
  types?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The unique ID for a `MediaGalleryEntry` object. */
  uid: Scalars['ID'];
  /** Details about the content of a video item. */
  video_content?: Maybe<ProductMediaGalleryEntriesVideoContent>;
};

/** Contains basic information about a product image or video. */
export type MediaGalleryInterface = {
  /** Indicates whether the image is hidden from view. */
  disabled?: Maybe<Scalars['Boolean']>;
  /** The label of the product image or video. */
  label?: Maybe<Scalars['String']>;
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars['Int']>;
  /** The URL of the product image or video. */
  url?: Maybe<Scalars['String']>;
};

export enum MediaTypeEnum {
  /** @deprecated  */
  Image = 'IMAGE',
  /** @deprecated  */
  Video = 'VIDEO'
}

export type MirasvitKbArticle = {
  __typename?: 'MirasvitKbArticle';
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** Defines a monetary value, including a numeric value and a currency code. */
export type Money = {
  __typename?: 'Money';
  /** A three-letter currency code, such as USD or EUR. */
  currency?: Maybe<CurrencyEnum>;
  /** A number expressing a monetary value. */
  value?: Maybe<Scalars['Float']>;
};

export type MpFilters = {
  /** Filter From Date. */
  from: Scalars['String'];
  /** Period. */
  period_type?: InputMaybe<Scalars['String']>;
  /** Show Empty Rows. */
  show_empty_rows?: InputMaybe<Scalars['Boolean']>;
  /** Filter Store Id. */
  store_id?: InputMaybe<Scalars['Int']>;
  /** Filter To Date. */
  to: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** sets the client type the user used on cart */
  AdminSetOrderSourceOnCart: OrderSourceOnCartOutput;
  /** Add new view to a given booking. */
  addBookingView: BookedService;
  /** Add one or more bundle products to the specified cart. We recommend using `addProductsToCart` instead. */
  addBundleProductsToCart?: Maybe<AddBundleProductsToCartOutput>;
  /** Add comment to additional item in order substitution */
  addCommentToAdditionalItem: Substitution;
  /** Add comment to a given booked service. */
  addCommentToBookedService: BookedService;
  /** Add comment to visit */
  addCommentToVisit: Visit;
  /** Add one or more configurable products to the specified cart. We recommend using `addProductsToCart` instead. */
  addConfigurableProductsToCart?: Maybe<AddConfigurableProductsToCartOutput>;
  /** Add reminder for a customer vehicle as an admin. */
  addCustomerVehicleReminder?: Maybe<CustomerVehicle>;
  /** Add discount to visit */
  addDiscountToVisit: Visit;
  /** Add one or more downloadable products to the specified cart. We recommend using `addProductsToCart` instead. */
  addDownloadableProductsToCart?: Maybe<AddDownloadableProductsToCartOutput>;
  addNewAdminUser: AdminOutput;
  /** Add any type of product to the cart. */
  addProductsToCart?: Maybe<AddProductsToCartOutput>;
  /** Add products to the specified compare list. */
  addProductsToCompareList?: Maybe<CompareList>;
  /** Add one or more products to the specified wish list. This mutation supports all product types. */
  addProductsToWishlist?: Maybe<AddProductsToWishlistOutput>;
  /** Add bookable services to store locators. */
  addServicesToStore: AddServicesToStoreOutput;
  /** Add one or more simple products to the specified cart. We recommend using `addProductsToCart` instead. */
  addSimpleProductsToCart?: Maybe<AddSimpleProductsToCartOutput>;
  addToJumpStartOrder?: Maybe<EditOrderOutput>;
  addToVanServiceOrder?: Maybe<EditOrderOutput>;
  /** Add vehicle to customer. */
  addVehicle: Customer;
  /** Add reminder for personal vehicle. */
  addVehicleReminder?: Maybe<CustomerVehicle>;
  /** Add one or more virtual products to the specified cart. We recommend using `addProductsToCart` instead. */
  addVirtualProductsToCart?: Maybe<AddVirtualProductsToCartOutput>;
  /** Add items in the specified wishlist to the customer's cart. */
  addWishlistItemsToCart?: Maybe<AddWishlistItemsToCartOutput>;
  /** Apply a pre-defined coupon code to the specified cart. */
  applyCouponToCart?: Maybe<ApplyCouponToCartOutput>;
  applyEvouchersToCart?: Maybe<ApplyEvouchersToCartOutput>;
  /** Approve adding new item in order substitution */
  approveAdditionalItem: Substitution;
  /** Approve item changes in order substitution */
  approveSubstitutionItem: Substitution;
  /** Assign the specified compare list to the logged in customer. */
  assignCompareListToCustomer?: Maybe<AssignCompareListToCustomerOutput>;
  /** Assign a logged-in customer to the specified guest shopping cart. */
  assignCustomerToGuestCart: Cart;
  assignJSMRider?: Maybe<JsmInfo>;
  /** Assign vehicle to cart. */
  assignVehicleToCart: AssignVehicleToCartOutput;
  /** Assign vehicle to customer, this mutation is allowed for admins only. */
  assignVehicleToCustomer: Customer;
  assignVsRider?: Maybe<JsmInfo>;
  /** Update or insert additional bookable service in order substitution */
  bookAdditionalService: Substitution;
  /** Book all cart services in a specific store consequently. */
  bookAllCartServices: BookAllCartServicesOutput;
  /** Book cart services in store separately. */
  bookCartServicesSeparately: BookCartServicesSeparatelyOutput;
  bookJumpStart?: Maybe<JumpStartCart>;
  bookVanService?: Maybe<JumpStartCart>;
  /** Cancel visit */
  cancelVisit: Visit;
  changeAdminPassword: AdminToken;
  /** Change the password for the logged-in customer. */
  changeCustomerPassword?: Maybe<Customer>;
  /** Enable or disable store locator. */
  changeStoreLocatorStatus: AddServicesToStoreOutput;
  /** Change store locator working times; from and/or to. */
  changeStoreLocatorWorkingTimes: AddServicesToStoreOutput;
  checkoutJumpStartAddons?: Maybe<EditOrderOutput>;
  /** clear Customer cart */
  clearCustomerCart?: Maybe<Cart>;
  /** Close store locator for a given period of time. */
  closeStoreLocator: CloseStoreLocatorOutput;
  completeCustomerProfile: CustomerToken;
  /** Complete visit */
  completeVisit: Visit;
  /** Contact us mutation */
  contactForm?: Maybe<Scalars['String']>;
  /** Create a new compare list. The compare list is saved for logged in customers. */
  createCompareList?: Maybe<CompareList>;
  /** Use `createCustomerV2` instead. */
  createCustomer?: Maybe<CustomerOutput>;
  /** Create a billing or shipping address for a customer or guest. */
  createCustomerAddress?: Maybe<CustomerAddress>;
  createCustomerAndAddress?: Maybe<CustomerOutput>;
  /** Create a customer account. */
  createCustomerV2?: Maybe<CustomerOutput>;
  /** Create an empty shopping cart for a guest or logged in user */
  createEmptyCart?: Maybe<Scalars['String']>;
  /** Create an order and visit for an in store/ offline made visit */
  createOrderAndVisit: Visit;
  /** Initiate a transaction and receive a token. Use this mutation for Payflow Pro and Payments Pro payment methods */
  createPayflowProToken?: Maybe<CreatePayflowProTokenOutput>;
  /** Initiate an Express Checkout transaction and receive a token. Use this mutation for Express Checkout and Payments Standard payment methods. */
  createPaypalExpressToken?: Maybe<PaypalExpressTokenOutput>;
  /** Create a product review for the specified product. */
  createProductReview: CreateProductReviewOutput;
  /** Create new substiution / job order for visit / sub order in garage */
  createSubstitution: Substitution;
  /** Create a visit for an order with today's booked services & products */
  createVisit: Visit;
  deleteAdminUser: Scalars['Boolean'];
  /** Delete a period where the store is closed. */
  deleteClosedPeriodFromStore: CloseStoreLocatorOutput;
  /** Delete the specified compare list. */
  deleteCompareList?: Maybe<DeleteCompareListOutput>;
  /** Delete customer account */
  deleteCustomer: Scalars['Boolean'];
  /** Delete the billing or shipping address of a customer. */
  deleteCustomerAddress?: Maybe<Scalars['Boolean']>;
  /** Delete a customer's payment token. */
  deletePaymentToken?: Maybe<DeletePaymentTokenOutput>;
  /** Delete upcoming visit reminder */
  deleteUpcomingVisitReminder: Scalars['Boolean'];
  /** Deliver vehicle visit */
  deliverVehicleVisit: Visit;
  /** Edits unverified customer phone number using OTP */
  editCustomerPhoneNumber: Scalars['Boolean'];
  /** Edit upcoming visit reminder */
  editUpcomingVisitReminder: UpcomingVisitReminder;
  generateAdminToken: AdminToken;
  /** Generate a token for specified customer. */
  generateCustomerToken?: Maybe<CustomerToken>;
  /** Request a customer token so that an administrator can perform remote shopping assistance. */
  generateCustomerTokenAsAdmin?: Maybe<GenerateCustomerTokenAsAdminOutput>;
  /** Handle a payment response and save the payment in Quote. Use this mutation for Payflow Pro and Payments Pro payment methods. */
  handlePayflowProResponse?: Maybe<PayflowProResponseOutput>;
  /** Import bookable services to store locators. */
  importBookableServices: AddServicesToStoreOutput;
  initiateJumpStart?: Maybe<InitiateJumpStartOutput>;
  initiateVanService?: Maybe<InitiateJumpStartOutput>;
  /** Start initial inspection for visit */
  initiateVisitInspection: Visit;
  /** Invoice visit */
  invoiceVisit: Visit;
  logInWithSocialProvider?: Maybe<CustomerToken>;
  /** Mark visit as waiting on customer */
  markVisitAsWaiting: Visit;
  /** Transfer the contents of a guest cart into the cart of a logged-in customer. */
  mergeCarts: Cart;
  /** Convert the quote into an order. */
  placeOrder?: Maybe<PlaceOrderOutput>;
  /** Plan upcoming visit */
  planUpcomingVisit: Visit;
  refreshAdminToken: AdminToken;
  refreshToken: CustomerToken;
  /** Reject adding new item in order substitution */
  rejectAdditionalItem: Substitution;
  /** Reject item changes in order substitution */
  rejectSubstitutionItem: Substitution;
  /** Remove additional item in order substitution */
  removeAdditionalItem: Substitution;
  /** Remove a previously-applied coupon from the cart. The cart must contain at least one item in order to remove the coupon. */
  removeCouponFromCart?: Maybe<RemoveCouponFromCartOutput>;
  /** Remove discount from visit */
  removeDiscountFromVisit: Visit;
  removeEvouchersFromCart?: Maybe<RemoveEvouchersFromCartOutput>;
  removeFromJumpStartOrder?: Maybe<EditOrderOutput>;
  removeFromVanServiceOrder?: Maybe<EditOrderOutput>;
  /** Delete the entire quantity of a specified item from the cart. If you remove all items from the cart, the cart continues to exist. */
  removeItemFromCart?: Maybe<RemoveItemFromCartOutput>;
  /** Remove products from the specified compare list. */
  removeProductsFromCompareList?: Maybe<CompareList>;
  /** Remove one or more products from the specified wish list. */
  removeProductsFromWishlist?: Maybe<RemoveProductsFromWishlistOutput>;
  /** Remove item in order substitution */
  removeSubstitutionItem: Substitution;
  /** Remove vehicle from customer. */
  removeVehicle: Customer;
  /** Add all products from a customer's previous order to the cart. */
  reorderItems?: Maybe<ReorderItemsOutput>;
  /** Request an email with a reset password token for the registered user/admin identified by the specified username. */
  requestAdminPasswordReset?: Maybe<Scalars['Boolean']>;
  /** Request an email with a reset password token for the registered customer identified by the specified email. */
  requestPasswordResetEmail?: Maybe<Scalars['Boolean']>;
  /** Sends a new OTP to the customer email, that can be used to change his phone number. */
  requestPhoneNumberChangeEmail: Scalars['Boolean'];
  requestProfileCompletionByPhone?: Maybe<Scalars['Boolean']>;
  /** The chosen start time formatted as `HH:MM`. */
  rescheduleJumpStartRequest?: Maybe<JsmInfo>;
  rescheduleVanServiceRequest?: Maybe<JsmInfo>;
  /** Sends a new OTP to the customer phone number. */
  resendOTP: Scalars['Boolean'];
  /** Regenerates and send verification code */
  resendVerficationCode: Scalars['Boolean'];
  /** Reset a user's password using the reset password token that the user received in an email. */
  resetAdminPassword?: Maybe<Scalars['Boolean']>;
  /** Reset a customer's password using the reset password token that the customer received in an email after requesting it using `requestPasswordResetEmail`. */
  resetPassword?: Maybe<Scalars['Boolean']>;
  revokeAdminToken?: Maybe<RevokeAdminTokenOutput>;
  /** Revoke the customer token. */
  revokeCustomerToken?: Maybe<RevokeCustomerTokenOutput>;
  /** Send a message on behalf of a customer to the specified email addresses. */
  sendEmailToFriend?: Maybe<SendEmailToFriendOutput>;
  /** Set the billing address on a specific cart. */
  setBillingAddressOnCart?: Maybe<SetBillingAddressOnCartOutput>;
  /** Save reminder used to initiate appointment on cart */
  setCartParentReminder: SetCartParentReminderOutput;
  setCustomerSelectedStockSource: SetCustomerSelectedStockSourceOutput;
  /** Assign the email address of a guest to the cart. */
  setGuestEmailOnCart?: Maybe<SetGuestEmailOnCartOutput>;
  /** sets the client type the user used on cart */
  setOrderSourceOnCart: OrderSourceOnCartOutput;
  /**
   * Set the cart payment method and convert the cart into an order.
   * @deprecated Should use setPaymentMethodOnCart and placeOrder mutations in single request.
   */
  setPaymentMethodAndPlaceOrder?: Maybe<PlaceOrderOutput>;
  /** Apply a payment method to the cart. */
  setPaymentMethodOnCart?: Maybe<SetPaymentMethodOnCartOutput>;
  /** Set one or more shipping addresses on a specific cart. */
  setShippingAddressesOnCart?: Maybe<SetShippingAddressesOnCartOutput>;
  setShippingLocationOnCart?: Maybe<SetShippingLocationOnCartOutput>;
  /** Set one or more delivery methods on a cart. */
  setShippingMethodsOnCart?: Maybe<SetShippingMethodsOnCartOutput>;
  /** Update order substitution start date */
  startSubstitution: Substitution;
  /** add Product to stock back notification */
  stockBackNotification: Scalars['Boolean'];
  submitSellCarRequest?: Maybe<Scalars['Boolean']>;
  /** Submit order substitution */
  submitSubstitution: Substitution;
  submitUsedCarAppointmentRequest?: Maybe<Scalars['Boolean']>;
  /** Subscribe the specified email to the store's newsletter. */
  subscribeEmailToNewsletter?: Maybe<SubscribeEmailToNewsletterOutput>;
  /** Remove vehicle from customer, this mutation is allowed for admins only. */
  unassignVehicleFromCustomer: Customer;
  /** Update admin fcm token */
  updateAdminFcm: Scalars['Boolean'];
  updateAdminUser: AdminOutput;
  /** Update customer vehicle data for admins. */
  updateAssignedCustomerVehicle?: Maybe<CustomerVehicle>;
  /** Update status for a specific booking. */
  updateBookingStatus: BookedService;
  /** Update booking date & time for a specific booking. */
  updateBookingTime: BookedService;
  /** Modify items in the cart. */
  updateCartItems?: Maybe<UpdateCartItemsOutput>;
  /** Update a period where the store is closed. */
  updateClosedPeriodAtStore: CloseStoreLocatorOutput;
  /** Use `updateCustomerV2` instead. */
  updateCustomer?: Maybe<CustomerOutput>;
  /** Update the billing or shipping address of a customer or guest. */
  updateCustomerAddress?: Maybe<CustomerAddress>;
  /** Update some of the customer's personal information */
  updateCustomerAsAdmin?: Maybe<CustomerOutput>;
  /** Change the email address for the logged-in customer. */
  updateCustomerEmail?: Maybe<CustomerOutput>;
  updateCustomerPhoneNumber?: Maybe<UpdateCustomerPhoneNumberOutput>;
  /** Update the customer's personal information. */
  updateCustomerV2?: Maybe<CustomerOutput>;
  /** Update customer fcm token */
  updateFcmToken: Scalars['Boolean'];
  /** Update inspection for visit. */
  updateInspection: Visit;
  /** Update inspection for visit, adding images and comments to attributes. */
  updateInspectionAdditionalData: Inspection;
  /** Progress the request status from the rider side. */
  updateJSMRequestStatus?: Maybe<JsmInfo>;
  updateJsRequestLocation?: Maybe<JsmInfo>;
  /** Update order vehicle data as admin. */
  updateOrderVehicle?: Maybe<OrderVehicle>;
  /** Update one or more products in the specified wish list. */
  updateProductsInWishlist?: Maybe<UpdateProductsInWishlistOutput>;
  /** Update bookable services in store locators. */
  updateServicesInStore: AddServicesToStoreOutput;
  /** Update substitution item */
  updateSubstitutionItem: Substitution;
  /** Update customer vehicle data. */
  updateVehicle?: Maybe<CustomerVehicle>;
  /** Update visit item */
  updateVisitItem: Visit;
  updateVsRequestLocation?: Maybe<JsmInfo>;
  /** Progress the request status from the rider side. */
  updateVsRequestStatus?: Maybe<JsmInfo>;
  /** Update or insert additional item in order substitution */
  upsertAdditionalItem: Substitution;
  /** Update or insert multiple addititonal items in order substitution */
  upsertMultipleAdditionalItem: Substitution;
  /** Verifies customer phone number using OTP */
  verifyCustomer: CustomerToken;
  /** Verifies the validity and correctness of the otp sent to the customer. */
  verifyCustomerOTP: Scalars['Boolean'];
  /** Verifying phone number with code validation */
  verifyPhoneNumber: Scalars['Boolean'];
  /** Verify customer's reset password token that they received in an email after requesting it using requestPasswordResetEmail. */
  verifyResetPasswordToken?: Maybe<Scalars['Boolean']>;
};


export type MutationAdminSetOrderSourceOnCartArgs = {
  input?: InputMaybe<AdminOrderSourceOnCartInput>;
};


export type MutationAddBookingViewArgs = {
  uid: Scalars['ID'];
};


export type MutationAddBundleProductsToCartArgs = {
  input?: InputMaybe<AddBundleProductsToCartInput>;
};


export type MutationAddCommentToAdditionalItemArgs = {
  input?: InputMaybe<AddCommentToAdditionalItemInput>;
};


export type MutationAddCommentToBookedServiceArgs = {
  input?: InputMaybe<AddCommentToBookedServiceInput>;
};


export type MutationAddCommentToVisitArgs = {
  comment: Scalars['String'];
  visitId: Scalars['ID'];
};


export type MutationAddConfigurableProductsToCartArgs = {
  input?: InputMaybe<AddConfigurableProductsToCartInput>;
};


export type MutationAddCustomerVehicleReminderArgs = {
  customerId: Scalars['Int'];
  services: Array<PlanUpcomingServiceInput>;
  vehicleUid: Scalars['ID'];
};


export type MutationAddDiscountToVisitArgs = {
  discount: Scalars['Float'];
  type: DiscountType;
  visitId: Scalars['ID'];
};


export type MutationAddDownloadableProductsToCartArgs = {
  input?: InputMaybe<AddDownloadableProductsToCartInput>;
};


export type MutationAddNewAdminUserArgs = {
  input: AddNewAdminUserInput;
};


export type MutationAddProductsToCartArgs = {
  cartId: Scalars['String'];
  cartItems: Array<CartItemInput>;
};


export type MutationAddProductsToCompareListArgs = {
  input?: InputMaybe<AddProductsToCompareListInput>;
};


export type MutationAddProductsToWishlistArgs = {
  wishlistId: Scalars['ID'];
  wishlistItems: Array<WishlistItemInput>;
};


export type MutationAddServicesToStoreArgs = {
  bookableServices: Array<BookableServiceInput>;
  storeLocatorId: Scalars['Int'];
};


export type MutationAddSimpleProductsToCartArgs = {
  input?: InputMaybe<AddSimpleProductsToCartInput>;
};


export type MutationAddToJumpStartOrderArgs = {
  input: AddToJumpStartOrderInput;
};


export type MutationAddToVanServiceOrderArgs = {
  input: AddToVanServiceOrderInput;
};


export type MutationAddVehicleArgs = {
  vehicle: VehicleInput;
};


export type MutationAddVehicleReminderArgs = {
  services: Array<PlanUpcomingServiceInput>;
  vehicleUid: Scalars['ID'];
};


export type MutationAddVirtualProductsToCartArgs = {
  input?: InputMaybe<AddVirtualProductsToCartInput>;
};


export type MutationAddWishlistItemsToCartArgs = {
  wishlistId: Scalars['ID'];
  wishlistItemIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationApplyCouponToCartArgs = {
  input?: InputMaybe<ApplyCouponToCartInput>;
};


export type MutationApplyEvouchersToCartArgs = {
  input: ApplyEvouchersToCartInput;
};


export type MutationApproveAdditionalItemArgs = {
  input?: InputMaybe<ApproveAdditionalItemInput>;
};


export type MutationApproveSubstitutionItemArgs = {
  input?: InputMaybe<ApproveSubstitutionItemInput>;
};


export type MutationAssignCompareListToCustomerArgs = {
  uid: Scalars['ID'];
};


export type MutationAssignCustomerToGuestCartArgs = {
  cart_id: Scalars['String'];
};


export type MutationAssignJsmRiderArgs = {
  input?: InputMaybe<AssignJsmRiderInput>;
};


export type MutationAssignVehicleToCartArgs = {
  cartId: Scalars['String'];
  vehicle?: InputMaybe<VehicleInput>;
  vehicleUid?: InputMaybe<Scalars['ID']>;
};


export type MutationAssignVehicleToCustomerArgs = {
  customerId: Scalars['Int'];
  vehicle: VehicleInput;
};


export type MutationAssignVsRiderArgs = {
  input?: InputMaybe<AssignJsmRiderInput>;
};


export type MutationBookAdditionalServiceArgs = {
  input?: InputMaybe<BookAdditionalServiceInput>;
};


export type MutationBookAllCartServicesArgs = {
  adminEmail?: InputMaybe<Scalars['String']>;
  input: BookAllCartServicesInput;
};


export type MutationBookCartServicesSeparatelyArgs = {
  adminEmail?: InputMaybe<Scalars['String']>;
  bookableCartServices: Array<BookableCartServiceInput>;
  cartId: Scalars['String'];
};


export type MutationBookJumpStartArgs = {
  adminEmail?: InputMaybe<Scalars['String']>;
  cartId: Scalars['String'];
};


export type MutationBookVanServiceArgs = {
  adminEmail?: InputMaybe<Scalars['String']>;
  cartId: Scalars['String'];
};


export type MutationCancelVisitArgs = {
  visitId: Scalars['ID'];
};


export type MutationChangeAdminPasswordArgs = {
  currentPassword: Scalars['String'];
  newPassword: Scalars['String'];
};


export type MutationChangeCustomerPasswordArgs = {
  currentPassword: Scalars['String'];
  newPassword: Scalars['String'];
};


export type MutationChangeStoreLocatorStatusArgs = {
  status: Scalars['Boolean'];
  storeLocatorId: Scalars['Int'];
};


export type MutationChangeStoreLocatorWorkingTimesArgs = {
  input: WorkingTimesInput;
  storeLocatorId: Scalars['Int'];
};


export type MutationCheckoutJumpStartAddonsArgs = {
  input?: InputMaybe<CheckoutJumpStartAddonsInput>;
};


export type MutationClearCustomerCartArgs = {
  cart_id: Scalars['String'];
};


export type MutationCloseStoreLocatorArgs = {
  input: CloseStoreLocatorInput;
};


export type MutationCompleteCustomerProfileArgs = {
  customerInformation: CustomerInformationInput;
  otp: Scalars['String'];
  phoneNumber: Scalars['String'];
};


export type MutationCompleteVisitArgs = {
  visitId: Scalars['ID'];
};


export type MutationContactFormArgs = {
  input?: InputMaybe<ContactFormInput>;
};


export type MutationCreateCompareListArgs = {
  input?: InputMaybe<CreateCompareListInput>;
};


export type MutationCreateCustomerArgs = {
  input?: InputMaybe<CreateCustomerInput>;
};


export type MutationCreateCustomerAddressArgs = {
  input: CustomerAddressInput;
};


export type MutationCreateCustomerAndAddressArgs = {
  input: CreateCustomerAndAddressInput;
};


export type MutationCreateCustomerV2Args = {
  input: CustomerCreateInput;
};


export type MutationCreateEmptyCartArgs = {
  input?: InputMaybe<CreateEmptyCartInput>;
};


export type MutationCreateOrderAndVisitArgs = {
  input: CreateOrderAndVisitInput;
};


export type MutationCreatePayflowProTokenArgs = {
  input: PayflowProTokenInput;
};


export type MutationCreatePaypalExpressTokenArgs = {
  input: PaypalExpressTokenInput;
};


export type MutationCreateProductReviewArgs = {
  input: CreateProductReviewInput;
};


export type MutationCreateSubstitutionArgs = {
  input: CreateSubstitutionInput;
};


export type MutationCreateVisitArgs = {
  orderID: Scalars['ID'];
  storeLocatorId: Scalars['Int'];
};


export type MutationDeleteAdminUserArgs = {
  username: Scalars['String'];
};


export type MutationDeleteClosedPeriodFromStoreArgs = {
  closedPeriodUid: Scalars['ID'];
};


export type MutationDeleteCompareListArgs = {
  uid: Scalars['ID'];
};


export type MutationDeleteCustomerAddressArgs = {
  id: Scalars['Int'];
};


export type MutationDeletePaymentTokenArgs = {
  public_hash: Scalars['String'];
};


export type MutationDeleteUpcomingVisitReminderArgs = {
  reminderId: Scalars['ID'];
};


export type MutationDeliverVehicleVisitArgs = {
  visitId: Scalars['ID'];
};


export type MutationEditCustomerPhoneNumberArgs = {
  new_phone_number: Scalars['String'];
  old_phone_number: Scalars['String'];
  otp: Scalars['String'];
};


export type MutationEditUpcomingVisitReminderArgs = {
  input: EditUpcomingVisitReminderInput;
  reminderId: Scalars['ID'];
};


export type MutationGenerateAdminTokenArgs = {
  password: Scalars['String'];
  username: Scalars['String'];
};


export type MutationGenerateCustomerTokenArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationGenerateCustomerTokenAsAdminArgs = {
  input: GenerateCustomerTokenAsAdminInput;
};


export type MutationHandlePayflowProResponseArgs = {
  input: PayflowProResponseInput;
};


export type MutationImportBookableServicesArgs = {
  input: Array<BookableServiceImportInput>;
  storeLocatorId: Scalars['Int'];
};


export type MutationInitiateJumpStartArgs = {
  input: InitiateJumpStartInput;
};


export type MutationInitiateVanServiceArgs = {
  input: InitiateJumpStartInput;
};


export type MutationInitiateVisitInspectionArgs = {
  visitId: Scalars['ID'];
};


export type MutationInvoiceVisitArgs = {
  visitId: Scalars['ID'];
};


export type MutationLogInWithSocialProviderArgs = {
  input: SocialProviderLogInInput;
  socialProvider: SocialProviderEnum;
};


export type MutationMarkVisitAsWaitingArgs = {
  visitId: Scalars['ID'];
};


export type MutationMergeCartsArgs = {
  destination_cart_id?: InputMaybe<Scalars['String']>;
  source_cart_id: Scalars['String'];
};


export type MutationPlaceOrderArgs = {
  input?: InputMaybe<PlaceOrderInput>;
};


export type MutationPlanUpcomingVisitArgs = {
  services: Array<PlanUpcomingServiceInput>;
  visitId: Scalars['ID'];
};


export type MutationRefreshAdminTokenArgs = {
  refreshToken: Scalars['String'];
};


export type MutationRefreshTokenArgs = {
  refreshToken: Scalars['String'];
};


export type MutationRejectAdditionalItemArgs = {
  input?: InputMaybe<RejectAdditionalItemInput>;
};


export type MutationRejectSubstitutionItemArgs = {
  input?: InputMaybe<RejectSubstitutionItemInput>;
};


export type MutationRemoveAdditionalItemArgs = {
  input?: InputMaybe<RemoveAdditionalItemInput>;
};


export type MutationRemoveCouponFromCartArgs = {
  input?: InputMaybe<RemoveCouponFromCartInput>;
};


export type MutationRemoveDiscountFromVisitArgs = {
  visitId: Scalars['ID'];
};


export type MutationRemoveEvouchersFromCartArgs = {
  input: ApplyEvouchersToCartInput;
};


export type MutationRemoveFromJumpStartOrderArgs = {
  input: RemoveFromJumpStartOrderInput;
};


export type MutationRemoveFromVanServiceOrderArgs = {
  input: RemoveFromJumpStartOrderInput;
};


export type MutationRemoveItemFromCartArgs = {
  input?: InputMaybe<RemoveItemFromCartInput>;
};


export type MutationRemoveProductsFromCompareListArgs = {
  input?: InputMaybe<RemoveProductsFromCompareListInput>;
};


export type MutationRemoveProductsFromWishlistArgs = {
  wishlistId: Scalars['ID'];
  wishlistItemsIds: Array<Scalars['ID']>;
};


export type MutationRemoveSubstitutionItemArgs = {
  input?: InputMaybe<RemoveSubstitutionItemInput>;
};


export type MutationRemoveVehicleArgs = {
  vehicleUid: Scalars['ID'];
};


export type MutationReorderItemsArgs = {
  orderNumber: Scalars['String'];
};


export type MutationRequestAdminPasswordResetArgs = {
  email: Scalars['String'];
  username: Scalars['String'];
};


export type MutationRequestPasswordResetEmailArgs = {
  email: Scalars['String'];
};


export type MutationRequestPhoneNumberChangeEmailArgs = {
  phone_number: Scalars['String'];
};


export type MutationRequestProfileCompletionByPhoneArgs = {
  phoneNumber: Scalars['String'];
};


export type MutationRescheduleJumpStartRequestArgs = {
  input: RescheduleRequestInput;
};


export type MutationRescheduleVanServiceRequestArgs = {
  input: RescheduleRequestInput;
};


export type MutationResendOtpArgs = {
  phone_number: Scalars['String'];
};


export type MutationResendVerficationCodeArgs = {
  input: ResendVerficationCodeInput;
};


export type MutationResetAdminPasswordArgs = {
  newPassword: Scalars['String'];
  resetPasswordToken: Scalars['String'];
  username: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  email: Scalars['String'];
  newPassword: Scalars['String'];
  resetPasswordToken: Scalars['String'];
};


export type MutationRevokeAdminTokenArgs = {
  revokeRefreshToken?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSendEmailToFriendArgs = {
  input?: InputMaybe<SendEmailToFriendInput>;
};


export type MutationSetBillingAddressOnCartArgs = {
  input?: InputMaybe<SetBillingAddressOnCartInput>;
};


export type MutationSetCartParentReminderArgs = {
  cartId: Scalars['ID'];
  reminderId: Scalars['ID'];
};


export type MutationSetCustomerSelectedStockSourceArgs = {
  sourceCode: Scalars['String'];
};


export type MutationSetGuestEmailOnCartArgs = {
  input?: InputMaybe<SetGuestEmailOnCartInput>;
};


export type MutationSetOrderSourceOnCartArgs = {
  input?: InputMaybe<OrderSourceOnCartInput>;
};


export type MutationSetPaymentMethodAndPlaceOrderArgs = {
  input?: InputMaybe<SetPaymentMethodAndPlaceOrderInput>;
};


export type MutationSetPaymentMethodOnCartArgs = {
  input?: InputMaybe<SetPaymentMethodOnCartInput>;
};


export type MutationSetShippingAddressesOnCartArgs = {
  input?: InputMaybe<SetShippingAddressesOnCartInput>;
};


export type MutationSetShippingLocationOnCartArgs = {
  input?: InputMaybe<SetShippingLocationOnCartInput>;
};


export type MutationSetShippingMethodsOnCartArgs = {
  input?: InputMaybe<SetShippingMethodsOnCartInput>;
};


export type MutationStartSubstitutionArgs = {
  input: StartSubstitutionInput;
};


export type MutationStockBackNotificationArgs = {
  email?: InputMaybe<Scalars['String']>;
  phone_number?: InputMaybe<Scalars['String']>;
  product_id?: InputMaybe<Scalars['Int']>;
  product_uid?: InputMaybe<Scalars['String']>;
};


export type MutationSubmitSellCarRequestArgs = {
  input: SellCarInput;
};


export type MutationSubmitSubstitutionArgs = {
  input?: InputMaybe<SubmitSubstitutionInput>;
};


export type MutationSubmitUsedCarAppointmentRequestArgs = {
  input: UsedCarAppointmentInput;
};


export type MutationSubscribeEmailToNewsletterArgs = {
  email: Scalars['String'];
};


export type MutationUnassignVehicleFromCustomerArgs = {
  customerId: Scalars['Int'];
  vehicleUid: Scalars['ID'];
};


export type MutationUpdateAdminFcmArgs = {
  channel: AdminFcmChannel;
  token: Scalars['String'];
};


export type MutationUpdateAdminUserArgs = {
  input: UpdateAdminUserInput;
  username: Scalars['String'];
};


export type MutationUpdateAssignedCustomerVehicleArgs = {
  customerId: Scalars['Int'];
  updateInput: CustomerVehicleSpecificInput;
  vehicleUid: Scalars['ID'];
};


export type MutationUpdateBookingStatusArgs = {
  input: UpdateBookingStatusInput;
};


export type MutationUpdateBookingTimeArgs = {
  input: UpdateBookingTimeInput;
};


export type MutationUpdateCartItemsArgs = {
  input?: InputMaybe<UpdateCartItemsInput>;
};


export type MutationUpdateClosedPeriodAtStoreArgs = {
  input: UpdateClosedPeriodInput;
};


export type MutationUpdateCustomerArgs = {
  input: CustomerInput;
};


export type MutationUpdateCustomerAddressArgs = {
  id: Scalars['Int'];
  input?: InputMaybe<CustomerAddressInput>;
};


export type MutationUpdateCustomerAsAdminArgs = {
  email: Scalars['String'];
  input: CustomerUpdateAsAdminInput;
};


export type MutationUpdateCustomerEmailArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationUpdateCustomerPhoneNumberArgs = {
  input?: InputMaybe<UpdateCustomerPhoneNumberInput>;
};


export type MutationUpdateCustomerV2Args = {
  input: CustomerUpdateInput;
};


export type MutationUpdateFcmTokenArgs = {
  channel: FcmChannelEnum;
  token: Scalars['String'];
};


export type MutationUpdateInspectionArgs = {
  input: UpdateInspectionInput;
};


export type MutationUpdateInspectionAdditionalDataArgs = {
  input: UpdateInspectionAdditionalDataInput;
  visitUid: Scalars['ID'];
};


export type MutationUpdateJsmRequestStatusArgs = {
  requestId: Scalars['ID'];
  status: JsmStatus;
};


export type MutationUpdateJsRequestLocationArgs = {
  input: UpdateSosRequestLocationInput;
};


export type MutationUpdateOrderVehicleArgs = {
  orderId: Scalars['ID'];
  updateInput: OrderVehicleInput;
};


export type MutationUpdateProductsInWishlistArgs = {
  wishlistId: Scalars['ID'];
  wishlistItems: Array<WishlistItemUpdateInput>;
};


export type MutationUpdateServicesInStoreArgs = {
  input: Array<UpdateBookableServiceInput>;
};


export type MutationUpdateSubstitutionItemArgs = {
  input?: InputMaybe<UpdateSubstitutionItemInput>;
};


export type MutationUpdateVehicleArgs = {
  updateInput: CustomerVehicleSpecificInput;
  vehicleUid: Scalars['ID'];
};


export type MutationUpdateVisitItemArgs = {
  input: UpdateVisitItemInput;
};


export type MutationUpdateVsRequestLocationArgs = {
  input: UpdateSosRequestLocationInput;
};


export type MutationUpdateVsRequestStatusArgs = {
  requestId: Scalars['ID'];
  status: JsmStatus;
};


export type MutationUpsertAdditionalItemArgs = {
  input?: InputMaybe<AddAdditionalItemInput>;
};


export type MutationUpsertMultipleAdditionalItemArgs = {
  input?: InputMaybe<AddAdditionalMultipleItemInput>;
};


export type MutationVerifyCustomerArgs = {
  otp: Scalars['String'];
  username: Scalars['String'];
};


export type MutationVerifyCustomerOtpArgs = {
  otp: Scalars['String'];
  username: Scalars['String'];
};


export type MutationVerifyPhoneNumberArgs = {
  input: VerifyingPhoneNumberInput;
};


export type MutationVerifyResetPasswordTokenArgs = {
  email: Scalars['String'];
  resetPasswordToken: Scalars['String'];
};

export type NearestTime = {
  __typename?: 'NearestTime';
  /** The day of this period formatted as `YYYY-MM-DD`. */
  day: Scalars['String'];
  /** The end time of this period formatted as `HH:MM`. */
  end_time: Scalars['String'];
  /** The start time of this period formatted as `HH:MM`. */
  start_time: Scalars['String'];
};

export type NextDeliveryIntervalOutput = {
  __typename?: 'NextDeliveryIntervalOutput';
  expires_at: Scalars['String'];
  from: Scalars['String'];
  to: Scalars['String'];
};

/** Contains an error message when an invalid UID was specified. */
export type NoSuchEntityUidError = ErrorInterface & {
  __typename?: 'NoSuchEntityUidError';
  /** The returned error message. */
  message: Scalars['String'];
  /** The specified invalid unique ID of an object. */
  uid: Scalars['ID'];
};

export type Offer = {
  __typename?: 'Offer';
  button_text?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  image_url: Scalars['String'];
  is_featured?: Maybe<Scalars['Boolean']>;
  is_hot?: Maybe<Scalars['Boolean']>;
  is_mega_menu?: Maybe<Scalars['Boolean']>;
  link_object_url_key?: Maybe<Scalars['String']>;
  link_type?: Maybe<Scalars['String']>;
  mobile_image_url: Scalars['String'];
  offer_url?: Maybe<Scalars['String']>;
  responsive_image_url: Scalars['String'];
  sort?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

/** Contains the order ID. */
export type Order = {
  __typename?: 'Order';
  acceptIframeUrl?: Maybe<Scalars['String']>;
  delivery_details?: Maybe<DeliveryDetails>;
  /** An array of the gained evouchers on any order. */
  gainedEvouchers?: Maybe<CustomerEvoucher>;
  /** @deprecated Use `order_number` instead. */
  order_id?: Maybe<Scalars['String']>;
  /** The unique ID for an `Order` object. */
  order_number: Scalars['String'];
};


/** Contains the order ID. */
export type OrderGainedEvouchersArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** Contains detailed information about an order's billing and shipping addresses. */
export type OrderAddress = {
  __typename?: 'OrderAddress';
  /** An object containing the city name, city code, and city ID */
  city?: Maybe<City>;
  /** The customer's company. */
  company?: Maybe<Scalars['String']>;
  /** An object containing the country name, country code, and country ID */
  country?: Maybe<Country>;
  /** The customer's country. */
  country_code?: Maybe<CountryCodeEnum>;
  /** The fax number. */
  fax?: Maybe<Scalars['String']>;
  /** The first name of the person associated with the shipping/billing address. */
  firstname: Scalars['String'];
  /** The family name of the person associated with the shipping/billing address. */
  lastname: Scalars['String'];
  /** The middle name of the person associated with the shipping/billing address. */
  middlename?: Maybe<Scalars['String']>;
  /** The customer's ZIP or postal code. */
  postcode?: Maybe<Scalars['String']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars['String']>;
  /** The state or province name. */
  region?: Maybe<Scalars['String']>;
  /** The unique ID for a `Region` object of a pre-defined region. */
  region_id?: Maybe<Scalars['ID']>;
  /** An array of strings that define the street number and name. */
  street: Array<Maybe<Scalars['String']>>;
  /** A value such as Sr., Jr., or III. */
  suffix?: Maybe<Scalars['String']>;
  /** The telephone number. */
  telephone?: Maybe<Scalars['String']>;
  /** The customer's Value-added tax (VAT) number (for corporate customers). */
  vat_id?: Maybe<Scalars['String']>;
};

export type OrderItem = OrderItemInterface & {
  __typename?: 'OrderItem';
  /** Information about the booking of this item */
  booked_service?: Maybe<BookedService>;
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The entered option for the base product, such as a logo or image. */
  entered_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The selected gift message for the order item */
  gift_message?: Maybe<GiftMessage>;
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars['ID'];
  /** The categories assigned to the product. */
  product_categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** The URL of the main product image of the base product */
  product_image_url?: Maybe<Scalars['String']>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The original price of the base product */
  product_original_price: Money;
  /** The sale price of the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The URL of the thumbnail image of the base product */
  product_thumbnail_url?: Maybe<Scalars['String']>;
  /** The type of product, such as simple, configurable, etc. */
  product_type?: Maybe<Scalars['String']>;
  /** URL key of the base product. */
  product_url_key?: Maybe<Scalars['String']>;
  /** The number of canceled items. */
  quantity_canceled?: Maybe<Scalars['Float']>;
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']>;
  /** The number of units ordered for this item. */
  quantity_ordered?: Maybe<Scalars['Float']>;
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']>;
  /** The number of returned items. */
  quantity_returned?: Maybe<Scalars['Float']>;
  /** The number of shipped items. */
  quantity_shipped?: Maybe<Scalars['Float']>;
  /** The selected options for the base product, such as color or size. */
  selected_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The status of the order item. */
  status?: Maybe<Scalars['String']>;
};

/** Order item details. */
export type OrderItemInterface = {
  /** Information about the booking of this item */
  booked_service?: Maybe<BookedService>;
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The entered option for the base product, such as a logo or image. */
  entered_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The selected gift message for the order item */
  gift_message?: Maybe<GiftMessage>;
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars['ID'];
  /** The categories assigned to the product. */
  product_categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** The URL of the main product image of the base product */
  product_image_url?: Maybe<Scalars['String']>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The original price of the base product */
  product_original_price: Money;
  /** The sale price of the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The URL of the thumbnail image of the base product */
  product_thumbnail_url?: Maybe<Scalars['String']>;
  /** The type of product, such as simple, configurable, etc. */
  product_type?: Maybe<Scalars['String']>;
  /** URL key of the base product. */
  product_url_key?: Maybe<Scalars['String']>;
  /** The number of canceled items. */
  quantity_canceled?: Maybe<Scalars['Float']>;
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']>;
  /** The number of units ordered for this item. */
  quantity_ordered?: Maybe<Scalars['Float']>;
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']>;
  /** The number of returned items. */
  quantity_returned?: Maybe<Scalars['Float']>;
  /** The number of shipped items. */
  quantity_shipped?: Maybe<Scalars['Float']>;
  /** The selected options for the base product, such as color or size. */
  selected_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The status of the order item. */
  status?: Maybe<Scalars['String']>;
};

/** Represents order item options like selected or entered. */
export type OrderItemOption = {
  __typename?: 'OrderItemOption';
  /** The name of the option. */
  label: Scalars['String'];
  /** The value of the option. */
  value: Scalars['String'];
};

/** Contains details about the payment method used to pay for the order. */
export type OrderPaymentMethod = {
  __typename?: 'OrderPaymentMethod';
  /** Additional data per payment method type. */
  additional_data?: Maybe<Array<Maybe<KeyValue>>>;
  /** The label that describes the payment method. */
  name: Scalars['String'];
  /** The payment method code that indicates how the order was paid for. */
  type: Scalars['String'];
};

/** Contains order shipment details. */
export type OrderShipment = {
  __typename?: 'OrderShipment';
  /** Comments added to the shipment. */
  comments?: Maybe<Array<Maybe<SalesCommentItem>>>;
  /** The unique ID for a `OrderShipment` object. */
  id: Scalars['ID'];
  /** An array of items included in the shipment. */
  items?: Maybe<Array<Maybe<ShipmentItemInterface>>>;
  /** The sequential credit shipment number. */
  number: Scalars['String'];
  /** An array of shipment tracking details. */
  tracking?: Maybe<Array<Maybe<ShipmentTracking>>>;
};

export type OrderSourceOnCartInput = {
  cart_id: Scalars['String'];
  order_source: Scalars['String'];
};

export type OrderSourceOnCartOutput = {
  __typename?: 'OrderSourceOnCartOutput';
  cart: Cart;
};

/** Contains details about the sales total amounts used to calculate the final price. */
export type OrderTotal = {
  __typename?: 'OrderTotal';
  /** The final base grand total amount in the base currency. */
  base_grand_total: Money;
  /** The applied discounts to the order. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The final total amount, including shipping, discounts, and taxes. */
  grand_total: Money;
  /** Details about the shipping and handling costs for the order. */
  shipping_handling?: Maybe<ShippingHandling>;
  /** The subtotal of the order, excluding shipping, discounts, and taxes. */
  subtotal: Money;
  /** The order tax details. */
  taxes?: Maybe<Array<Maybe<TaxItem>>>;
  /** The shipping amount for the order. */
  total_shipping: Money;
  /** The amount of tax applied to the order. */
  total_tax: Money;
};

export type OrderVehicle = {
  __typename?: 'OrderVehicle';
  /** Vehicle brand/make name */
  brand: Scalars['String'];
  /** Vehicle color */
  color?: Maybe<Color>;
  /** Is this the customer's default vehicle */
  is_default?: Maybe<Scalars['Boolean']>;
  /** License Plate number */
  license_number?: Maybe<Scalars['String']>;
  /** Vehicle model mileage */
  mileage?: Maybe<Scalars['String']>;
  /** Vehicle model name */
  model: Scalars['String'];
  /** Vehicle type */
  type?: Maybe<Scalars['String']>;
  /** Vehicle submodel aka model version */
  version?: Maybe<Scalars['String']>;
  /** VIN */
  vin?: Maybe<Scalars['String']>;
  /** Vehicle model year */
  year?: Maybe<Scalars['String']>;
};

export type OrderVehicleInput = {
  /** Vehicle brand/make name */
  brand?: InputMaybe<Scalars['String']>;
  /** Vehicle Color ID */
  color_id?: InputMaybe<Scalars['ID']>;
  /** License plate number */
  license_number?: InputMaybe<Scalars['String']>;
  /** Vehicle model mileage */
  mileage?: InputMaybe<Scalars['String']>;
  /** Vehicle model name */
  model?: InputMaybe<Scalars['String']>;
  /** Vehicle model year */
  model_year?: InputMaybe<Scalars['String']>;
  /** Vehicle type */
  type?: InputMaybe<Scalars['String']>;
  /** Vehicle submodel aka model version */
  version?: InputMaybe<Scalars['String']>;
  /** Vehicle Identification Number */
  vin?: InputMaybe<Scalars['String']>;
};

/** Contains required input for Payflow Express Checkout payments. */
export type PayflowExpressInput = {
  /** The unique ID of the PayPal user. */
  payer_id: Scalars['String'];
  /** The token returned by the createPaypalExpressToken mutation. */
  token: Scalars['String'];
};

/** A set of relative URLs that PayPal uses in response to various actions during the authorization process. Adobe Commerce prepends the base URL to this value to create a full URL. For example, if the full URL is https://www.example.com/path/to/page.html, the relative URL is path/to/page.html. Use this input for Payflow Link and Payments Advanced payment methods. */
export type PayflowLinkInput = {
  /** The relative URL of the page that PayPal redirects to when the buyer cancels the transaction in order to choose a different payment method. If the full URL to this page is https://www.example.com/paypal/action/cancel.html, the relative URL is paypal/action/cancel.html. */
  cancel_url: Scalars['String'];
  /** The relative URL of the transaction error page that PayPal redirects to upon payment error. If the full URL to this page is https://www.example.com/paypal/action/error.html, the relative URL is paypal/action/error.html. */
  error_url: Scalars['String'];
  /** The relative URL of the order confirmation page that PayPal redirects to when the payment is successful and additional confirmation is not needed. If the full URL to this page is https://www.example.com/paypal/action/return.html, the relative URL is paypal/action/return.html. */
  return_url: Scalars['String'];
};

/** Indicates the mode for payment. Applies to the Payflow Link and Payments Advanced payment methods. */
export enum PayflowLinkMode {
  /** @deprecated  */
  Live = 'LIVE',
  /** @deprecated  */
  Test = 'TEST'
}

/** Contains information used to generate PayPal iframe for transaction. Applies to Payflow Link and Payments Advanced payment methods. */
export type PayflowLinkToken = {
  __typename?: 'PayflowLinkToken';
  /** The mode for the Payflow transaction. */
  mode?: Maybe<PayflowLinkMode>;
  /** The PayPal URL used for requesting a Payflow form. */
  paypal_url?: Maybe<Scalars['String']>;
  /** The secure token generated by PayPal. */
  secure_token?: Maybe<Scalars['String']>;
  /** The secure token ID generated by PayPal. */
  secure_token_id?: Maybe<Scalars['String']>;
};

/** Contains information required to fetch payment token information for the Payflow Link and Payments Advanced payment methods. */
export type PayflowLinkTokenInput = {
  /** The unique ID that identifies the customer's cart. */
  cart_id: Scalars['String'];
};

/** Contains input for the Payflow Pro and Payments Pro payment methods. */
export type PayflowProInput = {
  /** Required input for credit card related information. */
  cc_details: CreditCardDetailsInput;
  /** Indicates whether details about the shopper's credit/debit card should be tokenized for later usage. Required only if Vault is enabled for the PayPal Payflow Pro payment integration. */
  is_active_payment_token_enabler?: InputMaybe<Scalars['Boolean']>;
};

/** Input required to complete payment. Applies to Payflow Pro and Payments Pro payment methods. */
export type PayflowProResponseInput = {
  /** The unique ID that identifies the shopper's cart. */
  cart_id: Scalars['String'];
  /** The payload returned from PayPal. */
  paypal_payload: Scalars['String'];
};

export type PayflowProResponseOutput = {
  __typename?: 'PayflowProResponseOutput';
  /** The cart with the updated selected payment method. */
  cart: Cart;
};

/** Contains the secure information used to authorize transaction. Applies to Payflow Pro and Payments Pro payment methods. */
export type PayflowProToken = {
  __typename?: 'PayflowProToken';
  /** The RESPMSG returned by PayPal. If the `result` is `0`, then `response_message` is `Approved`. */
  response_message: Scalars['String'];
  /** A non-zero value if any errors occurred. */
  result: Scalars['Int'];
  /** The RESULT returned by PayPal. A value of `0` indicates the transaction was approved. */
  result_code: Scalars['Int'];
  /** A secure token generated by PayPal. */
  secure_token: Scalars['String'];
  /** A secure token ID generated by PayPal. */
  secure_token_id: Scalars['String'];
};

/** Contains input required to fetch payment token information for the Payflow Pro and Payments Pro payment methods. */
export type PayflowProTokenInput = {
  /** The unique ID that identifies the shopper's cart. */
  cart_id: Scalars['String'];
  /** A set of relative URLs that PayPal uses for callback. */
  urls: PayflowProUrlInput;
};

/** Contains a set of relative URLs that PayPal uses in response to various actions during the authorization process. Magento prepends the base URL to this value to create a full URL. For example, if the full URL is https://www.example.com/path/to/page.html, the relative URL is path/to/page.html. Use this input for the Payflow Pro and Payment Pro payment methods. */
export type PayflowProUrlInput = {
  /** The relative URL of the page that PayPal redirects to when the buyer cancels the transaction in order to choose a different payment method. If the full URL to this page is https://www.example.com/paypal/action/cancel.html, the relative URL is paypal/action/cancel.html. */
  cancel_url: Scalars['String'];
  /** The relative URL of the transaction error page that PayPal redirects to upon payment error. If the full URL to this page is https://www.example.com/paypal/action/error.html, the relative URL is paypal/action/error.html. */
  error_url: Scalars['String'];
  /** The relative URL of the final confirmation page that PayPal redirects to upon payment success. If the full URL to this page is https://www.example.com/paypal/action/return.html, the relative URL is paypal/action/return.html. */
  return_url: Scalars['String'];
};

/** Defines the payment method. */
export type PaymentMethodInput = {
  /** The internal name for the payment method. */
  code: Scalars['String'];
  /** Required input for PayPal Hosted pro payments. */
  hosted_pro?: InputMaybe<HostedProInput>;
  /** Required input for Payflow Express Checkout payments. */
  payflow_express?: InputMaybe<PayflowExpressInput>;
  /** Required input for PayPal Payflow Link and Payments Advanced payments. */
  payflow_link?: InputMaybe<PayflowLinkInput>;
  /** Required input for PayPal Payflow Pro and Payment Pro payments. */
  payflowpro?: InputMaybe<PayflowProInput>;
  /** Required input for PayPal Payflow Pro vault payments. */
  payflowpro_cc_vault?: InputMaybe<VaultTokenInput>;
  /** Required input for Express Checkout and Payments Standard payments. */
  paypal_express?: InputMaybe<PaypalExpressInput>;
  /** The purchase order number. Optional for most payment methods. */
  purchase_order_number?: InputMaybe<Scalars['String']>;
};

/** The stored payment method available to the customer. */
export type PaymentToken = {
  __typename?: 'PaymentToken';
  /** A description of the stored account details. */
  details?: Maybe<Scalars['String']>;
  /** The payment method code associated with the token. */
  payment_method_code: Scalars['String'];
  /** The public hash of the token. */
  public_hash: Scalars['String'];
  /** Specifies the payment token type. */
  type: PaymentTokenTypeEnum;
};

/** The list of available payment token types. */
export enum PaymentTokenTypeEnum {
  /**
   * phpcs:ignore Magento2.GraphQL.ValidArgumentName
   * @deprecated
   */
  Account = 'account',
  /**
   * phpcs:ignore Magento2.GraphQL.ValidArgumentName
   * @deprecated
   */
  Card = 'card'
}

/** Contains required input for Express Checkout and Payments Standard payments. */
export type PaypalExpressInput = {
  /** The unique ID of the PayPal user. */
  payer_id: Scalars['String'];
  /** The token returned by the `createPaypalExpressToken` mutation. */
  token: Scalars['String'];
};

/** Deprecated. Use `PaypalExpressTokenOutput` instead. */
export type PaypalExpressToken = {
  __typename?: 'PaypalExpressToken';
  /**
   * A set of URLs that allow the buyer to authorize payment and adjust checkout details.
   * @deprecated Use `PaypalExpressTokenOutput.paypal_urls` instead.
   */
  paypal_urls?: Maybe<PaypalExpressUrlList>;
  /**
   * The token returned by PayPal.
   * @deprecated Use `PaypalExpressTokenOutput.token` instead.
   */
  token?: Maybe<Scalars['String']>;
};

/** Defines the attributes required to receive a payment token for Express Checkout and Payments Standard payment methods. */
export type PaypalExpressTokenInput = {
  /** The unique ID that identifies the customer's cart. */
  cart_id: Scalars['String'];
  /** The payment method code. */
  code: Scalars['String'];
  /** Indicates whether the buyer selected the quick checkout button. The default value is false. */
  express_button?: InputMaybe<Scalars['Boolean']>;
  /** A set of relative URLs that PayPal uses in response to various actions during the authorization process. */
  urls: PaypalExpressUrlsInput;
  /** Indicates whether the buyer clicked the PayPal credit button. The default value is false. */
  use_paypal_credit?: InputMaybe<Scalars['Boolean']>;
};

/** Contains the token returned by PayPal and a set of URLs that allow the buyer to authorize payment and adjust checkout details. Applies to Express Checkout and Payments Standard payment methods. */
export type PaypalExpressTokenOutput = {
  __typename?: 'PaypalExpressTokenOutput';
  /** A set of URLs that allow the buyer to authorize payment and adjust checkout details. */
  paypal_urls?: Maybe<PaypalExpressUrlList>;
  /** The token returned by PayPal. */
  token?: Maybe<Scalars['String']>;
};

/** Contains a set of URLs that allow the buyer to authorize payment and adjust checkout details for Express Checkout and Payments Standard transactions. */
export type PaypalExpressUrlList = {
  __typename?: 'PaypalExpressUrlList';
  /** The PayPal URL that allows the buyer to edit their checkout details. */
  edit?: Maybe<Scalars['String']>;
  /** The URL to the PayPal login page. */
  start?: Maybe<Scalars['String']>;
};

/** Contains a set of relative URLs that PayPal uses in response to various actions during the authorization process. Magento prepends the base URL to this value to create a full URL. For example, if the full URL is https://www.example.com/path/to/page.html, the relative URL is path/to/page.html. Use this input for Express Checkout and Payments Standard payment methods. */
export type PaypalExpressUrlsInput = {
  /** The relative URL of the page that PayPal redirects to when the buyer cancels the transaction in order to choose a different payment method. If the full URL to this page is https://www.example.com/paypal/action/cancel.html, the relative URL is paypal/action/cancel.html. */
  cancel_url: Scalars['String'];
  /** The relative URL of the page that PayPal redirects to when the payment has been put on hold for additional review. This condition mostly applies to ACH transactions, and is not applicable to most PayPal solutions. If the full URL to this page is https://www.example.com/paypal/action/success_pending.html, the relative URL is paypal/action/success_pending.html. */
  pending_url?: InputMaybe<Scalars['String']>;
  /** The relative URL of the final confirmation page that PayPal redirects to upon payment success. If the full URL to this page is https://www.example.com/paypal/action/return.html, the relative URL is paypal/action/return.html. */
  return_url: Scalars['String'];
  /** The relative URL of the order confirmation page that PayPal redirects to when the payment is successful and additional confirmation is not needed. Not applicable to most PayPal solutions. If the full URL to this page is https://www.example.com/paypal/action/success.html, the relative URL is paypal/action/success.html. */
  success_url?: InputMaybe<Scalars['String']>;
};

export enum Period {
  /** @deprecated  */
  Day = 'DAY',
  /** @deprecated  */
  Month = 'MONTH',
  /** @deprecated  */
  Year = 'YEAR'
}

export type PeriodCount = {
  __typename?: 'PeriodCount';
  period: Scalars['String'];
  value: Scalars['Float'];
};

/** Contains attributes specific to tangible products. */
export type PhysicalProductInterface = {
  /** The weight of the item, in units defined by the store. */
  weight?: Maybe<Scalars['Float']>;
};

/** Defines Pickup Location information. */
export type PickupLocation = {
  __typename?: 'PickupLocation';
  city?: Maybe<Scalars['String']>;
  contact_name?: Maybe<Scalars['String']>;
  country_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  pickup_location_code?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  region_id?: Maybe<Scalars['Int']>;
  street?: Maybe<Scalars['String']>;
};

/** PickupLocationFilterInput defines the list of attributes and filters for the search. */
export type PickupLocationFilterInput = {
  /** Filter by city. */
  city?: InputMaybe<FilterTypeInput>;
  /** Filter by country. */
  country_id?: InputMaybe<FilterTypeInput>;
  /** Filter by pickup location name. */
  name?: InputMaybe<FilterTypeInput>;
  /** Filter by pickup location code. */
  pickup_location_code?: InputMaybe<FilterTypeInput>;
  /** Filter by postcode. */
  postcode?: InputMaybe<FilterTypeInput>;
  /** Filter by region. */
  region?: InputMaybe<FilterTypeInput>;
  /** Filter by region id. */
  region_id?: InputMaybe<FilterTypeInput>;
  /** Filter by street. */
  street?: InputMaybe<FilterTypeInput>;
};

/** PickupLocationSortInput specifies attribute to use for sorting search results and indicates whether the results are sorted in ascending or descending order. */
export type PickupLocationSortInput = {
  /** City where pickup location is placed. */
  city?: InputMaybe<SortEnum>;
  /** Name of the contact person. */
  contact_name?: InputMaybe<SortEnum>;
  /** Id of the country in two letters. */
  country_id?: InputMaybe<SortEnum>;
  /** Description of the pickup location. */
  description?: InputMaybe<SortEnum>;
  /** Distance to the address, requested by distance filter. Applicable only with distance filter. If distance sort order is present, all other sort orders will be ignored. */
  distance?: InputMaybe<SortEnum>;
  /** Contact email of the pickup location. */
  email?: InputMaybe<SortEnum>;
  /** Contact fax of the pickup location. */
  fax?: InputMaybe<SortEnum>;
  /** Geographic latitude where pickup location is placed. */
  latitude?: InputMaybe<SortEnum>;
  /** Geographic longitude where pickup location is placed. */
  longitude?: InputMaybe<SortEnum>;
  /** The pickup location name. Customer use this to identify the pickup location. */
  name?: InputMaybe<SortEnum>;
  /** Contact phone number of the pickup location. */
  phone?: InputMaybe<SortEnum>;
  /** A code assigned to pickup location to identify the source. */
  pickup_location_code?: InputMaybe<SortEnum>;
  /** Postcode where pickup location is placed. */
  postcode?: InputMaybe<SortEnum>;
  /** Name of the region. */
  region?: InputMaybe<SortEnum>;
  /** Id of the region. */
  region_id?: InputMaybe<SortEnum>;
  /** Street where pickup location is placed. */
  street?: InputMaybe<SortEnum>;
};

/** Top level object returned in a pickup locations search. */
export type PickupLocations = {
  __typename?: 'PickupLocations';
  /** An array of pickup locations that match the specific search request. */
  items?: Maybe<Array<Maybe<PickupLocation>>>;
  /** An object that includes the page_info and currentPage values specified in the query. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The number of products returned. */
  total_count?: Maybe<Scalars['Int']>;
};

/** Specifies the quote to be converted to an order. */
export type PlaceOrderInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
};

/** Contains the results of the request to place an order. */
export type PlaceOrderOutput = {
  __typename?: 'PlaceOrderOutput';
  /** The ID of the order. */
  order: Order;
};

export type PlanUpcomingServiceInput = {
  comment?: InputMaybe<Scalars['String']>;
  date: Scalars['String'];
  service_sku?: InputMaybe<Scalars['String']>;
};

/** Deprecated. Use `ProductPrice` instead. Defines the price of a product as well as any tax-related adjustments. */
export type Price = {
  __typename?: 'Price';
  /**
   * An array that provides information about tax, weee, or weee_tax adjustments.
   * @deprecated Use `ProductPrice` instead.
   */
  adjustments?: Maybe<Array<Maybe<PriceAdjustment>>>;
  /**
   * The price of a product plus a three-letter currency code.
   * @deprecated Use `ProductPrice` instead.
   */
  amount?: Maybe<Money>;
};

/** Deprecated. Taxes will be included or excluded in the price. Defines the amount of money to apply as an adjustment, the type of adjustment to apply, and whether the item is included or excluded from the adjustment. */
export type PriceAdjustment = {
  __typename?: 'PriceAdjustment';
  /** The amount of the price adjustment and its currency code. */
  amount?: Maybe<Money>;
  /**
   * Indicates whether the adjustment involves tax, weee, or weee_tax.
   * @deprecated `PriceAdjustment` is deprecated.
   */
  code?: Maybe<PriceAdjustmentCodesEnum>;
  /**
   * Indicates whether the entity described by the code attribute is included or excluded from the adjustment.
   * @deprecated `PriceAdjustment` is deprecated.
   */
  description?: Maybe<PriceAdjustmentDescriptionEnum>;
};

/** `PriceAdjustment.code` is deprecated. */
export enum PriceAdjustmentCodesEnum {
  /** @deprecated `PriceAdjustmentCodesEnum` is deprecated. Tax is included or excluded in the price. Tax is not shown separately in Catalog. */
  Tax = 'TAX',
  /** @deprecated WEEE code is deprecated. Use `fixed_product_taxes.label` instead. */
  Weee = 'WEEE',
  /** @deprecated Use `fixed_product_taxes` instead.  Tax is included or excluded in price. The tax is not shown separtely in Catalog. */
  WeeeTax = 'WEEE_TAX'
}

/** `PriceAdjustmentDescriptionEnum` is deprecated. States whether a price adjustment is included or excluded. */
export enum PriceAdjustmentDescriptionEnum {
  /** @deprecated  */
  Excluded = 'EXCLUDED',
  /** @deprecated  */
  Included = 'INCLUDED'
}

/** Contains the price range for a product. If the product has a single price, the minimum and maximum price will be the same. */
export type PriceRange = {
  __typename?: 'PriceRange';
  /** The highest possible price for the product. */
  maximum_price?: Maybe<ProductPrice>;
  /** The lowest possible price for the product. */
  minimum_price: ProductPrice;
};

/** Defines the price type. */
export enum PriceTypeEnum {
  /** @deprecated  */
  Dynamic = 'DYNAMIC',
  /** @deprecated  */
  Fixed = 'FIXED',
  /** @deprecated  */
  Percent = 'PERCENT'
}

/** Defines whether a bundle product's price is displayed as the lowest possible value or as a range. */
export enum PriceViewEnum {
  /** @deprecated  */
  AsLowAs = 'AS_LOW_AS',
  /** @deprecated  */
  PriceRange = 'PRICE_RANGE'
}

/** Contains a product attribute code and value. */
export type ProductAttribute = {
  __typename?: 'ProductAttribute';
  /** The unique identifier for a product attribute code. */
  code: Scalars['String'];
  /** The display value of the attribute. */
  value: Scalars['String'];
};

/** ProductAttributeFilterInput defines the filters to be used in the search. A filter contains at least one attribute, a comparison operator, and the value that is being searched for. */
export type ProductAttributeFilterInput = {
  /** Attribute label: Ampere */
  ampere?: InputMaybe<FilterEqualTypeInput>;
  ar_available?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Aspect Ratio */
  aspect_ratio?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Car Batteries Ampere Capacity */
  car_batteries_ampere?: InputMaybe<FilterEqualTypeInput>;
  /** Deprecated: use `category_uid` to filter product by category ID. */
  category_id?: InputMaybe<FilterEqualTypeInput>;
  /** Filter product by the unique ID for a `CategoryInterface` object. */
  category_uid?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Country of origin  */
  country_of_origin?: InputMaybe<FilterEqualTypeInput>;
  created_at?: InputMaybe<FilterTypeInput>;
  /** Attribute label: Creation Date */
  creation_date?: InputMaybe<FilterRangeTypeInput>;
  /** Attribute label: Description */
  description?: InputMaybe<FilterMatchTypeInput>;
  /** Attribute label: diameter */
  diameter?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Has Deal */
  has_deal?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Is Bookable Service */
  is_bookable_service?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Is Bookable Service Add-On */
  is_bookable_service_addon?: InputMaybe<FilterEqualTypeInput>;
  is_coming_soon?: InputMaybe<FilterEqualTypeInput>;
  is_discontinued?: InputMaybe<FilterEqualTypeInput>;
  /** Filter bookable services in store locator. */
  is_enabled_in_store?: InputMaybe<Scalars['Boolean']>;
  /** Attribute label: Is Featured */
  is_featured?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Show As Featured Offer */
  is_featured_offer?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Is a spare part? */
  is_spare_part?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Warranty */
  mileage_warranty?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Product Name */
  name?: InputMaybe<FilterMatchTypeInput>;
  /** Filter product by news_from_date. */
  news_from_date?: InputMaybe<FilterTypeInput>;
  /** Filter product by news_to_date. */
  news_to_date?: InputMaybe<FilterTypeInput>;
  /** Attribute label: Price */
  price?: InputMaybe<FilterRangeTypeInput>;
  /** Attribute label: Brand */
  product_brand_id?: InputMaybe<FilterEqualTypeInput>;
  /** Filters by offer type */
  product_offer_type?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Short Description */
  short_description?: InputMaybe<FilterMatchTypeInput>;
  /** Attribute label: SKU */
  sku?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Tire Type */
  type?: InputMaybe<FilterEqualTypeInput>;
  /** The part of the URL that identifies the product */
  url_key?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: width */
  width?: InputMaybe<FilterEqualTypeInput>;
};

/** Specifies the attribute to use for sorting search results and indicates whether the results are sorted in ascending or descending order. It's possible to sort products using searchable attributes with enabled 'Use in Filter Options' option */
export type ProductAttributeSortInput = {
  /** Attribute label: Creation Date */
  creation_date?: InputMaybe<SortEnum>;
  featured_order?: InputMaybe<SortEnum>;
  is_featured_offer?: InputMaybe<SortEnum>;
  /** Attribute label: Product Name */
  name?: InputMaybe<SortEnum>;
  /** Sort by the position assigned to each product. */
  position?: InputMaybe<SortEnum>;
  /** Attribute label: Price */
  price?: InputMaybe<SortEnum>;
  /** Sort by the search relevance score (default). */
  relevance?: InputMaybe<SortEnum>;
  /** Attribute label: Tire Type */
  type?: InputMaybe<SortEnum>;
};

/** Contains the discount applied to a product price. */
export type ProductDiscount = {
  __typename?: 'ProductDiscount';
  /** The actual value of the discount. */
  amount_off?: Maybe<Scalars['Float']>;
  /** The discount expressed a percentage. */
  percent_off?: Maybe<Scalars['Float']>;
};

/** ProductFilterInput is deprecated, use @ProductAttributeFilterInput instead. ProductFilterInput defines the filters to be used in the search. A filter contains at least one attribute, a comparison operator, and the value that is being searched for. */
export type ProductFilterInput = {
  /** The category ID the product belongs to. */
  category_id?: InputMaybe<FilterTypeInput>;
  /** The product's country of origin. */
  country_of_manufacture?: InputMaybe<FilterTypeInput>;
  /** The timestamp indicating when the product was created. */
  created_at?: InputMaybe<FilterTypeInput>;
  /** The name of a custom layout. */
  custom_layout?: InputMaybe<FilterTypeInput>;
  /** XML code that is applied as a layout update to the product page. */
  custom_layout_update?: InputMaybe<FilterTypeInput>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: InputMaybe<FilterTypeInput>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: InputMaybe<FilterTypeInput>;
  /** Indicates whether additional attributes have been created for the product. */
  has_options?: InputMaybe<FilterTypeInput>;
  /** The relative path to the main image on the product page. */
  image?: InputMaybe<FilterTypeInput>;
  /** The label assigned to a product image. */
  image_label?: InputMaybe<FilterTypeInput>;
  /** A number representing the product's manufacturer. */
  manufacturer?: InputMaybe<FilterTypeInput>;
  /** The numeric maximal price of the product. Do not include the currency code. */
  max_price?: InputMaybe<FilterTypeInput>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: InputMaybe<FilterTypeInput>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: InputMaybe<FilterTypeInput>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: InputMaybe<FilterTypeInput>;
  /** The numeric minimal price of the product. Do not include the currency code. */
  min_price?: InputMaybe<FilterTypeInput>;
  /** The product name. Customers use this name to identify the product. */
  name?: InputMaybe<FilterTypeInput>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  news_from_date?: InputMaybe<FilterTypeInput>;
  /** The end date for new product listings. */
  news_to_date?: InputMaybe<FilterTypeInput>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: InputMaybe<FilterTypeInput>;
  /** The keyword required to perform a logical OR comparison. */
  or?: InputMaybe<ProductFilterInput>;
  /** The price of an item. */
  price?: InputMaybe<FilterTypeInput>;
  /** Indicates whether the product has required options. */
  required_options?: InputMaybe<FilterTypeInput>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: InputMaybe<FilterTypeInput>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: InputMaybe<FilterTypeInput>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: InputMaybe<FilterTypeInput>;
  /** The label assigned to a product's small image. */
  small_image_label?: InputMaybe<FilterTypeInput>;
  /** The beginning date that a product has a special price. */
  special_from_date?: InputMaybe<FilterTypeInput>;
  /** The discounted price of the product. Do not include the currency code. */
  special_price?: InputMaybe<FilterTypeInput>;
  /** The end date that a product has a special price. */
  special_to_date?: InputMaybe<FilterTypeInput>;
  /** The file name of a swatch image. */
  swatch_image?: InputMaybe<FilterTypeInput>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: InputMaybe<FilterTypeInput>;
  /** The label assigned to a product's thumbnail image. */
  thumbnail_label?: InputMaybe<FilterTypeInput>;
  /** The price when tier pricing is in effect and the items purchased threshold has been reached. */
  tier_price?: InputMaybe<FilterTypeInput>;
  /** The timestamp indicating when the product was updated. */
  updated_at?: InputMaybe<FilterTypeInput>;
  /** The part of the URL that identifies the product */
  url_key?: InputMaybe<FilterTypeInput>;
  url_path?: InputMaybe<FilterTypeInput>;
  /** The weight of the item, in units defined by the store. */
  weight?: InputMaybe<FilterTypeInput>;
};

/** Contains product image information, including the image URL and label. */
export type ProductImage = MediaGalleryInterface & {
  __typename?: 'ProductImage';
  /** Indicates whether the image is hidden from view. */
  disabled?: Maybe<Scalars['Boolean']>;
  /** The label of the product image or video. */
  label?: Maybe<Scalars['String']>;
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars['Int']>;
  /** The URL of the product image or video. */
  url?: Maybe<Scalars['String']>;
};

/** Product Information used for Pickup Locations search. */
export type ProductInfoInput = {
  /** Product SKU. */
  sku: Scalars['String'];
};

/** The ProductInterface contains attributes that are common to all types of products. Note that descriptions may not be available for custom and EAV attributes. */
export type ProductInterface = {
  /** @deprecated Use the `custom_attributes` field instead. */
  ampere?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  aspect_ratio?: Maybe<Scalars['Int']>;
  /** Attribute set information */
  attribute_set?: Maybe<AttributeSetInformation>;
  /**
   * The attribute set assigned to the product.
   * @deprecated The field should not be used on the storefront.
   */
  attribute_set_id?: Maybe<Scalars['Int']>;
  /** List of product attributes */
  attributes?: Maybe<Array<Maybe<CustomAttribute>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  average_duration?: Maybe<Scalars['String']>;
  /** Attributes regarding this bookable service in the given store locator. */
  bookable_service?: Maybe<BookableService>;
  /** The product brand. */
  brand?: Maybe<Brand>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
  canonical_url?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  car_batteries_ampere?: Maybe<Scalars['Int']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  color?: Maybe<Scalars['Int']>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  country_of_origin?: Maybe<Scalars['Int']>;
  /**
   * Timestamp indicating when the product was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  creation_date?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  creation_id?: Maybe<Scalars['Int']>;
  /** Crosssell Products */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /**
   * List of product custom labels
   * @deprecated Use the `custom_attributes` field instead.
   */
  custom_labels: Array<Maybe<Label>>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  /** @deprecated Use the `custom_attributes` field instead. */
  diameter?: Maybe<Scalars['Int']>;
  expected_shipping_fees?: Maybe<Scalars['Float']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  exterior_hand_wash?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_age_group?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_age_range?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_baby_food_stage?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_brand?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_capacity?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_color?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_compatible_devices?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_decor_style?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_digital_zoom?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_display_technology?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_finish?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_gemstone?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_gender?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_health_concern?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_ingredients?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_is_assembly_required?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_material?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_maximum_weight?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_megapixels?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_minimum_weight?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_model?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_number_of_licenses?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_operating_system?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_optical_zoom?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_package_quantity?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_pattern?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_depth?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_form?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_height?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_length?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_weight?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_width?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_recommended_use?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_resolution?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_scent?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_screen_size?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_shoe_width?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_size?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_storage_capacity?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_style?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_system_requirements?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_thread_count?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_video_game_platform?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  featured_order?: Maybe<Scalars['Int']>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  has_deal?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  hover_cleaning?: Maybe<Scalars['Int']>;
  /**
   * The ID number assigned to the product.
   * @deprecated Use the `uid` field instead.
   */
  id?: Maybe<Scalars['Int']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** @deprecated Use the `custom_attributes` field instead. */
  in_store_only?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  interior_cleaning?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  interior_vacuum_clean?: Maybe<Scalars['Int']>;
  /** Check if product is a best seller */
  is_best_seller?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  is_bookable_service?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  is_bookable_service_addon?: Maybe<Scalars['Int']>;
  /** if the product favorited by the logged in user */
  is_favorited?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  is_featured?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  is_featured_offer?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  is_november_deal?: Maybe<Scalars['Int']>;
  is_van_installment_enabled: Scalars['Boolean'];
  /** Indicates whether the product is the wiper that has the gift or not. */
  is_wiper: Scalars['Boolean'];
  /** product labels */
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * A number representing the product's manufacturer.
   * @deprecated Use the `custom_attributes` field instead.
   */
  manufacturer?: Maybe<Scalars['Int']>;
  /** An array of media gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use `media_gallery` instead.
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  mileage_warranty?: Maybe<Scalars['String']>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']>;
  /** Quantity of product left in customer's choosen source */
  only_x_left_in_source?: Maybe<Scalars['Float']>;
  /** Product stock only x left count */
  only_x_left_in_stock?: Maybe<Scalars['Float']>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  pattern?: Maybe<Scalars['String']>;
  /**
   * Indicates the price of an item.
   * @deprecated Use `price_range` for product price information.
   */
  price?: Maybe<ProductPrices>;
  /** The range of prices for the product */
  price_range: PriceRange;
  /** An array of `TierPrice` objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_brand_id?: Maybe<Scalars['Int']>;
  /** An array of `ProductLinks` objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  product_offer_type?: Maybe<Scalars['Int']>;
  /** The average of all the ratings given to the product. */
  rating_summary: Scalars['Float'];
  /** Related Products */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The total count of all the reviews given to the product. */
  review_count: Scalars['Int'];
  /** The list of products reviews. */
  reviews: ProductReviews;
  /** @deprecated Use the `custom_attributes` field instead. */
  serving_order?: Maybe<Scalars['Int']>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  /**
   * The beginning date that a product has a special price.
   * @deprecated The field should not be used on the storefront.
   */
  special_from_date?: Maybe<Scalars['String']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']>;
  /** Time left for expiry of special price in seconds */
  special_price_time_left?: Maybe<Scalars['Int']>;
  /** The end date for a product with a special price. */
  special_to_date?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  speed?: Maybe<Scalars['String']>;
  /** List of product attributes */
  stockQtyTerm?: Maybe<Array<Maybe<ProductStockQty>>>;
  /** Stock status of the product */
  stock_status?: Maybe<ProductStockStatus>;
  /** The file name of a swatch image. */
  swatch_image?: Maybe<Scalars['String']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  type?: Maybe<Scalars['Int']>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use `__typename` instead.
   */
  type_id?: Maybe<Scalars['String']>;
  /** The unique ID for a `ProductInterface` object. */
  uid: Scalars['ID'];
  /**
   * Timestamp indicating when the product was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']>;
  /** Upsell Products */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  width?: Maybe<Scalars['Int']>;
};


/** The ProductInterface contains attributes that are common to all types of products. Note that descriptions may not be available for custom and EAV attributes. */
export type ProductInterfaceAttributesArgs = {
  groupCode?: InputMaybe<Scalars['String']>;
};


/** The ProductInterface contains attributes that are common to all types of products. Note that descriptions may not be available for custom and EAV attributes. */
export type ProductInterfaceBookable_ServiceArgs = {
  storeLocatorId?: InputMaybe<Scalars['Int']>;
};


/** The ProductInterface contains attributes that are common to all types of products. Note that descriptions may not be available for custom and EAV attributes. */
export type ProductInterfaceExpected_Shipping_FeesArgs = {
  sourceCode?: InputMaybe<Scalars['String']>;
};


/** The ProductInterface contains attributes that are common to all types of products. Note that descriptions may not be available for custom and EAV attributes. */
export type ProductInterfaceReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** An implementation of `ProductLinksInterface`. */
export type ProductLinks = ProductLinksInterface & {
  __typename?: 'ProductLinks';
  /** One of related, associated, upsell, or crosssell. */
  link_type?: Maybe<Scalars['String']>;
  /** The SKU of the linked product. */
  linked_product_sku?: Maybe<Scalars['String']>;
  /** The type of linked product (simple, virtual, bundle, downloadable, grouped, configurable). */
  linked_product_type?: Maybe<Scalars['String']>;
  /** The position within the list of product links. */
  position?: Maybe<Scalars['Int']>;
  /** The identifier of the linked product. */
  sku?: Maybe<Scalars['String']>;
};

/** Contains information about linked products, including the link type and product type of each item. */
export type ProductLinksInterface = {
  /** One of related, associated, upsell, or crosssell. */
  link_type?: Maybe<Scalars['String']>;
  /** The SKU of the linked product. */
  linked_product_sku?: Maybe<Scalars['String']>;
  /** The type of linked product (simple, virtual, bundle, downloadable, grouped, configurable). */
  linked_product_type?: Maybe<Scalars['String']>;
  /** The position within the list of product links. */
  position?: Maybe<Scalars['Int']>;
  /** The identifier of the linked product. */
  sku?: Maybe<Scalars['String']>;
};

/** Contains an image in base64 format and basic information about the image. */
export type ProductMediaGalleryEntriesContent = {
  __typename?: 'ProductMediaGalleryEntriesContent';
  /** The image in base64 format. */
  base64_encoded_data?: Maybe<Scalars['String']>;
  /** The file name of the image. */
  name?: Maybe<Scalars['String']>;
  /** The MIME type of the file, such as image/png. */
  type?: Maybe<Scalars['String']>;
};

/** Contains a link to a video file and basic information about the video. */
export type ProductMediaGalleryEntriesVideoContent = {
  __typename?: 'ProductMediaGalleryEntriesVideoContent';
  /** Must be external-video. */
  media_type?: Maybe<Scalars['String']>;
  /** A description of the video. */
  video_description?: Maybe<Scalars['String']>;
  /** Optional data about the video. */
  video_metadata?: Maybe<Scalars['String']>;
  /** Describes the video source. */
  video_provider?: Maybe<Scalars['String']>;
  /** The title of the video. */
  video_title?: Maybe<Scalars['String']>;
  /** The URL to the video. */
  video_url?: Maybe<Scalars['String']>;
};

export type ProductOfferAggregation = {
  __typename?: 'ProductOfferAggregation';
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** Represents a product price. */
export type ProductPrice = {
  __typename?: 'ProductPrice';
  /** The price discount. Represents the difference between the regular and final price. */
  discount?: Maybe<ProductDiscount>;
  /** The final price of the product after applying discounts. */
  final_price: Money;
  /** An array of the multiple Fixed Product Taxes that can be applied to a product price. */
  fixed_product_taxes?: Maybe<Array<Maybe<FixedProductTax>>>;
  /** The regular price of the product. */
  regular_price: Money;
};

/** Deprecated. Use `PriceRange` instead. Contains the regular price of an item, as well as its minimum and maximum prices. Only composite products, which include bundle, configurable, and grouped products, can contain a minimum and maximum price. */
export type ProductPrices = {
  __typename?: 'ProductPrices';
  /**
   * The highest possible final price for all the options defined within a composite product. If you are specifying a price range, this would be the `to` value.
   * @deprecated Use `PriceRange.maximum_price` instead.
   */
  maximalPrice?: Maybe<Price>;
  /**
   * The lowest possible final price for all the options defined within a composite product. If you are specifying a price range, this would be the `from` value.
   * @deprecated Use `PriceRange.minimum_price` instead.
   */
  minimalPrice?: Maybe<Price>;
  /**
   * The base price of a product.
   * @deprecated Use `regular_price` from `PriceRange.minimum_price` or `PriceRange.maximum_price` instead.
   */
  regularPrice?: Maybe<Price>;
};

/** Contains details of a product review. */
export type ProductReview = {
  __typename?: 'ProductReview';
  /** The average of all ratings for this product. */
  average_rating: Scalars['Float'];
  /** The date the review was created. */
  created_at: Scalars['String'];
  /** The customer's nickname. Defaults to the customer name, if logged in. */
  nickname: Scalars['String'];
  /** The reviewed product. */
  product: ProductInterface;
  /** An array of ratings by rating category, such as quality, price, and value. */
  ratings_breakdown: Array<Maybe<ProductReviewRating>>;
  /** The summary (title) of the review. */
  summary: Scalars['String'];
  /** The review text. */
  text: Scalars['String'];
};

/** Contains data about a single aspect of a product review. */
export type ProductReviewRating = {
  __typename?: 'ProductReviewRating';
  /** The label assigned to an aspect of a product that is being rated, such as quality or price. */
  name: Scalars['String'];
  /** The rating value given by customer. By default, possible values range from 1 to 5. */
  value: Scalars['String'];
};

/** Contains the reviewer's rating for a single aspect of a review. */
export type ProductReviewRatingInput = {
  /** An encoded rating ID. */
  id: Scalars['String'];
  /** An encoded rating value ID. */
  value_id: Scalars['String'];
};

/** Contains details about a single aspect of a product review. */
export type ProductReviewRatingMetadata = {
  __typename?: 'ProductReviewRatingMetadata';
  /** An encoded rating ID. */
  id: Scalars['String'];
  /** The label assigned to an aspect of a product that is being rated, such as quality or price. */
  name: Scalars['String'];
  /** List of product review ratings sorted by position. */
  values: Array<Maybe<ProductReviewRatingValueMetadata>>;
};

/** Contains details about a single value in a product review. */
export type ProductReviewRatingValueMetadata = {
  __typename?: 'ProductReviewRatingValueMetadata';
  /** A ratings scale, such as the number of stars awarded. */
  value: Scalars['String'];
  /** An encoded rating value ID. */
  value_id: Scalars['String'];
};

/** Contains an array of metadata about each aspect of a product review. */
export type ProductReviewRatingsMetadata = {
  __typename?: 'ProductReviewRatingsMetadata';
  /** An array of product reviews sorted by position. */
  items: Array<Maybe<ProductReviewRatingMetadata>>;
};

/** Contains an array of product reviews. */
export type ProductReviews = {
  __typename?: 'ProductReviews';
  /** An array of product reviews. */
  items: Array<Maybe<ProductReview>>;
  /** Metadata for pagination rendering. */
  page_info: SearchResultPageInfo;
};

/** Deprecated. Use `ProductAttributeSortInput` instead. Specifies the attribute to use for sorting search results and indicates whether the results are sorted in ascending or descending order. */
export type ProductSortInput = {
  /** The product's country of origin. */
  country_of_manufacture?: InputMaybe<SortEnum>;
  /** The timestamp indicating when the product was created. */
  created_at?: InputMaybe<SortEnum>;
  /** The name of a custom layout. */
  custom_layout?: InputMaybe<SortEnum>;
  /** XML code that is applied as a layout update to the product page. */
  custom_layout_update?: InputMaybe<SortEnum>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: InputMaybe<SortEnum>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: InputMaybe<SortEnum>;
  /** Indicates whether additional attributes have been created for the product. */
  has_options?: InputMaybe<SortEnum>;
  /** The relative path to the main image on the product page. */
  image?: InputMaybe<SortEnum>;
  /** The label assigned to a product image. */
  image_label?: InputMaybe<SortEnum>;
  /** A number representing the product's manufacturer. */
  manufacturer?: InputMaybe<SortEnum>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: InputMaybe<SortEnum>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: InputMaybe<SortEnum>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: InputMaybe<SortEnum>;
  /** The product name. Customers use this name to identify the product. */
  name?: InputMaybe<SortEnum>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  news_from_date?: InputMaybe<SortEnum>;
  /** The end date for new product listings. */
  news_to_date?: InputMaybe<SortEnum>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: InputMaybe<SortEnum>;
  /** The price of the item. */
  price?: InputMaybe<SortEnum>;
  /** Indicates whether the product has required options. */
  required_options?: InputMaybe<SortEnum>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: InputMaybe<SortEnum>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: InputMaybe<SortEnum>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: InputMaybe<SortEnum>;
  /** The label assigned to a product's small image. */
  small_image_label?: InputMaybe<SortEnum>;
  /** The beginning date that a product has a special price. */
  special_from_date?: InputMaybe<SortEnum>;
  /** The discounted price of the product. */
  special_price?: InputMaybe<SortEnum>;
  /** The end date that a product has a special price. */
  special_to_date?: InputMaybe<SortEnum>;
  /** Indicates the criteria to sort swatches. */
  swatch_image?: InputMaybe<SortEnum>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: InputMaybe<SortEnum>;
  /** The label assigned to a product's thumbnail image. */
  thumbnail_label?: InputMaybe<SortEnum>;
  /** The price when tier pricing is in effect and the items purchased threshold has been reached. */
  tier_price?: InputMaybe<SortEnum>;
  /** The timestamp indicating when the product was updated. */
  updated_at?: InputMaybe<SortEnum>;
  /** The part of the URL that identifies the product */
  url_key?: InputMaybe<SortEnum>;
  url_path?: InputMaybe<SortEnum>;
  /** The weight of the item, in units defined by the store. */
  weight?: InputMaybe<SortEnum>;
};

export type ProductStockQty = {
  __typename?: 'ProductStockQty';
  max_sale_qty?: Maybe<Scalars['Float']>;
  min_sale_qty?: Maybe<Scalars['Float']>;
};

/** This enumeration states whether a product stock status is in stock or out of stock */
export enum ProductStockStatus {
  /** @deprecated  */
  InStock = 'IN_STOCK',
  /** @deprecated  */
  OutOfStock = 'OUT_OF_STOCK'
}

/** Deprecated. Use `TierPrice` instead. Defines a tier price, which is a quantity discount offered to a specific customer group. */
export type ProductTierPrices = {
  __typename?: 'ProductTierPrices';
  /**
   * The ID of the customer group.
   * @deprecated Not relevant for the storefront.
   */
  customer_group_id?: Maybe<Scalars['String']>;
  /**
   * The percentage discount of the item.
   * @deprecated Use `TierPrice.discount` instead.
   */
  percentage_value?: Maybe<Scalars['Float']>;
  /**
   * The number of items that must be purchased to qualify for tier pricing.
   * @deprecated Use `TierPrice.quantity` instead.
   */
  qty?: Maybe<Scalars['Float']>;
  /**
   * The price of the fixed price item.
   * @deprecated Use `TierPrice.final_price` instead.
   */
  value?: Maybe<Scalars['Float']>;
  /**
   * The ID assigned to the website.
   * @deprecated Not relevant for the storefront.
   */
  website_id?: Maybe<Scalars['Float']>;
};

/** Contains information about a product video. */
export type ProductVideo = MediaGalleryInterface & {
  __typename?: 'ProductVideo';
  /** Indicates whether the image is hidden from view. */
  disabled?: Maybe<Scalars['Boolean']>;
  /** The label of the product image or video. */
  label?: Maybe<Scalars['String']>;
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars['Int']>;
  /** The URL of the product image or video. */
  url?: Maybe<Scalars['String']>;
  /** Contains a `ProductMediaGalleryEntriesVideoContent` object. */
  video_content?: Maybe<ProductMediaGalleryEntriesVideoContent>;
};

/** Contains the results of a `products` query. */
export type Products = {
  __typename?: 'Products';
  /** A bucket that contains the attribute code and label for each filterable option. */
  aggregations?: Maybe<Array<Maybe<Aggregation>>>;
  /**
   * Layered navigation filters array.
   * @deprecated Use `aggregations` instead.
   */
  filters?: Maybe<Array<Maybe<LayerFilter>>>;
  /** An array of products that match the specified search criteria. */
  items?: Maybe<Array<Maybe<ProductInterface>>>;
  /** An object that includes the page_info and currentPage values specified in the query. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** An object that includes the default sort field and all available sort fields. */
  sort_fields?: Maybe<SortFields>;
  /** An array of search suggestions for case when search query have no results. */
  suggestions?: Maybe<Array<Maybe<SearchSuggestion>>>;
  /** The number of products that are marked as visible. By default, in complex products, parent products are visible, but their child products are not. */
  total_count?: Maybe<Scalars['Int']>;
};


/** Contains the results of a `products` query. */
export type ProductsAggregationsArgs = {
  filter?: InputMaybe<AggregationsFilterInput>;
};

export type Query = {
  __typename?: 'Query';
  /** @deprecated Use customAttributeMetadata instead */
  AttributesData?: Maybe<CustomAttributeMetadata>;
  VanServiceProduct?: Maybe<ProductInterface>;
  admin: Admin;
  adminRoles: AdminRoles;
  admins: Admins;
  /** Fetch Customer Vehicles saved, and filter through them based on input. */
  allCustomerVehicles: CustomerVehiclesOutput;
  /** Get a list of available store views and their config information. */
  availableStores?: Maybe<Array<Maybe<StoreConfig>>>;
  /** get brand by url key */
  brandByUrlKey: Brand;
  /** List all brands */
  brands: Array<Maybe<Brand>>;
  /** Get enabled cancellation reasons for orders/store closing. */
  cancellationReasons: Array<Maybe<Scalars['String']>>;
  /** Return information about the specified shopping cart. */
  cart?: Maybe<Cart>;
  /** Return a list of categories that match the specified filter. */
  categories?: Maybe<CategoryResult>;
  /**
   * Search for categories that match the criteria specified in the `search` and `filter` attributes.
   * @deprecated Use `categories` instead.
   */
  category?: Maybe<CategoryTree>;
  /**
   * Return an array of categories based on the specified filters.
   * @deprecated Use `categories` instead.
   */
  categoryList?: Maybe<Array<Maybe<CategoryTree>>>;
  /** Return Terms and Conditions configuration information. */
  checkoutAgreements?: Maybe<Array<Maybe<CheckoutAgreement>>>;
  /** The city query provides information for a single city. */
  city?: Maybe<City>;
  /** Return information about CMS blocks. */
  cmsBlocks?: Maybe<CmsBlocks>;
  /** Return details about a CMS page. */
  cmsPage?: Maybe<CmsPage>;
  /** Return products that have been added to the specified compare list. */
  compareList?: Maybe<CompareList>;
  contact_form_subjects?: Maybe<Array<Maybe<ContactFormSubject>>>;
  /** The countries query provides information for all countries. */
  countries?: Maybe<Array<Maybe<Country>>>;
  /** The countries query provides information for a single country. */
  country?: Maybe<Country>;
  /** Return information about the store's currency. */
  currency?: Maybe<Currency>;
  /** Return the attribute type, given an attribute code and entity type. */
  customAttributeMetadata?: Maybe<CustomAttributeMetadata>;
  /** Returns array of all custom attributes belonging to an entity in a specific attribute set along with their metadata */
  customAttributeMetadataByEntity?: Maybe<CustomAttributeMetadata>;
  /** Return detailed information about a customer account. */
  customer?: Maybe<Customer>;
  customerById?: Maybe<Customer>;
  /** Return information about the customer's shopping cart. */
  customerCart: Cart;
  /** Return a list of downloadable products the customer has purchased. */
  customerDownloadableProducts?: Maybe<CustomerDownloadableProducts>;
  /** Get latest customer order */
  customerLatestOrder?: Maybe<CustomerOrder>;
  /** Get order and details by id */
  customerOrder?: Maybe<CustomerOrder>;
  /** Get order and details by increment id */
  customerOrderByIncrementId?: Maybe<CustomerOrder>;
  /** @deprecated Use the `customer` query instead. */
  customerOrders?: Maybe<CustomerOrders>;
  /** Get order and details by increment id */
  customerOrdersByIncrementId?: Maybe<Array<Maybe<CustomerOrder>>>;
  /** Get orders and details by payment id */
  customerOrdersByPaymentId?: Maybe<AcceptOrdersOutput>;
  /** Get order and details by increment id */
  customerOrdersSearchByIncrementId?: Maybe<CustomerOrderSearchOutput>;
  /** Return a list of customer payment tokens stored in the vault. */
  customerPaymentTokens?: Maybe<CustomerPaymentTokens>;
  /** Returns Substitution Model that contains info about order replacements */
  customerSubstitution?: Maybe<Substitution>;
  /** Returns Substitution Model that contains info about order replacements */
  customerSubstitutionById?: Maybe<Substitution>;
  /** Returns Substitution Item Model that contains info about order replacements */
  customerSubstitutionItemById: SubstitutionItem;
  customers?: Maybe<Customers>;
  deals_offers: Array<Maybe<Offer>>;
  /** Dates and time slots availale for delivery */
  deliverydays?: Maybe<Array<Maybe<Day>>>;
  /** Frequently Asked Questions Categories */
  faqCategories: Array<Maybe<FaqCategory>>;
  /** Frequently Asked Questions Codes */
  faqCodes: Array<Maybe<FaqCode>>;
  /** Frequently Asked Questions */
  faqs: Array<Maybe<Faq>>;
  findStore?: Maybe<FindStoreOutput>;
  /** Get garage analytics */
  garageAnalytics: GarageAnalytics;
  /** Get Array of times available for booking the given service, with the given quantiy, formatted as `HH:MM` */
  getAvailableTimesForBooking: Array<Maybe<Scalars['String']>>;
  getCartAcceptIframeUrl?: Maybe<Scalars['String']>;
  /** Retrieve the secure PayPal URL for a Payments Pro Hosted Solution transaction. */
  getHostedProUrl?: Maybe<HostedProUrl>;
  /** Get Array of nearest time available to book all cart services. */
  getNearestTimesForBooking: Array<Maybe<NearestTime>>;
  /** Retrieve payment credentials for a transaction. Use this query for Payflow Link and Payments Advanced payment methods. */
  getPayflowLinkToken?: Maybe<PayflowLinkToken>;
  /** Gets account phone number (last 3 digits) by email */
  getPhoneNumberByEmail: GetPhoneNumberByEmailOutput;
  /** get Product ids that you are subscribed to */
  getStockBackSubscriptionProductIds: Array<Maybe<Scalars['Int']>>;
  /** get Product uids that you are subscribed to */
  getStockBackSubscriptionProductUids: Array<Maybe<Scalars['String']>>;
  giftregistry_offers: Array<Maybe<Offer>>;
  homepage_offers: Array<Maybe<Offer>>;
  /** Check whether the specified email has already been used to create a customer account. */
  isEmailAvailable?: Maybe<IsEmailAvailableOutput>;
  /** Does this phone number belong to account with a dummy email? */
  isIncompleteProfile: Scalars['Boolean'];
  jsRequestsStatusHistory: JsmStatusHistoryOutput;
  jumpStartMeProduct?: Maybe<ProductInterface>;
  /** Searches for Best Sellers information matches the filter. */
  mpSmtpBestsellers?: Maybe<SmtpBestsellersOutput>;
  /** First available date and time slot for delivery */
  nextDeliveryInterval?: Maybe<NextDeliveryIntervalOutput>;
  /** The pickup locations query searches for locations that match the search request requirements. */
  pickupLocations?: Maybe<PickupLocations>;
  /** get product by url key */
  product?: Maybe<ProductInterface>;
  /** Listing all products that have special price, Very Important Notes: You MUST retrieve sku for items to not get internal server error - never filter by sku as module overrides the sku filter */
  productDeals?: Maybe<Products>;
  /** Return the active ratings attributes and the values each rating can have. */
  productReviewRatingsMetadata: ProductReviewRatingsMetadata;
  /** Search for products that match the criteria specified in the `search` and `filter` attributes. */
  products?: Maybe<Products>;
  /** The regions query provides information for a single region. */
  region?: Maybe<Region>;
  /** Return the full details for a specified product, category, or CMS page. */
  route?: Maybe<RoutableInterface>;
  search?: Maybe<SearchResult>;
  stockSources: StockSources;
  /** Return details about the store's configuration. */
  storeConfig?: Maybe<StoreConfig>;
  /** Get a store locator by id. */
  storeLocator?: Maybe<StoreLocator>;
  /** Get Stores */
  storeLocators: StoreLocatorOutput;
  /** Get store locator / garage visit by id */
  storeVisit: Visit;
  suggestedBatteries?: Maybe<Products>;
  suggestedTires?: Maybe<Products>;
  testimonials: Array<Maybe<Testimonial>>;
  /** Get visit reminder by id */
  upcomingVisitReminder: UpcomingVisitReminder;
  /**
   * Return the relative URL for a specified product, category or CMS page.
   * @deprecated Use the `route` query instead.
   */
  urlResolver?: Maybe<EntityUrl>;
  /** Get a list of used vehicles. */
  usedVehicles?: Maybe<UsedVehicles>;
  /** Fetch vehicle colors */
  vehicleColors: Array<Maybe<Color>>;
  /** Get all models */
  vehicleModels: Array<Maybe<VehicleModel>>;
  /** Get all brands for existing vehicles */
  vehiclesBrands: Array<Maybe<VehicleBrand>>;
  verifyCustomerSource?: Maybe<VerifyCustomerSourceOutput>;
  /**
   * Return the contents of a customer's wish list.
   * @deprecated Moved under `Customer.wishlist`.
   */
  wishlist?: Maybe<WishlistOutput>;
};


export type QueryAttributesDataArgs = {
  entityType?: InputMaybe<Scalars['String']>;
};


export type QueryAdminsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<UsersFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryAllCustomerVehiclesArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryAvailableStoresArgs = {
  useCurrentGroup?: InputMaybe<Scalars['Boolean']>;
};


export type QueryBrandByUrlKeyArgs = {
  url_key: Scalars['String'];
};


export type QueryBrandsArgs = {
  filter_out_of_stock?: InputMaybe<Scalars['Boolean']>;
  is_in_slider?: InputMaybe<Scalars['Boolean']>;
  is_shown_in_homepage?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryCancellationReasonsArgs = {
  type: CancellationType;
};


export type QueryCartArgs = {
  cart_id: Scalars['String'];
};


export type QueryCategoriesArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<CategoryFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryCategoryArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type QueryCategoryListArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<CategoryFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryCityArgs = {
  filter?: InputMaybe<AddressFilterInput>;
  id?: InputMaybe<Scalars['String']>;
};


export type QueryCmsBlocksArgs = {
  identifiers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryCmsPageArgs = {
  id?: InputMaybe<Scalars['Int']>;
  identifier?: InputMaybe<Scalars['String']>;
};


export type QueryCompareListArgs = {
  uid: Scalars['ID'];
};


export type QueryCountryArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryCustomAttributeMetadataArgs = {
  attributes: Array<AttributeInput>;
};


export type QueryCustomAttributeMetadataByEntityArgs = {
  attributeSet?: InputMaybe<Scalars['String']>;
  entityType: EntityType;
};


export type QueryCustomerByIdArgs = {
  id: Scalars['ID'];
};


export type QueryCustomerOrderArgs = {
  order_id: Scalars['Int'];
};


export type QueryCustomerOrderByIncrementIdArgs = {
  order_number: Scalars['String'];
};


export type QueryCustomerOrdersByIncrementIdArgs = {
  order_number: Scalars['String'];
};


export type QueryCustomerOrdersByPaymentIdArgs = {
  payment_id: Scalars['String'];
};


export type QueryCustomerOrdersSearchByIncrementIdArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  order_number: Scalars['String'];
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryCustomerSubstitutionByIdArgs = {
  id: Scalars['Int'];
};


export type QueryCustomerSubstitutionItemByIdArgs = {
  id: Scalars['Int'];
};


export type QueryCustomersArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<CustomersFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryDeals_OffersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryDeliverydaysArgs = {
  city_code?: InputMaybe<Scalars['String']>;
};


export type QueryFaqCategoriesArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryFaqsArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  codeId?: InputMaybe<Scalars['Int']>;
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryFindStoreArgs = {
  lat: Scalars['String'];
  lng: Scalars['String'];
  type?: InputMaybe<StoreTypeEnum>;
};


export type QueryGarageAnalyticsArgs = {
  date: Scalars['String'];
  period?: InputMaybe<Period>;
  storeLocatorId: Scalars['Int'];
};


export type QueryGetAvailableTimesForBookingArgs = {
  bookableServiceUid: Scalars['ID'];
  bookingDay: Scalars['String'];
  quantity?: InputMaybe<Scalars['Int']>;
};


export type QueryGetCartAcceptIframeUrlArgs = {
  cart_id: Scalars['String'];
  phone_number?: InputMaybe<Scalars['String']>;
};


export type QueryGetHostedProUrlArgs = {
  input: HostedProUrlInput;
};


export type QueryGetNearestTimesForBookingArgs = {
  bookingDay?: InputMaybe<Scalars['String']>;
  cartId: Scalars['String'];
  storeLocatorId: Scalars['Int'];
};


export type QueryGetPayflowLinkTokenArgs = {
  input: PayflowLinkTokenInput;
};


export type QueryGetPhoneNumberByEmailArgs = {
  email: Scalars['String'];
};


export type QueryGiftregistry_OffersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryHomepage_OffersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryIsEmailAvailableArgs = {
  email: Scalars['String'];
};


export type QueryIsIncompleteProfileArgs = {
  phoneNumber: Scalars['String'];
};


export type QueryJsRequestsStatusHistoryArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<JsmRequestsStatusHistoryFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortEnum>;
};


export type QueryMpSmtpBestsellersArgs = {
  app_id: Scalars['String'];
  filters?: InputMaybe<MpFilters>;
  secret_key: Scalars['String'];
};


export type QueryNextDeliveryIntervalArgs = {
  city_code?: InputMaybe<Scalars['String']>;
};


export type QueryPickupLocationsArgs = {
  area?: InputMaybe<AreaInput>;
  currentPage?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<PickupLocationFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
  productsInfo?: InputMaybe<Array<InputMaybe<ProductInfoInput>>>;
  sort?: InputMaybe<PickupLocationSortInput>;
};


export type QueryProductArgs = {
  sku?: InputMaybe<Scalars['String']>;
  url_key?: InputMaybe<Scalars['String']>;
};


export type QueryProductDealsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ProductAttributeFilterInput>;
  includeBundles?: InputMaybe<Scalars['Boolean']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<ProductAttributeSortInput>;
};


export type QueryProductsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ProductAttributeFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<ProductAttributeSortInput>;
};


export type QueryRegionArgs = {
  filter?: InputMaybe<AddressFilterInput>;
  id?: InputMaybe<Scalars['String']>;
};


export type QueryRouteArgs = {
  url: Scalars['String'];
};


export type QuerySearchArgs = {
  query?: InputMaybe<Scalars['String']>;
};


export type QueryStockSourcesArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<StockSourcesFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryStoreLocatorArgs = {
  id: Scalars['Int'];
};


export type QueryStoreLocatorsArgs = {
  citiesIds?: InputMaybe<Array<Scalars['Int']>>;
  cityId?: InputMaybe<Scalars['Int']>;
  currentPage?: InputMaybe<Scalars['Int']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  regionId?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  services?: InputMaybe<Array<Scalars['String']>>;
  storeType?: InputMaybe<StoreTypeFilter>;
  type?: InputMaybe<StoreTypeEnum>;
};


export type QueryStoreVisitArgs = {
  storeLocatorId?: InputMaybe<Scalars['Int']>;
  visitId: Scalars['ID'];
};


export type QuerySuggestedBatteriesArgs = {
  cartId: Scalars['String'];
  currentPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ProductAttributeFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<ProductAttributeSortInput>;
};


export type QuerySuggestedTiresArgs = {
  cartId: Scalars['String'];
  currentPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ProductAttributeFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<ProductAttributeSortInput>;
};


export type QueryTestimonialsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryUpcomingVisitReminderArgs = {
  reminderId: Scalars['ID'];
};


export type QueryUrlResolverArgs = {
  url: Scalars['String'];
};


export type QueryUsedVehiclesArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<UsedVehicleFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<UsedVehicleSortInput>;
};


export type QueryVehicleModelsArgs = {
  brandId: Scalars['ID'];
};


export type QueryVehiclesBrandsArgs = {
  brandId?: InputMaybe<Scalars['ID']>;
};


export type QueryVerifyCustomerSourceArgs = {
  filters?: InputMaybe<VerifyCustomerSourceInput>;
};

export type Range = {
  __typename?: 'Range';
  from_percent?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
  to_percent?: Maybe<Scalars['Int']>;
};

export type Region = {
  __typename?: 'Region';
  available_cities: Array<Maybe<City>>;
  /** The two-letter code for the region, such as TX for Texas. */
  code?: Maybe<Scalars['String']>;
  /** Delivery Configurations of this region */
  delivery_options: RegionDeliveryOptions;
  /** The unique ID for a `Region` object. */
  id?: Maybe<Scalars['Int']>;
  is_active?: Maybe<Scalars['Boolean']>;
  /** The name of the region, such as Texas. */
  name?: Maybe<Scalars['String']>;
};


export type RegionAvailable_CitiesArgs = {
  filter?: InputMaybe<AddressFilterInput>;
};

export type RegionDeliveryOptions = {
  __typename?: 'RegionDeliveryOptions';
  is_van_installment_enabled: Scalars['Boolean'];
  quick_delivery: DeliveryBounds;
  slow_delivery: DeliveryBounds;
};

export type RejectAdditionalItemInput = {
  additional_item_id: Scalars['Int'];
  substitution_id: Scalars['Int'];
};

export type RejectSubstitutionItemInput = {
  substitution_id: Scalars['Int'];
  substitution_item_id: Scalars['Int'];
};

export type RemovableItem = {
  itemId: Scalars['String'];
  qty: Scalars['Int'];
};

export type RemoveAdditionalItemInput = {
  additional_item_id: Scalars['Int'];
  substitution_id: Scalars['Int'];
};

/** Specifies the cart from which to remove a coupon. */
export type RemoveCouponFromCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
};

/** Contains details about the cart after removing a coupon. */
export type RemoveCouponFromCartOutput = {
  __typename?: 'RemoveCouponFromCartOutput';
  /** The cart after removing a coupon. */
  cart?: Maybe<Cart>;
};

export type RemoveEvouchersFromCartOutput = {
  __typename?: 'RemoveEvouchersFromCartOutput';
  /** The cart after the evouchers have been removed. */
  cart: Cart;
};

export type RemoveFromJumpStartOrderInput = {
  items: Array<InputMaybe<RemovableItem>>;
  orderNumber: Scalars['String'];
};

/** Specifies which items to remove from the cart. */
export type RemoveItemFromCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
  /** Deprecated. Use `cart_item_uid` instead. */
  cart_item_id?: InputMaybe<Scalars['Int']>;
  /** Required field. The unique ID for a `CartItemInterface` object. */
  cart_item_uid?: InputMaybe<Scalars['ID']>;
};

/** Contains details about the cart after removing an item. */
export type RemoveItemFromCartOutput = {
  __typename?: 'RemoveItemFromCartOutput';
  /** The cart after removing an item. */
  cart: Cart;
};

/** Defines which products to remove from a compare list. */
export type RemoveProductsFromCompareListInput = {
  /** An array of product IDs to remove from the compare list. */
  products: Array<InputMaybe<Scalars['ID']>>;
  /** The unique identifier of the compare list to modify. */
  uid: Scalars['ID'];
};

/** Contains the customer's wish list and any errors encountered. */
export type RemoveProductsFromWishlistOutput = {
  __typename?: 'RemoveProductsFromWishlistOutput';
  /** An array of errors encountered while deleting products from a wish list. */
  user_errors: Array<Maybe<WishListUserInputError>>;
  /** Contains the wish list with after items were successfully deleted. */
  wishlist: Wishlist;
};

export type RemoveSubstitutionItemInput = {
  substitution_id: Scalars['Int'];
  substitution_item_id?: InputMaybe<Scalars['Int']>;
  visit_item_uid?: InputMaybe<Scalars['ID']>;
};

/** Contains the cart and any errors after adding products. */
export type ReorderItemsOutput = {
  __typename?: 'ReorderItemsOutput';
  /** Detailed information about the customer's cart. */
  cart: Cart;
  /** An array of reordering errors. */
  userInputErrors: Array<Maybe<CheckoutUserInputError>>;
};

export type RescheduleRequestInput = {
  /** The day to book at in the format `YYYY-MM-DD`. By default it's today if left empty. */
  newDate?: InputMaybe<Scalars['String']>;
  /** The time to book at in the format `HH:MM`. */
  newTime: Scalars['String'];
  requestId: Scalars['ID'];
};

export type ResendVerficationCodeInput = {
  phone_number: Scalars['String'];
};

export type RevokeAdminTokenOutput = {
  __typename?: 'RevokeAdminTokenOutput';
  result: Scalars['Boolean'];
};

/** Contains the result of a request to revoke a customer token. */
export type RevokeCustomerTokenOutput = {
  __typename?: 'RevokeCustomerTokenOutput';
  /** The result of a request to revoke a customer token. */
  result: Scalars['Boolean'];
};

export type RiderRequestsOutput = {
  __typename?: 'RiderRequestsOutput';
  items?: Maybe<Array<Maybe<StoreBooking>>>;
  page_info?: Maybe<SearchResultPageInfo>;
  total_count: Scalars['Int'];
};

export enum RiderStatus {
  /** @deprecated  */
  Active = 'ACTIVE',
  /** @deprecated  */
  Assigned = 'ASSIGNED',
  /** @deprecated  */
  Completed = 'COMPLETED'
}

export type RiderVsRequestsOutput = {
  __typename?: 'RiderVsRequestsOutput';
  items?: Maybe<Array<Maybe<StoreBooking>>>;
  page_info: SearchResultPageInfo;
  status?: Maybe<JsmStatus>;
  total_completed_count: Scalars['Int'];
  total_count: Scalars['Int'];
};

/** Routable entities serve as the model for a rendered page. */
export type RoutableInterface = {
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int'];
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']>;
};

/** Contains details about a comment. */
export type SalesCommentItem = {
  __typename?: 'SalesCommentItem';
  /** The text of the message. */
  message: Scalars['String'];
  /** The timestamp of the comment. */
  timestamp: Scalars['String'];
};

export type SalesItemInterface = {
  __typename?: 'SalesItemInterface';
  /** The entered gift message for the order item */
  gift_message?: Maybe<GiftMessage>;
};

/** This enumeration defines the scope type for customer orders. */
export enum ScopeTypeEnum {
  /** @deprecated  */
  Global = 'GLOBAL',
  /** @deprecated  */
  Store = 'STORE',
  /** @deprecated  */
  Website = 'WEBSITE'
}

export type SearchResult = {
  __typename?: 'SearchResult';
  aheadworks_blog_post?: Maybe<SearchResultAheadworksBlogPost>;
  amasty_blog_post?: Maybe<SearchResultAmastyBlogPost>;
  amasty_faq_question?: Maybe<SearchResultAmastyFaqQuestion>;
  external_wordpress_post?: Maybe<SearchResultExternalWordpressPost>;
  magefan_blog_post?: Maybe<SearchResultMagefanBlogPost>;
  magento_catalog_attribute?: Maybe<SearchResultMagentoCatalogAttribute>;
  magento_catalog_attribute_2?: Maybe<SearchResultMagentoCatalogAttribute_2>;
  magento_catalog_attribute_3?: Maybe<SearchResultMagentoCatalogAttribute_3>;
  magento_catalog_attribute_4?: Maybe<SearchResultMagentoCatalogAttribute_4>;
  magento_catalog_attribute_5?: Maybe<SearchResultMagentoCatalogAttribute_5>;
  magento_catalog_category?: Maybe<SearchResultMagentoCatalogCategory>;
  magento_catalog_product?: Maybe<SearchResultMagentoCatalogProduct>;
  magento_cms_page?: Maybe<SearchResultMagentoCmsPage>;
  mageplaza_blog_post?: Maybe<SearchResultMageplazaBlogPost>;
  mirasvit_kb_article?: Maybe<SearchResultMirasvitKbArticle>;
};


export type SearchResultAheadworks_Blog_PostArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type SearchResultAmasty_Blog_PostArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type SearchResultAmasty_Faq_QuestionArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type SearchResultExternal_Wordpress_PostArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type SearchResultMagefan_Blog_PostArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type SearchResultMagento_Catalog_AttributeArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type SearchResultMagento_Catalog_Attribute_2Args = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type SearchResultMagento_Catalog_Attribute_3Args = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type SearchResultMagento_Catalog_Attribute_4Args = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type SearchResultMagento_Catalog_Attribute_5Args = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type SearchResultMagento_Catalog_CategoryArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type SearchResultMagento_Catalog_ProductArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ProductAttributeFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ProductAttributeSortInput>;
};


export type SearchResultMagento_Cms_PageArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type SearchResultMageplaza_Blog_PostArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type SearchResultMirasvit_Kb_ArticleArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type SearchResultAheadworksBlogPost = {
  __typename?: 'SearchResultAheadworksBlogPost';
  identifier?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<AheadworksBlogPost>>>;
  page_info?: Maybe<SearchResultPageInfo>;
  position?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  total_count?: Maybe<Scalars['Int']>;
};

export type SearchResultAmastyBlogPost = {
  __typename?: 'SearchResultAmastyBlogPost';
  identifier?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<AmastyBlogPost>>>;
  page_info?: Maybe<SearchResultPageInfo>;
  position?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  total_count?: Maybe<Scalars['Int']>;
};

export type SearchResultAmastyFaqQuestion = {
  __typename?: 'SearchResultAmastyFaqQuestion';
  identifier?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<AmastyFaqQuestion>>>;
  page_info?: Maybe<SearchResultPageInfo>;
  position?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  total_count?: Maybe<Scalars['Int']>;
};

export type SearchResultExternalWordpressPost = {
  __typename?: 'SearchResultExternalWordpressPost';
  identifier?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<ExternalWordpressPost>>>;
  page_info?: Maybe<SearchResultPageInfo>;
  position?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  total_count?: Maybe<Scalars['Int']>;
};

export type SearchResultMagefanBlogPost = {
  __typename?: 'SearchResultMagefanBlogPost';
  identifier?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<MagefanBlogPost>>>;
  page_info?: Maybe<SearchResultPageInfo>;
  position?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  total_count?: Maybe<Scalars['Int']>;
};

export type SearchResultMagentoCatalogAttribute = {
  __typename?: 'SearchResultMagentoCatalogAttribute';
  identifier?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<AttributeOption>>>;
  page_info?: Maybe<SearchResultPageInfo>;
  position?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  total_count?: Maybe<Scalars['Int']>;
};

export type SearchResultMagentoCatalogAttribute_2 = {
  __typename?: 'SearchResultMagentoCatalogAttribute_2';
  identifier?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<AttributeOption>>>;
  page_info?: Maybe<SearchResultPageInfo>;
  position?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  total_count?: Maybe<Scalars['Int']>;
};

export type SearchResultMagentoCatalogAttribute_3 = {
  __typename?: 'SearchResultMagentoCatalogAttribute_3';
  identifier?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<AttributeOption>>>;
  page_info?: Maybe<SearchResultPageInfo>;
  position?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  total_count?: Maybe<Scalars['Int']>;
};

export type SearchResultMagentoCatalogAttribute_4 = {
  __typename?: 'SearchResultMagentoCatalogAttribute_4';
  identifier?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<AttributeOption>>>;
  page_info?: Maybe<SearchResultPageInfo>;
  position?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  total_count?: Maybe<Scalars['Int']>;
};

export type SearchResultMagentoCatalogAttribute_5 = {
  __typename?: 'SearchResultMagentoCatalogAttribute_5';
  identifier?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<AttributeOption>>>;
  page_info?: Maybe<SearchResultPageInfo>;
  position?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  total_count?: Maybe<Scalars['Int']>;
};

export type SearchResultMagentoCatalogCategory = {
  __typename?: 'SearchResultMagentoCatalogCategory';
  identifier?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<CategoryInterface>>>;
  page_info?: Maybe<SearchResultPageInfo>;
  position?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  total_count?: Maybe<Scalars['Int']>;
};

export type SearchResultMagentoCatalogProduct = {
  __typename?: 'SearchResultMagentoCatalogProduct';
  aggregations?: Maybe<Array<Maybe<Aggregation>>>;
  identifier?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<ProductInterface>>>;
  page_info?: Maybe<SearchResultPageInfo>;
  position?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  total_count?: Maybe<Scalars['Int']>;
};

export type SearchResultMagentoCmsPage = {
  __typename?: 'SearchResultMagentoCmsPage';
  identifier?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<CmsPage>>>;
  page_info?: Maybe<SearchResultPageInfo>;
  position?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  total_count?: Maybe<Scalars['Int']>;
};

export type SearchResultMageplazaBlogPost = {
  __typename?: 'SearchResultMageplazaBlogPost';
  identifier?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<MageplazaBlogPost>>>;
  page_info?: Maybe<SearchResultPageInfo>;
  position?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  total_count?: Maybe<Scalars['Int']>;
};

export type SearchResultMirasvitKbArticle = {
  __typename?: 'SearchResultMirasvitKbArticle';
  identifier?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<MirasvitKbArticle>>>;
  page_info?: Maybe<SearchResultPageInfo>;
  position?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  total_count?: Maybe<Scalars['Int']>;
};

/** Provides navigation for the query response. */
export type SearchResultPageInfo = {
  __typename?: 'SearchResultPageInfo';
  /** The specific page to return. */
  current_page?: Maybe<Scalars['Int']>;
  /** The maximum number of items to return per page of results. */
  page_size?: Maybe<Scalars['Int']>;
  /** The total number of pages in the response. */
  total_pages?: Maybe<Scalars['Int']>;
};

/** A string that contains search suggestion */
export type SearchSuggestion = {
  __typename?: 'SearchSuggestion';
  /** The search suggestion of existing product. */
  search: Scalars['String'];
};

/** Contains details about a selected bundle option. */
export type SelectedBundleOption = {
  __typename?: 'SelectedBundleOption';
  /** @deprecated Use `uid` instead */
  id: Scalars['Int'];
  /** The display name of the selected bundle product option. */
  label: Scalars['String'];
  /** The type of selected bundle product option. */
  type: Scalars['String'];
  /** The unique ID for a `SelectedBundleOption` object */
  uid: Scalars['ID'];
  /** An array of selected bundle option values. */
  values: Array<Maybe<SelectedBundleOptionValue>>;
};

/** Contains details about a value for a selected bundle option. */
export type SelectedBundleOptionValue = {
  __typename?: 'SelectedBundleOptionValue';
  /** Use `uid` instead */
  id: Scalars['Int'];
  /** The display name of the value for the selected bundle product option. */
  label: Scalars['String'];
  /** The price of the value for the selected bundle product option. */
  price: Scalars['Float'];
  /** The quantity of the value for the selected bundle product option. */
  quantity: Scalars['Float'];
  /** The unique ID for a `SelectedBundleOptionValue` object */
  uid: Scalars['ID'];
};

/** Contains details about a selected configurable option. */
export type SelectedConfigurableOption = {
  __typename?: 'SelectedConfigurableOption';
  /** The unique ID for a `ConfigurableProductOptions` object. */
  configurable_product_option_uid: Scalars['ID'];
  /** The unique ID for a `ConfigurableProductOptionsValues` object. */
  configurable_product_option_value_uid: Scalars['ID'];
  /** @deprecated Use `SelectedConfigurableOption.configurable_product_option_uid` instead. */
  id: Scalars['Int'];
  /** The display text for the option. */
  option_label: Scalars['String'];
  /** @deprecated Use `SelectedConfigurableOption.configurable_product_option_value_uid` instead. */
  value_id: Scalars['Int'];
  /** The display name of the selected configurable option. */
  value_label: Scalars['String'];
};

/** Identifies a customized product that has been placed in a cart. */
export type SelectedCustomizableOption = {
  __typename?: 'SelectedCustomizableOption';
  /** The unique ID for a specific `CustomizableOptionInterface` object, such as a `CustomizableFieldOption`, `CustomizableFileOption`, or `CustomizableAreaOption` object. */
  customizable_option_uid: Scalars['ID'];
  /** @deprecated Use `SelectedCustomizableOption.customizable_option_uid` instead. */
  id: Scalars['Int'];
  /** Indicates whether the customizable option is required. */
  is_required: Scalars['Boolean'];
  /** The display name of the selected customizable option. */
  label: Scalars['String'];
  /** A value indicating the order to display this option. */
  sort_order: Scalars['Int'];
  /** The type of `CustomizableOptionInterface` object. */
  type: Scalars['String'];
  /** An array of selectable values. */
  values: Array<Maybe<SelectedCustomizableOptionValue>>;
};

/** Identifies the value of the selected customized option. */
export type SelectedCustomizableOptionValue = {
  __typename?: 'SelectedCustomizableOptionValue';
  /** The unique ID for a value object that corresponds to the object represented by the `customizable_option_uid` attribute. */
  customizable_option_value_uid: Scalars['ID'];
  /** @deprecated Use `SelectedCustomizableOptionValue.customizable_option_value_uid` instead. */
  id: Scalars['Int'];
  /** The display name of the selected value. */
  label: Scalars['String'];
  /** The price of the selected customizable value. */
  price: CartItemSelectedOptionValuePrice;
  /** The text identifying the selected value. */
  value: Scalars['String'];
};

/** Describes the payment method the shopper selected. */
export type SelectedPaymentMethod = {
  __typename?: 'SelectedPaymentMethod';
  /** The payment method code. */
  code: Scalars['String'];
  /** The purchase order number. */
  purchase_order_number?: Maybe<Scalars['String']>;
  /** The payment method title. */
  title: Scalars['String'];
};

/** Contains details about the selected shipping method and carrier. */
export type SelectedShippingMethod = {
  __typename?: 'SelectedShippingMethod';
  /** The cost of shipping using this shipping method. */
  amount: Money;
  /** @deprecated The field should not be used on the storefront. */
  base_amount?: Maybe<Money>;
  /** A string that identifies a commercial carrier or an offline shipping method. */
  carrier_code: Scalars['String'];
  /** The label for the carrier code. */
  carrier_title: Scalars['String'];
  /** A shipping method code associated with a carrier. */
  method_code: Scalars['String'];
  /** The label for the method code. */
  method_title: Scalars['String'];
  /** The cost of shipping using this shipping method, excluding tax. */
  price_excl_tax: Money;
  /** The cost of shipping using this shipping method, including tax. */
  price_incl_tax: Money;
};

export type SellCarInput = {
  area: Scalars['String'];
  carBrand: Scalars['String'];
  carMileage: Scalars['Int'];
  carModel: Scalars['String'];
  category: Scalars['String'];
  city: Scalars['String'];
  email: Scalars['String'];
  expectedPrice: Scalars['Float'];
  fullName: Scalars['String'];
  phoneNumber: Scalars['String'];
  year: Scalars['Int'];
};

/** Defines the referenced product and the email sender and recipients. */
export type SendEmailToFriendInput = {
  /** The ID of the product that the sender is referencing. */
  product_id: Scalars['Int'];
  /** An array containing information about each recipient. */
  recipients: Array<InputMaybe<SendEmailToFriendRecipientInput>>;
  /** Information about the customer and the content of the message. */
  sender: SendEmailToFriendSenderInput;
};

/** Contains information about the sender and recipients. */
export type SendEmailToFriendOutput = {
  __typename?: 'SendEmailToFriendOutput';
  /** An array containing information about each recipient. */
  recipients?: Maybe<Array<Maybe<SendEmailToFriendRecipient>>>;
  /** Information about the customer and the content of the message. */
  sender?: Maybe<SendEmailToFriendSender>;
};

/** An output object that contains information about the recipient. */
export type SendEmailToFriendRecipient = {
  __typename?: 'SendEmailToFriendRecipient';
  /** The email address of the recipient. */
  email: Scalars['String'];
  /** The name of the recipient. */
  name: Scalars['String'];
};

/** Contains details about a recipient. */
export type SendEmailToFriendRecipientInput = {
  /** The email address of the recipient. */
  email: Scalars['String'];
  /** The name of the recipient. */
  name: Scalars['String'];
};

/** An output object that contains information about the sender. */
export type SendEmailToFriendSender = {
  __typename?: 'SendEmailToFriendSender';
  /** The email address of the sender. */
  email: Scalars['String'];
  /** The text of the message to be sent. */
  message: Scalars['String'];
  /** The name of the sender. */
  name: Scalars['String'];
};

/** Contains details about the sender. */
export type SendEmailToFriendSenderInput = {
  /** The email address of the sender. */
  email: Scalars['String'];
  /** The text of the message to be sent. */
  message: Scalars['String'];
  /** The name of the sender. */
  name: Scalars['String'];
};

/** Contains details about the configuration of the Email to a Friend feature. */
export type SendFriendConfiguration = {
  __typename?: 'SendFriendConfiguration';
  /** Indicates whether the Email to a Friend feature is enabled. */
  enabled_for_customers: Scalars['Boolean'];
  /** Indicates whether the Email to a Friend feature is enabled for guests. */
  enabled_for_guests: Scalars['Boolean'];
};

/** Sets the billing address. */
export type SetBillingAddressOnCartInput = {
  /** The billing address. */
  billing_address: BillingAddressInput;
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
};

/** Contains details about the cart after setting the billing address. */
export type SetBillingAddressOnCartOutput = {
  __typename?: 'SetBillingAddressOnCartOutput';
  /** The cart after setting the billing address. */
  cart: Cart;
};

export type SetCartParentReminderOutput = {
  __typename?: 'SetCartParentReminderOutput';
  cart: Cart;
};

export type SetCustomerSelectedStockSourceOutput = {
  __typename?: 'SetCustomerSelectedStockSourceOutput';
  customer: Customer;
};

/** Defines the guest email and cart. */
export type SetGuestEmailOnCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
  /** The email address of the guest. */
  email: Scalars['String'];
};

/** Contains details about the cart after setting the email of a guest. */
export type SetGuestEmailOnCartOutput = {
  __typename?: 'SetGuestEmailOnCartOutput';
  /** The cart after setting the guest email. */
  cart: Cart;
};

/** Applies a payment method to the quote. */
export type SetPaymentMethodAndPlaceOrderInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
  /** The payment method data to apply to the cart. */
  payment_method: PaymentMethodInput;
};

/** Applies a payment method to the cart. */
export type SetPaymentMethodOnCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
  /** The payment method data to apply to the cart. */
  payment_method: PaymentMethodInput;
};

/** Contains details about the cart after setting the payment method. */
export type SetPaymentMethodOnCartOutput = {
  __typename?: 'SetPaymentMethodOnCartOutput';
  /** The cart after setting the payment method. */
  cart: Cart;
};

/** Specifies an array of addresses to use for shipping. */
export type SetShippingAddressesOnCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
  /** An array of shipping addresses. */
  shipping_addresses: Array<InputMaybe<ShippingAddressInput>>;
};

/** Contains details about the cart after setting the shipping addresses. */
export type SetShippingAddressesOnCartOutput = {
  __typename?: 'SetShippingAddressesOnCartOutput';
  /** The cart after setting the shipping addresses. */
  cart: Cart;
};

export type SetShippingLocationOnCartInput = {
  cart_id: Scalars['String'];
  store_id: Scalars['Int'];
};

export type SetShippingLocationOnCartOutput = {
  __typename?: 'SetShippingLocationOnCartOutput';
  cart: Cart;
};

/** Applies one or shipping methods to the cart. */
export type SetShippingMethodsOnCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
  /** comment order */
  delivery_comment?: InputMaybe<Scalars['String']>;
  /** chosen delivery day in UNIX timestamp */
  delivery_day_timestamp?: InputMaybe<Scalars['String']>;
  /** chosen time interval ID */
  delivery_interval_id?: InputMaybe<Scalars['Int']>;
  /** An array of shipping methods. */
  shipping_methods: Array<InputMaybe<ShippingMethodInput>>;
};

/** Contains details about the cart after setting the shipping methods. */
export type SetShippingMethodsOnCartOutput = {
  __typename?: 'SetShippingMethodsOnCartOutput';
  /** The cart after setting the shipping methods. */
  cart: Cart;
};

/** Defines whether bundle items must be shipped together. */
export enum ShipBundleItemsEnum {
  /** @deprecated  */
  Separately = 'SEPARATELY',
  /** @deprecated  */
  Together = 'TOGETHER'
}

export type ShipmentItem = ShipmentItemInterface & {
  __typename?: 'ShipmentItem';
  /** The unique ID for a `ShipmentItemInterface` object. */
  id: Scalars['ID'];
  /** The order item associated with the shipment item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price for the base product. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The number of shipped items. */
  quantity_shipped: Scalars['Float'];
};

/** Order shipment item details. */
export type ShipmentItemInterface = {
  /** The unique ID for a `ShipmentItemInterface` object. */
  id: Scalars['ID'];
  /** The order item associated with the shipment item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price for the base product. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The number of shipped items. */
  quantity_shipped: Scalars['Float'];
};

/** Contains order shipment tracking details. */
export type ShipmentTracking = {
  __typename?: 'ShipmentTracking';
  /** The shipping carrier for the order delivery. */
  carrier: Scalars['String'];
  /** The tracking number of the order shipment. */
  number?: Maybe<Scalars['String']>;
  /** The shipment tracking title. */
  title: Scalars['String'];
};

/** Defines a single shipping address. */
export type ShippingAddressInput = {
  /** Defines a shipping address. */
  address?: InputMaybe<CartAddressInput>;
  /** An ID from the customer's address book that uniquely identifies the address to be used for shipping. */
  customer_address_id?: InputMaybe<Scalars['Int']>;
  /** Text provided by the shopper. */
  customer_notes?: InputMaybe<Scalars['String']>;
  /** The code of Pickup Location which will be used for In-Store Pickup. */
  pickup_location_code?: InputMaybe<Scalars['String']>;
};

/** Contains shipping addresses and methods. */
export type ShippingCartAddress = CartAddressInterface & {
  __typename?: 'ShippingCartAddress';
  /** An array that lists the shipping methods that can be applied to the cart. */
  available_shipping_methods?: Maybe<Array<Maybe<AvailableShippingMethod>>>;
  /** @deprecated Use `cart_items_v2` instead. */
  cart_items?: Maybe<Array<Maybe<CartItemQuantity>>>;
  /** An array that lists the items in the cart. */
  cart_items_v2?: Maybe<Array<Maybe<CartItemInterface>>>;
  /** An object containing the city name, city code, and city ID */
  city?: Maybe<City>;
  /** The company specified for the billing or shipping address. */
  company?: Maybe<Scalars['String']>;
  /** An object containing the country name, country code, and country ID */
  country?: Maybe<Country>;
  /** Text provided by the shopper. */
  customer_notes?: Maybe<Scalars['String']>;
  /** The first name of the customer or guest. */
  firstname: Scalars['String'];
  /** @deprecated This information should not be exposed on the frontend. */
  items_weight?: Maybe<Scalars['Float']>;
  /** The last name of the customer or guest. */
  lastname: Scalars['String'];
  pickup_location_code?: Maybe<Scalars['String']>;
  /** The ZIP or postal code of the billing or shipping address. */
  postcode?: Maybe<Scalars['String']>;
  region: Region;
  /** An object that describes the selected shipping method. */
  selected_shipping_method?: Maybe<SelectedShippingMethod>;
  /** An array containing the street for the billing or shipping address. */
  street: Array<Maybe<Scalars['String']>>;
  /** The telephone number for the billing or shipping address. */
  telephone?: Maybe<Scalars['String']>;
  /** The unique id of the customer address. */
  uid: Scalars['String'];
  /** The VAT company number for billing or shipping address. */
  vat_id?: Maybe<Scalars['String']>;
};

/** Defines an individual shipping discount. This discount can be applied to shipping. */
export type ShippingDiscount = {
  __typename?: 'ShippingDiscount';
  /** The amount of the discount. */
  amount: Money;
};

/** Contains details about shipping and handling costs. */
export type ShippingHandling = {
  __typename?: 'ShippingHandling';
  /** The shipping amount, excluding tax. */
  amount_excluding_tax?: Maybe<Money>;
  /** The shipping amount, including tax. */
  amount_including_tax?: Maybe<Money>;
  /** The applied discounts to the shipping. */
  discounts?: Maybe<Array<Maybe<ShippingDiscount>>>;
  /** Details about taxes applied for shipping. */
  taxes?: Maybe<Array<Maybe<TaxItem>>>;
  /** The total amount for shipping. */
  total_amount: Money;
};

/** Defines the shipping carrier and method. */
export type ShippingMethodInput = {
  /** A string that identifies a commercial carrier or an offline delivery method. */
  carrier_code: Scalars['String'];
  /** A string that indicates which service a commercial carrier will use to ship items. For offline delivery methods, this value is similar to the label displayed on the checkout page. */
  method_code: Scalars['String'];
};

/** An implementation for simple product cart items. */
export type SimpleCartItem = CartItemInterface & {
  __typename?: 'SimpleCartItem';
  /** Information about the booking of this item */
  booked_service?: Maybe<BookedService>;
  /** An array containing the customizable options the shopper selected. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>;
  /** The entered gift message for the cart item */
  gift_message?: Maybe<GiftMessage>;
  /** @deprecated Use `uid` instead. */
  id: Scalars['String'];
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>;
  /** Details about an item in the cart. */
  product: ProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float'];
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID'];
};

/** Defines a simple product, which is tangible and is usually sold in single units or in fixed quantities. */
export type SimpleProduct = CustomizableProductInterface & PhysicalProductInterface & ProductInterface & RoutableInterface & {
  __typename?: 'SimpleProduct';
  /** @deprecated Use the `custom_attributes` field instead. */
  ampere?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  aspect_ratio?: Maybe<Scalars['Int']>;
  /** Attribute set information */
  attribute_set?: Maybe<AttributeSetInformation>;
  /**
   * The attribute set assigned to the product.
   * @deprecated The field should not be used on the storefront.
   */
  attribute_set_id?: Maybe<Scalars['Int']>;
  /** List of product attributes */
  attributes?: Maybe<Array<Maybe<CustomAttribute>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  average_duration?: Maybe<Scalars['String']>;
  /** Attributes regarding this bookable service in the given store locator. */
  bookable_service?: Maybe<BookableService>;
  /** The product brand. */
  brand?: Maybe<Brand>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
  canonical_url?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  car_batteries_ampere?: Maybe<Scalars['Int']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  color?: Maybe<Scalars['Int']>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  country_of_origin?: Maybe<Scalars['Int']>;
  /**
   * Timestamp indicating when the product was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  creation_date?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  creation_id?: Maybe<Scalars['Int']>;
  /** Crosssell Products */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /**
   * List of product custom labels
   * @deprecated Use the `custom_attributes` field instead.
   */
  custom_labels: Array<Maybe<Label>>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  /** @deprecated Use the `custom_attributes` field instead. */
  diameter?: Maybe<Scalars['Int']>;
  expected_shipping_fees?: Maybe<Scalars['Float']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  exterior_hand_wash?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_age_group?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_age_range?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_baby_food_stage?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_brand?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_capacity?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_color?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_compatible_devices?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_decor_style?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_digital_zoom?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_display_technology?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_finish?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_gemstone?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_gender?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_health_concern?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_ingredients?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_is_assembly_required?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_material?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_maximum_weight?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_megapixels?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_minimum_weight?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_model?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_number_of_licenses?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_operating_system?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_optical_zoom?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_package_quantity?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_pattern?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_depth?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_form?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_height?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_length?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_weight?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_width?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_recommended_use?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_resolution?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_scent?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_screen_size?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_shoe_width?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_size?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_storage_capacity?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_style?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_system_requirements?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_thread_count?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_video_game_platform?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  featured_order?: Maybe<Scalars['Int']>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  has_deal?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  hover_cleaning?: Maybe<Scalars['Int']>;
  /**
   * The ID number assigned to the product.
   * @deprecated Use the `uid` field instead.
   */
  id?: Maybe<Scalars['Int']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** @deprecated Use the `custom_attributes` field instead. */
  in_store_only?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  interior_cleaning?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  interior_vacuum_clean?: Maybe<Scalars['Int']>;
  /** Check if product is a best seller */
  is_best_seller?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  is_bookable_service?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  is_bookable_service_addon?: Maybe<Scalars['Int']>;
  /** if the product favorited by the logged in user */
  is_favorited?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  is_featured?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  is_featured_offer?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  is_november_deal?: Maybe<Scalars['Int']>;
  is_van_installment_enabled: Scalars['Boolean'];
  /** Indicates whether the product is the wiper that has the gift or not. */
  is_wiper: Scalars['Boolean'];
  /** product labels */
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * A number representing the product's manufacturer.
   * @deprecated Use the `custom_attributes` field instead.
   */
  manufacturer?: Maybe<Scalars['Int']>;
  /** An array of media gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use `media_gallery` instead.
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  mileage_warranty?: Maybe<Scalars['String']>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']>;
  /** Quantity of product left in customer's choosen source */
  only_x_left_in_source?: Maybe<Scalars['Float']>;
  /** Product stock only x left count */
  only_x_left_in_stock?: Maybe<Scalars['Float']>;
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  pattern?: Maybe<Scalars['String']>;
  /**
   * Indicates the price of an item.
   * @deprecated Use `price_range` for product price information.
   */
  price?: Maybe<ProductPrices>;
  /** The range of prices for the product */
  price_range: PriceRange;
  /** An array of `TierPrice` objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_brand_id?: Maybe<Scalars['Int']>;
  /** An array of `ProductLinks` objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  product_offer_type?: Maybe<Scalars['Int']>;
  /** The average of all the ratings given to the product. */
  rating_summary: Scalars['Float'];
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int'];
  /** Related Products */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']>;
  /** The total count of all the reviews given to the product. */
  review_count: Scalars['Int'];
  /** The list of products reviews. */
  reviews: ProductReviews;
  /** @deprecated Use the `custom_attributes` field instead. */
  serving_order?: Maybe<Scalars['Int']>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  /**
   * The beginning date that a product has a special price.
   * @deprecated The field should not be used on the storefront.
   */
  special_from_date?: Maybe<Scalars['String']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']>;
  /** Time left for expiry of special price in seconds */
  special_price_time_left?: Maybe<Scalars['Int']>;
  /** The end date for a product with a special price. */
  special_to_date?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  speed?: Maybe<Scalars['String']>;
  /** List of product attributes */
  stockQtyTerm?: Maybe<Array<Maybe<ProductStockQty>>>;
  /** Stock status of the product */
  stock_status?: Maybe<ProductStockStatus>;
  /** The file name of a swatch image. */
  swatch_image?: Maybe<Scalars['String']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  type?: Maybe<Scalars['Int']>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use `__typename` instead.
   */
  type_id?: Maybe<Scalars['String']>;
  /** The unique ID for a `ProductInterface` object. */
  uid: Scalars['ID'];
  /**
   * Timestamp indicating when the product was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']>;
  /** Upsell Products */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
  /** The weight of the item, in units defined by the store. */
  weight?: Maybe<Scalars['Float']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  width?: Maybe<Scalars['Int']>;
};


/** Defines a simple product, which is tangible and is usually sold in single units or in fixed quantities. */
export type SimpleProductAttributesArgs = {
  groupCode?: InputMaybe<Scalars['String']>;
};


/** Defines a simple product, which is tangible and is usually sold in single units or in fixed quantities. */
export type SimpleProductBookable_ServiceArgs = {
  storeLocatorId?: InputMaybe<Scalars['Int']>;
};


/** Defines a simple product, which is tangible and is usually sold in single units or in fixed quantities. */
export type SimpleProductExpected_Shipping_FeesArgs = {
  sourceCode?: InputMaybe<Scalars['String']>;
};


/** Defines a simple product, which is tangible and is usually sold in single units or in fixed quantities. */
export type SimpleProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** Defines a single product to add to the cart. */
export type SimpleProductCartItemInput = {
  /** An array that defines customizable options for the product. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  /** An object containing the `sku`, `quantity`, and other relevant information about the product. */
  data: CartItemInput;
};

/** Contains a simple product wish list item. */
export type SimpleWishlistItem = WishlistItemInterface & {
  __typename?: 'SimpleWishlistItem';
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String'];
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars['String']>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID'];
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars['Float'];
};

export type SmtpBestsellersOutput = {
  __typename?: 'SmtpBestsellersOutput';
  /** Bestsellers Product Information. */
  mpBestsellers?: Maybe<Array<Maybe<BestsellersProductOutput>>>;
};

export enum SocialProviderEnum {
  /** @deprecated  */
  Apple = 'APPLE',
  /** @deprecated  */
  Facebook = 'FACEBOOK',
  /** @deprecated  */
  Google = 'GOOGLE'
}

export type SocialProviderLogInInput = {
  first_name?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};

/** Indicates whether to return results in ascending or descending order. */
export enum SortEnum {
  /** @deprecated  */
  Asc = 'ASC',
  /** @deprecated  */
  Desc = 'DESC'
}

/** Defines a possible sort field. */
export type SortField = {
  __typename?: 'SortField';
  /** The label of the sort field. */
  label?: Maybe<Scalars['String']>;
  /** The attribute code of the sort field. */
  value?: Maybe<Scalars['String']>;
};

/** Contains a default value for sort fields and all available sort fields. */
export type SortFields = {
  __typename?: 'SortFields';
  /** The default sort field value. */
  default?: Maybe<Scalars['String']>;
  /** An array of possible sort fields. */
  options?: Maybe<Array<Maybe<SortField>>>;
};

export type SosStatusFilterInput = {
  eq?: InputMaybe<JsmStatus>;
  in?: InputMaybe<Array<InputMaybe<JsmStatus>>>;
  neq?: InputMaybe<JsmStatus>;
  nin?: InputMaybe<Array<InputMaybe<JsmStatus>>>;
};

export type StartSubstitutionInput = {
  substitution_id: Scalars['Int'];
};

export enum Status {
  /** @deprecated  */
  Expired = 'EXPIRED',
  /** @deprecated  */
  Hidden = 'HIDDEN',
  /** @deprecated  */
  NotReady = 'NOT_READY',
  /** @deprecated  */
  Ready = 'READY',
  /** @deprecated  */
  Redeemed = 'REDEEMED'
}

export type StockSourceItem = {
  __typename?: 'StockSourceItem';
  cities?: Maybe<Array<Maybe<CitiesInfo>>>;
  city?: Maybe<Scalars['String']>;
  contact_name?: Maybe<Scalars['String']>;
  country_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Int']>;
  fax?: Maybe<Scalars['String']>;
  frontend_description?: Maybe<Scalars['String']>;
  frontend_name?: Maybe<Scalars['String']>;
  is_pickup_location_active?: Maybe<Scalars['Int']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  region_id?: Maybe<Scalars['Int']>;
  source_code?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  use_default_carrier_config?: Maybe<Scalars['Int']>;
};

export type StockSources = {
  __typename?: 'StockSources';
  items: Array<Maybe<StockSourceItem>>;
  page_info: SearchResultPageInfo;
  total_count: Scalars['Int'];
};

export type StockSourcesFilterInput = {
  city?: InputMaybe<Scalars['String']>;
  source_code?: InputMaybe<Scalars['String']>;
};

export type StoreBooking = {
  __typename?: 'StoreBooking';
  /** The timestamp of order completion after sync with ERP */
  completed_at?: Maybe<Scalars['String']>;
  /** The date the order was placed/created */
  created_at: Scalars['String'];
  /** Information about the booking's customer */
  customer?: Maybe<BookingCustomer>;
  is_jump_start_order?: Maybe<Scalars['Boolean']>;
  is_van_service_order?: Maybe<Scalars['Boolean']>;
  /** An array containing the services booked in this order */
  items?: Maybe<Array<Maybe<BookedItem>>>;
  jump_start_info?: Maybe<JsmInfo>;
  /** The order number */
  number: Scalars['String'];
  /** The parent reminder initiating the appointment / booking */
  parent_reminder?: Maybe<UpcomingVisitReminder>;
  /** Contains details about the calculated totals for this order */
  total?: Maybe<BookingTotal>;
  /** The unique ID for a `StoreBooking` object */
  uid: Scalars['ID'];
  van_service_info?: Maybe<JsmInfo>;
  /** Vehicle assigned to booking */
  vehicle?: Maybe<OrderVehicle>;
};

export type StoreBookings = {
  __typename?: 'StoreBookings';
  /** An array of store bookings */
  items: Array<Maybe<StoreBooking>>;
  /** The total count of store bookings in the specified period. */
  total_count?: Maybe<Scalars['Int']>;
};

/** Contains information about a store's configuration. */
export type StoreConfig = {
  __typename?: 'StoreConfig';
  /** Contains scripts that must be included in the HTML before the closing `<body>` tag. */
  absolute_footer?: Maybe<Scalars['String']>;
  /** Indicates whether guest users can write product reviews. Possible values: 1 (Yes) and 0 (No). */
  allow_guests_to_write_product_reviews?: Maybe<Scalars['String']>;
  /** The value of the Allow Gift Messages for Order Items option */
  allow_items?: Maybe<Scalars['String']>;
  /** The value of the Allow Gift Messages on Order Level option */
  allow_order?: Maybe<Scalars['String']>;
  /** Android Version */
  android_version?: Maybe<Scalars['String']>;
  /** Indicates whether to enable autocomplete on login and forgot password forms. */
  autocomplete_on_storefront?: Maybe<Scalars['Boolean']>;
  /** Extended Config Data - Label text for Availabe in AR */
  available_in_ar_text?: Maybe<Scalars['String']>;
  /** The base currency code. */
  base_currency_code?: Maybe<Scalars['String']>;
  /** A fully-qualified URL that is used to create relative links to the `base_url`. */
  base_link_url?: Maybe<Scalars['String']>;
  /** The fully-qualified URL that specifies the location of media files. */
  base_media_url?: Maybe<Scalars['String']>;
  /** The fully-qualified URL that specifies the location of static view files. */
  base_static_url?: Maybe<Scalars['String']>;
  /** The store’s fully-qualified base URL. */
  base_url?: Maybe<Scalars['String']>;
  /** An array containing the best seller products */
  bestsellers?: Maybe<Products>;
  /** Maximum number of cars a store can serve at a time. */
  bookable_services_max_capacity?: Maybe<Scalars['Float']>;
  /** Maximum number of slots a store can take per service. This value is used in conjunction with `bookable_services_slot_duration` */
  bookable_services_max_slots?: Maybe<Scalars['Float']>;
  /** Slot duration for bookable services. Services duration should be calculated as multiples of this value. */
  bookable_services_slot_duration?: Maybe<Scalars['Float']>;
  /** The default sort order of the search results list. */
  catalog_default_sort_by?: Maybe<Scalars['String']>;
  /** Corresponds to the 'Display Prices In Product Lists' field in the Admin. It indicates how FPT information is displayed on category pages. */
  category_fixed_product_tax_display_setting?: Maybe<FixedProductTaxDisplaySettings>;
  /** The suffix applied to category pages, such as `.htm` or `.html`. */
  category_url_suffix?: Maybe<Scalars['String']>;
  /** Indicates whether only specific countries can use this payment method. */
  check_money_order_enable_for_specific_countries?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the Check/Money Order payment method is enabled. */
  check_money_order_enabled?: Maybe<Scalars['Boolean']>;
  /** The name of the party to whom the check must be payable. */
  check_money_order_make_check_payable_to?: Maybe<Scalars['String']>;
  /** The maximum order amount required to qualify for the Check/Money Order payment method. */
  check_money_order_max_order_total?: Maybe<Scalars['String']>;
  /** The minimum order amount required to qualify for the Check/Money Order payment method. */
  check_money_order_min_order_total?: Maybe<Scalars['String']>;
  /** The status of new orders placed using the Check/Money Order payment method. */
  check_money_order_new_order_status?: Maybe<Scalars['String']>;
  /** A comma-separated list of specific countries allowed to use the Check/Money Order payment method. */
  check_money_order_payment_from_specific_countries?: Maybe<Scalars['String']>;
  /** The full street address or PO Box where the checks are mailed. */
  check_money_order_send_check_to?: Maybe<Scalars['String']>;
  /** A number indicating the position of the Check/Money Order payment method in the list of available payment methods during checkout. */
  check_money_order_sort_order?: Maybe<Scalars['Int']>;
  /** The title of the Check/Money Order payment method displayed on the storefront. */
  check_money_order_title?: Maybe<Scalars['String']>;
  /** The name of the CMS page that identifies the home page for the store. */
  cms_home_page?: Maybe<Scalars['String']>;
  /** A specific CMS page that displays when cookies are not enabled for the browser. */
  cms_no_cookies?: Maybe<Scalars['String']>;
  /** A specific CMS page that displays when a 404 'Page Not Found' error occurs. */
  cms_no_route?: Maybe<Scalars['String']>;
  /**
   * A code assigned to the store to identify it.
   * @deprecated Use `store_code` instead.
   */
  code?: Maybe<Scalars['String']>;
  /** Extended Config Data - Label text for Coming Soon */
  coming_soon_text?: Maybe<Scalars['String']>;
  /** Indicates whether the `parent` or child (`itself`) thumbnail should be used in the cart for configurable products. */
  configurable_thumbnail_source?: Maybe<Scalars['String']>;
  /** The copyright statement that appears at the bottom of each page. */
  copyright?: Maybe<Scalars['String']>;
  /** The description that provides a summary of your site for search engine listings. It should not be more than 160 characters in length. */
  default_description?: Maybe<Scalars['String']>;
  /** The default display currency code. */
  default_display_currency_code?: Maybe<Scalars['String']>;
  /** A series of keywords that describe your store, each separated by a comma. */
  default_keywords?: Maybe<Scalars['String']>;
  /** The title that appears at the title bar of each page when viewed in a browser. */
  default_title?: Maybe<Scalars['String']>;
  /** Controls the display of the demo store notice at the top of the page. Options: 0 (No) or 1 (Yes). */
  demonotice?: Maybe<Scalars['Int']>;
  /** Extended Config Data - Label text for Discontinued Products */
  discontinued_text?: Maybe<Scalars['String']>;
  /** Minimum Order Amount for Free Shipping */
  free_shipping_minimum_order_amount?: Maybe<Scalars['Float']>;
  /** The landing page that is associated with the base URL. */
  front?: Maybe<Scalars['String']>;
  /** The default number of products per page in Grid View. */
  grid_per_page?: Maybe<Scalars['Int']>;
  /** A list of numbers that define how many products can be displayed in Grid View. */
  grid_per_page_values?: Maybe<Scalars['String']>;
  /** Scripts that must be included in the HTML before the closing `<head>` tag. */
  head_includes?: Maybe<Scalars['String']>;
  /** The small graphic image (favicon) that appears in the address bar and tab of the browser. */
  head_shortcut_icon?: Maybe<Scalars['String']>;
  /** The path to the logo that appears in the header. */
  header_logo_src?: Maybe<Scalars['String']>;
  /**
   * The ID number assigned to the store.
   * @deprecated Use `store_code` instead.
   */
  id?: Maybe<Scalars['Int']>;
  /** Include Discount in Minimum Order Amount? */
  include_discount_in_minimum_order_amount?: Maybe<Scalars['Boolean']>;
  /** Include Tax in Minimum Order Amount? */
  include_tax_in_minimum_order_amount?: Maybe<Scalars['Boolean']>;
  /** The SKU of the initial inspection service */
  initial_inspection_service_sku?: Maybe<Scalars['String']>;
  /** IOS Version */
  ios_version?: Maybe<Scalars['String']>;
  /** Check whether paymob/accept sympl payment method enabled to show the sympl widget on products details pages. */
  is_accept_sympl_enabled?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the store view has been designated as the default within the store group. */
  is_default_store?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the store group has been designated as the default within the website. */
  is_default_store_group?: Maybe<Scalars['Boolean']>;
  /** Extended Config Data - Label text when a product is limited */
  limited_qty_text?: Maybe<Scalars['String']>;
  /** Extended Config Data - Label quantity threshold determines when to show the limited qty label */
  limited_qty_threshold?: Maybe<Scalars['Int']>;
  /** The format of the search results list. */
  list_mode?: Maybe<Scalars['String']>;
  /** The default number of products per page in List View. */
  list_per_page?: Maybe<Scalars['Int']>;
  /** A list of numbers that define how many products can be displayed in List View. */
  list_per_page_values?: Maybe<Scalars['String']>;
  /** The store locale. */
  locale?: Maybe<Scalars['String']>;
  /** The Alt text that is associated with the logo. */
  logo_alt?: Maybe<Scalars['String']>;
  /** The height of the logo image, in pixels. */
  logo_height?: Maybe<Scalars['Int']>;
  /** The width of the logo image, in pixels. */
  logo_width?: Maybe<Scalars['Int']>;
  /** Indicates whether wishlists are enabled (1) or disabled (0). */
  magento_wishlist_general_is_enabled?: Maybe<Scalars['String']>;
  /** Is Minimum Order Value Enabled? */
  minimum_order_active?: Maybe<Scalars['String']>;
  /** Minimum Order Amount */
  minimum_order_amount?: Maybe<Scalars['Int']>;
  /** The minimum number of characters required for a valid password. */
  minimum_password_length?: Maybe<Scalars['String']>;
  /** Count of returned nearest times available for booking. */
  nearest_booking_times_count?: Maybe<Scalars['Float']>;
  /** The default page that displays when a 404 'Page not Found' error occurs. */
  no_route?: Maybe<Scalars['String']>;
  /** some desc */
  offer_ranges?: Maybe<Array<Maybe<Range>>>;
  /** Payflow Pro vault status. */
  payment_payflowpro_cc_vault_active?: Maybe<Scalars['String']>;
  /** Corresponds to the 'Display Prices On Product View Page' field in the Admin. It indicates how FPT information is displayed on product pages. */
  product_fixed_product_tax_display_setting?: Maybe<FixedProductTaxDisplaySettings>;
  /** Indicates whether product reviews are enabled. Possible values: 1 (Yes) and 0 (No). */
  product_reviews_enabled?: Maybe<Scalars['String']>;
  /** The suffix applied to product pages, such as `.htm` or `.html`. */
  product_url_suffix?: Maybe<Scalars['String']>;
  /** The number of different character classes (lowercase, uppercase, digits, special characters) required in a password. */
  required_character_classes_number?: Maybe<Scalars['String']>;
  /** Extended Config Data - Product Deals Footer Content */
  robusta_products_deals_module_config_deals_footer_content?: Maybe<Scalars['String']>;
  /** Extended Config Data - Product Deals Meta Description */
  robusta_products_deals_module_config_deals_meta_description?: Maybe<Scalars['String']>;
  /** Extended Config Data -  Product Deals Meta Title */
  robusta_products_deals_module_config_deals_meta_title?: Maybe<Scalars['String']>;
  /** Extended Config Data - Product Deals Page Title */
  robusta_products_deals_module_config_deals_page_title?: Maybe<Scalars['String']>;
  /**
   * The ID of the root category.
   * @deprecated Use `root_category_uid` instead.
   */
  root_category_id?: Maybe<Scalars['Int']>;
  /** The unique ID for a `CategoryInterface` object. */
  root_category_uid?: Maybe<Scalars['ID']>;
  /** Corresponds to the 'Display Prices In Sales Modules' field in the Admin. It indicates how FPT information is displayed on cart, checkout, and order pages. */
  sales_fixed_product_tax_display_setting?: Maybe<FixedProductTaxDisplaySettings>;
  /** A secure fully-qualified URL that is used to create relative links to the `base_url`. */
  secure_base_link_url?: Maybe<Scalars['String']>;
  /** The secure fully-qualified URL that specifies the location of media files. */
  secure_base_media_url?: Maybe<Scalars['String']>;
  /** The secure fully-qualified URL that specifies the location of static view files. */
  secure_base_static_url?: Maybe<Scalars['String']>;
  /** The store’s fully-qualified secure base URL. */
  secure_base_url?: Maybe<Scalars['String']>;
  /** Email to a Friend configuration. */
  send_friend?: Maybe<SendFriendConfiguration>;
  /** Indicates whether a breadcrumb trail appears on all CMS pages in the catalog. 0 (No) or 1 (Yes). */
  show_cms_breadcrumbs?: Maybe<Scalars['Int']>;
  /** The unique ID of the store view. In the Admin, this is called the Store View Code. When making a GraphQL call, assign this value to the `Store` header to provide the scope. */
  store_code?: Maybe<Scalars['ID']>;
  /** The unique ID assigned to the store group. In the Admin, this is called the Store Name. */
  store_group_code?: Maybe<Scalars['ID']>;
  /** The label assigned to the store group. */
  store_group_name?: Maybe<Scalars['String']>;
  /** The label assigned to the store view. */
  store_name?: Maybe<Scalars['String']>;
  /** The store view sort order. */
  store_sort_order?: Maybe<Scalars['Int']>;
  /** The time zone of the store. */
  timezone?: Maybe<Scalars['String']>;
  /** A prefix that appears before the title to create a two- or three-part title. */
  title_prefix?: Maybe<Scalars['String']>;
  /** The character that separates the category name and subcategory in the browser title bar. */
  title_separator?: Maybe<Scalars['String']>;
  /** A suffix that appears after the title to create a two- or three-part title. */
  title_suffix?: Maybe<Scalars['String']>;
  /** Indicates whether the store code should be used in the URL. */
  use_store_in_url?: Maybe<Scalars['Boolean']>;
  /** The unique ID for the website. */
  website_code?: Maybe<Scalars['ID']>;
  /**
   * The ID number assigned to the website store.
   * @deprecated The field should not be used on the storefront.
   */
  website_id?: Maybe<Scalars['Int']>;
  /** The label assigned to the website. */
  website_name?: Maybe<Scalars['String']>;
  /** The unit of weight. */
  weight_unit?: Maybe<Scalars['String']>;
  /** Text that appears in the header of the page and includes the name of the logged in customer. */
  welcome?: Maybe<Scalars['String']>;
  /** Indicates whether only specific countries can use this payment method. */
  zero_subtotal_enable_for_specific_countries?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the Zero Subtotal payment method is enabled. */
  zero_subtotal_enabled?: Maybe<Scalars['Boolean']>;
  /** The status of new orders placed using the Zero Subtotal payment method. */
  zero_subtotal_new_order_status?: Maybe<Scalars['String']>;
  /** When the new order status is 'Processing', this can be set to `authorize_capture` to automatically invoice all items that have a zero balance. */
  zero_subtotal_payment_action?: Maybe<Scalars['String']>;
  /** A comma-separated list of specific countries allowed to use the Zero Subtotal payment method. */
  zero_subtotal_payment_from_specific_countries?: Maybe<Scalars['String']>;
  /** A number indicating the position of the Zero Subtotal payment method in the list of available payment methods during checkout. */
  zero_subtotal_sort_order?: Maybe<Scalars['Int']>;
  /** The title of the Zero Subtotal payment method displayed on the storefront. */
  zero_subtotal_title?: Maybe<Scalars['String']>;
};


/** Contains information about a store's configuration. */
export type StoreConfigBestsellersArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ProductAttributeFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ProductAttributeSortInput>;
};

export type StoreLocator = {
  __typename?: 'StoreLocator';
  address?: Maybe<Scalars['String']>;
  /** The products available in this store locator. */
  available_services?: Maybe<Products>;
  /** Gets all bookings at the store in the specified period. */
  bookings?: Maybe<StoreBookings>;
  city?: Maybe<City>;
  /** Gets all times the store is closed in the specified period. */
  closed_periods: Array<Maybe<ClosedPeriod>>;
  code?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image_url?: Maybe<Scalars['String']>;
  is_active?: Maybe<Scalars['Boolean']>;
  latitude?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  region?: Maybe<Region>;
  storeSource?: Maybe<StockSourceItem>;
  storeSourceCode?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  /** The visits currently in this store locator. */
  visits?: Maybe<StoreVisits>;
  /** The number of visits in this store locator, grouped by status. */
  visitsCountByStatus?: Maybe<Array<Maybe<VisitStatusCount>>>;
  /** Value ranges from 1 to 24 mapping 1 AM to 12 AM respectively */
  working_from: Scalars['Int'];
  working_hours?: Maybe<Scalars['String']>;
  /** Value ranges from 1 to 24 mapping 1 AM to 12 AM respectively */
  working_to: Scalars['Int'];
};


export type StoreLocatorAvailable_ServicesArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ProductAttributeFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<ProductAttributeSortInput>;
};


export type StoreLocatorBookingsArgs = {
  from?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['ID']>;
  orderNumber?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  sosStatusFilter?: InputMaybe<SosStatusFilterInput>;
  statuses?: InputMaybe<FilterBookingStatusInput>;
  to?: InputMaybe<Scalars['String']>;
};


export type StoreLocatorClosed_PeriodsArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type StoreLocatorVisitsArgs = {
  filter?: InputMaybe<StoreVisitsFilterInput>;
  search?: InputMaybe<Scalars['String']>;
};

export type StoreLocatorOutput = {
  __typename?: 'StoreLocatorOutput';
  items?: Maybe<Array<Maybe<StoreLocator>>>;
  total_count: Scalars['Int'];
};

/** This enumeration contains values for store types. */
export enum StoreTypeEnum {
  /** @deprecated  */
  JumpStartStore = 'JUMP_START_STORE',
  /** @deprecated  */
  ServiceCenter = 'SERVICE_CENTER',
  /** @deprecated  */
  Store = 'STORE',
  /** @deprecated  */
  Van = 'VAN',
  /** @deprecated  */
  VanServiceStore = 'VAN_SERVICE_STORE'
}

export type StoreTypeFilter = {
  eq?: InputMaybe<StoreTypeEnum>;
  in?: InputMaybe<Array<InputMaybe<StoreTypeEnum>>>;
  neq?: InputMaybe<StoreTypeEnum>;
  nin?: InputMaybe<Array<InputMaybe<StoreTypeEnum>>>;
};

export type StoreVisits = {
  __typename?: 'StoreVisits';
  /** An array containing the visits in this store locator */
  items?: Maybe<Array<Maybe<Visit>>>;
  /** The total number of visits returned */
  total_count?: Maybe<Scalars['Int']>;
};

export type StoreVisitsFilterInput = {
  /** Filter by visit id */
  id?: InputMaybe<FilterEqualTypeInput>;
  /** Filter by visit number */
  visit_number?: InputMaybe<FilterEqualTypeInput>;
  /** Filter by visit status */
  visit_status?: InputMaybe<VisitStatus>;
};

/** Indicates where an attribute can be displayed. */
export type StorefrontProperties = {
  __typename?: 'StorefrontProperties';
  /** The relative position of the attribute in the layered navigation block. */
  position?: Maybe<Scalars['Int']>;
  /** Indicates whether the attribute is filterable with results, without results, or not at all. */
  use_in_layered_navigation?: Maybe<UseInLayeredNavigationOptions>;
  /** Indicates whether the attribute is displayed in product listings. */
  use_in_product_listing?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the attribute can be used in layered navigation on search results pages. */
  use_in_search_results_layered_navigation?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the attribute is displayed on product pages. */
  visible_on_catalog_pages?: Maybe<Scalars['Boolean']>;
};

export type SubmitSubstitutionInput = {
  substitution_id: Scalars['Int'];
};

/** Contains the result of the `subscribeEmailToNewsletter` operation. */
export type SubscribeEmailToNewsletterOutput = {
  __typename?: 'SubscribeEmailToNewsletterOutput';
  /** The status of the subscription request. */
  status?: Maybe<SubscriptionStatusesEnum>;
};

/** Indicates the status of the request. */
export enum SubscriptionStatusesEnum {
  /** @deprecated  */
  NotActive = 'NOT_ACTIVE',
  /** @deprecated  */
  Subscribed = 'SUBSCRIBED',
  /** @deprecated  */
  Unconfirmed = 'UNCONFIRMED',
  /** @deprecated  */
  Unsubscribed = 'UNSUBSCRIBED'
}

export type Substitution = {
  __typename?: 'Substitution';
  additional_items: Array<Maybe<AdditionalItem>>;
  can_submit: Scalars['Boolean'];
  confirmed_items: Array<Maybe<SubstitutionItem>>;
  created_at: Scalars['String'];
  id: Scalars['Int'];
  items: Array<Maybe<SubstitutionItem>>;
  non_confirmed_items: Array<Maybe<SubstitutionItem>>;
  notified_at?: Maybe<Scalars['String']>;
  /** Time passed since customer received substitution notification in seconds */
  notified_since?: Maybe<Scalars['Int']>;
  original_grand_total: Scalars['Float'];
  started_at?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  total_added: Scalars['Float'];
  total_removed: Scalars['Float'];
  updated_grand_total: Scalars['Float'];
  visit: Visit;
};

export type SubstitutionItem = {
  __typename?: 'SubstitutionItem';
  attribute_code?: Maybe<Scalars['String']>;
  /** Information about the booking of this item */
  booking?: Maybe<BookedService>;
  can_update_status: Scalars['Boolean'];
  final_quantity: Scalars['Float'];
  id: Scalars['Int'];
  price: Scalars['Float'];
  product: ProductInterface;
  quantity: Scalars['Float'];
  row_total: Scalars['Float'];
  status: SubstitutionItemStatus;
};

export enum SubstitutionItemStatus {
  /** @deprecated  */
  Approved = 'APPROVED',
  /** @deprecated  */
  Complete = 'COMPLETE',
  /** @deprecated  */
  Declined = 'DECLINED',
  /** @deprecated  */
  InProgress = 'IN_PROGRESS',
  /** @deprecated  */
  InQueue = 'IN_QUEUE',
  /** @deprecated  */
  Pending = 'PENDING'
}

/** Describes the swatch type and a value. */
export type SwatchData = {
  __typename?: 'SwatchData';
  /** The type of swatch filter item: 1 - text; 2 - image. */
  type?: Maybe<Scalars['String']>;
  /** The value for the swatch item. It could be text or an image link. */
  value?: Maybe<Scalars['String']>;
};

export type SwatchDataInterface = {
  /** The value can be represented as color (HEX code), image link, or text. */
  value?: Maybe<Scalars['String']>;
};

export type SwatchLayerFilterItem = LayerFilterItemInterface & SwatchLayerFilterItemInterface & {
  __typename?: 'SwatchLayerFilterItem';
  /**
   * The count of items per filter.
   * @deprecated Use `AggregationOption.count` instead.
   */
  items_count?: Maybe<Scalars['Int']>;
  /**
   * The label for a filter.
   * @deprecated Use `AggregationOption.label` instead.
   */
  label?: Maybe<Scalars['String']>;
  /** Data required to render a swatch filter item. */
  swatch_data?: Maybe<SwatchData>;
  /**
   * The value of a filter request variable to be used in query.
   * @deprecated Use `AggregationOption.value` instead.
   */
  value_string?: Maybe<Scalars['String']>;
};

export type SwatchLayerFilterItemInterface = {
  /** Data required to render a swatch filter item. */
  swatch_data?: Maybe<SwatchData>;
};

/** Contains tax item details. */
export type TaxItem = {
  __typename?: 'TaxItem';
  /** The amount of tax applied to the item. */
  amount: Money;
  /** The rate used to calculate the tax. */
  rate: Scalars['Float'];
  /** A title that describes the tax. */
  title: Scalars['String'];
};

export type Testimonial = {
  __typename?: 'Testimonial';
  customer_name?: Maybe<Scalars['String']>;
  customer_position?: Maybe<Scalars['String']>;
  customer_review?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  image_url: Scalars['String'];
};

export type TextSwatchData = SwatchDataInterface & {
  __typename?: 'TextSwatchData';
  /** The value can be represented as color (HEX code), image link, or text. */
  value?: Maybe<Scalars['String']>;
};

/** Defines a price based on the quantity purchased. */
export type TierPrice = {
  __typename?: 'TierPrice';
  /** The price discount that this tier represents. */
  discount?: Maybe<ProductDiscount>;
  /** The price of the product at this tier. */
  final_price?: Maybe<Money>;
  /** The minimum number of items that must be purchased to qualify for this price tier. */
  quantity?: Maybe<Scalars['Float']>;
};

export type UpcomingVisitReminder = {
  __typename?: 'UpcomingVisitReminder';
  can_edit: Scalars['Boolean'];
  comment?: Maybe<Scalars['String']>;
  date: Scalars['String'];
  id: Scalars['ID'];
  is_visit_reminder: Scalars['Boolean'];
  overdue: Scalars['Boolean'];
  parent_visit?: Maybe<Visit>;
  service?: Maybe<UpcomingVisitReminderService>;
};

export type UpcomingVisitReminderService = {
  __typename?: 'UpcomingVisitReminderService';
  items: Array<Maybe<ProductInterface>>;
};

export type UpcomingVisitsReminders = {
  __typename?: 'UpcomingVisitsReminders';
  /** An array containing the upcoming visits reminders */
  items: Array<Maybe<UpcomingVisitReminder>>;
  /** An object that includes the current_page, page_info, and page_size values specified in the query */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The total count of reminders */
  total_count?: Maybe<Scalars['Int']>;
};

export type UpdateAdminUserInput = {
  email?: InputMaybe<Scalars['String']>;
  firstname?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  role_id?: InputMaybe<Scalars['Int']>;
  store_locator_id?: InputMaybe<Scalars['Int']>;
  store_locator_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  username?: InputMaybe<Scalars['String']>;
};

export type UpdateBookableServiceInput = {
  bookable_service_uid: Scalars['ID'];
  /** If this service is enabled in store. */
  is_enabled_in_store?: InputMaybe<Scalars['Boolean']>;
  /** Number of minutes before the booking time to allow booking. */
  lead_time?: InputMaybe<Scalars['Int']>;
  /** Set the service timings the same as store working hours. */
  same_as_store_times?: InputMaybe<Scalars['Boolean']>;
  /** Number of cars the store can serve for this service at a time. */
  store_capacity?: InputMaybe<Scalars['Int']>;
  /** Number of slot durations the store takes. To calculate total duration check the one slot duration from `StoreConfig`. */
  store_duration_slots?: InputMaybe<Scalars['Int']>;
  working_times?: InputMaybe<WorkingTimesInput>;
};

export type UpdateBookingStatusInput = {
  /** The ID of booking to update. */
  booking_uid: Scalars['ID'];
  /** The cancellation reason if booking is to be cancelled. */
  cancellation_reason?: InputMaybe<Scalars['String']>;
  /** The comment if booking status is changed. */
  comment?: InputMaybe<Scalars['String']>;
  /** The status to change the booking to. */
  status: BookingStatus;
};

export type UpdateBookingTimeInput = {
  /** The day to book at in the format `YYYY-MM-DD`. By default it's today if left empty. */
  booking_day?: InputMaybe<Scalars['String']>;
  /** The time to book at in the format `HH:MM`. */
  booking_time: Scalars['String'];
  /** The ID of booking to update. */
  booking_uid: Scalars['ID'];
};

/** Modifies the specified items in the cart. */
export type UpdateCartItemsInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
  /** An array of items to be updated. */
  cart_items: Array<InputMaybe<CartItemUpdateInput>>;
};

/** Contains details about the cart after updating items. */
export type UpdateCartItemsOutput = {
  __typename?: 'UpdateCartItemsOutput';
  /** The cart after updating products. */
  cart: Cart;
};

export type UpdateClosedPeriodInput = {
  /** The start time of this period formatted as `YYYY-MM-DD HH:MM`. */
  from?: InputMaybe<Scalars['String']>;
  /** The reason why the store is closed at this time. */
  reason?: InputMaybe<Scalars['String']>;
  /** The end time of this booking formatted as `YYYY-MM-DD HH:MM`. */
  to?: InputMaybe<Scalars['String']>;
  /** The unique ID for the closed time */
  uid: Scalars['ID'];
};

export type UpdateCustomerPhoneNumberInput = {
  phone_number: Scalars['String'];
};

export type UpdateCustomerPhoneNumberOutput = {
  __typename?: 'UpdateCustomerPhoneNumberOutput';
  customer: Customer;
};

export type UpdateInspectionAdditionalDataInput = {
  /** Filepaths of images to be deleted/ removed. */
  unsetInput?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateInput?: InputMaybe<Array<InputMaybe<InspectionAdditionalDataInput>>>;
};

export type UpdateInspectionInput = {
  fields: Array<InputMaybe<InspectionFieldInput>>;
  visit_id: Scalars['ID'];
};

/** Contains the customer's wish list and any errors encountered. */
export type UpdateProductsInWishlistOutput = {
  __typename?: 'UpdateProductsInWishlistOutput';
  /** An array of errors encountered while updating products in a wish list. */
  user_errors: Array<Maybe<WishListUserInputError>>;
  /** Contains the wish list with all items that were successfully updated. */
  wishlist: Wishlist;
};

export type UpdateSubstitutionItemInput = {
  quantity?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<SubstitutionItemStatus>;
  substitution_id: Scalars['Int'];
  substitution_item_id?: InputMaybe<Scalars['Int']>;
  visit_item_uid?: InputMaybe<Scalars['ID']>;
};

export type UpdateVisitItemInput = {
  item_uid: Scalars['ID'];
  status: VisitItemStatus;
  visit_id: Scalars['ID'];
};

/** Contains URL rewrite details. */
export type UrlRewrite = {
  __typename?: 'UrlRewrite';
  /** An array of request parameters. */
  parameters?: Maybe<Array<Maybe<HttpQueryParameter>>>;
  /** The request URL. */
  url?: Maybe<Scalars['String']>;
};

/** This enumeration defines the entity type. */
export enum UrlRewriteEntityTypeEnum {
  /** @deprecated  */
  Category = 'CATEGORY',
  /** @deprecated  */
  CmsPage = 'CMS_PAGE',
  /** @deprecated  */
  Product = 'PRODUCT'
}

/** Defines whether the attribute is filterable in layered navigation. */
export enum UseInLayeredNavigationOptions {
  /** @deprecated  */
  FilterableNoResult = 'FILTERABLE_NO_RESULT',
  /** @deprecated  */
  FilterableWithResults = 'FILTERABLE_WITH_RESULTS',
  /** @deprecated  */
  No = 'NO'
}

export type UsedCarAppointmentInput = {
  email: Scalars['String'];
  fullName: Scalars['String'];
  phoneNumber: Scalars['String'];
  vehicleUid: Scalars['ID'];
};

export type UsedVehicle = {
  __typename?: 'UsedVehicle';
  body_type: Scalars['String'];
  brand: VehicleBrand;
  created_at: Scalars['String'];
  /** List of used vehicle custom labels */
  custom_labels: Array<Maybe<Label>>;
  engine_size: Scalars['Int'];
  exterior_color: Scalars['String'];
  fuel_type: Scalars['String'];
  image: Scalars['String'];
  inspection?: Maybe<UsedVehicleInspection>;
  interior_color: Scalars['String'];
  kilometers: Scalars['Int'];
  media_gallery: Array<Maybe<UsedVehicleMedia>>;
  model: VehicleModel;
  price: Scalars['Float'];
  sold: Scalars['Boolean'];
  transmission: Scalars['String'];
  trim?: Maybe<Scalars['String']>;
  uid: Scalars['ID'];
  year: Scalars['Int'];
};

export type UsedVehicleFilterInput = {
  brand?: InputMaybe<FilterEqualTypeInput>;
  brand_id?: InputMaybe<FilterEqualTypeInput>;
  mileage?: InputMaybe<FilterRangeTypeInput>;
  model?: InputMaybe<FilterEqualTypeInput>;
  model_id?: InputMaybe<FilterEqualTypeInput>;
  model_year?: InputMaybe<FilterRangeTypeInput>;
  price?: InputMaybe<FilterRangeTypeInput>;
  transmission?: InputMaybe<FilterEqualTypeInput>;
  uid?: InputMaybe<FilterEqualTypeInput>;
};

export type UsedVehicleInspection = {
  __typename?: 'UsedVehicleInspection';
  created_at: Scalars['String'];
  /** Inspection entity custom attributes metadata by attribute set. */
  customAttributeMetadata?: Maybe<CustomAttributeMetadata>;
  fields?: Maybe<Array<Maybe<InspectionField>>>;
  pdf_url?: Maybe<Scalars['String']>;
  updated_at: Scalars['String'];
};


export type UsedVehicleInspectionCustomAttributeMetadataArgs = {
  attributeSet?: InputMaybe<Scalars['String']>;
};

export type UsedVehicleMedia = {
  __typename?: 'UsedVehicleMedia';
  type?: Maybe<MediaTypeEnum>;
  url?: Maybe<Scalars['String']>;
};

export type UsedVehicleSortInput = {
  price?: InputMaybe<SortEnum>;
};

export type UsedVehicles = {
  __typename?: 'UsedVehicles';
  /** A bucket that contains the attribute code and label for each filterable option. */
  aggregations?: Maybe<Array<Maybe<Aggregation>>>;
  items: Array<Maybe<UsedVehicle>>;
  /** comment for page_info. */
  page_info?: Maybe<SearchResultPageInfo>;
  total_count?: Maybe<Scalars['Int']>;
};

export type UsersFilterInput = {
  email?: InputMaybe<FilterStringTypeInput>;
  firstname?: InputMaybe<FilterStringTypeInput>;
  lastname?: InputMaybe<FilterStringTypeInput>;
  role_id?: InputMaybe<FilterEqualTypeInput>;
  store_locator_id?: InputMaybe<FilterEqualTypeInput>;
  username?: InputMaybe<FilterStringTypeInput>;
};

/** Contains required input for payment methods with Vault support. */
export type VaultTokenInput = {
  /** The public hash of the payment token. */
  public_hash: Scalars['String'];
};

export type VehicleBrand = {
  __typename?: 'VehicleBrand';
  id: Scalars['ID'];
  is_user_defined: Scalars['Boolean'];
  models: Array<Maybe<VehicleModel>>;
  title: Scalars['String'];
};

export type VehicleInput = {
  /** Custom Brand only */
  brand?: InputMaybe<Scalars['String']>;
  /** Vehicle Color ID */
  color_id?: InputMaybe<Scalars['ID']>;
  /** Make this vehicle default vehicle for the customer */
  is_default?: InputMaybe<Scalars['Boolean']>;
  /** License plate number */
  license_number?: InputMaybe<Scalars['String']>;
  /** Vehicle model mileage */
  mileage?: InputMaybe<Scalars['String']>;
  /** Vehicle Model id, or custom Model */
  model: VehicleModelInput;
  /** Vehicle model year */
  model_year?: InputMaybe<Scalars['String']>;
  /** Vehicle Identification Number */
  vin?: InputMaybe<Scalars['String']>;
};

export type VehicleModel = {
  __typename?: 'VehicleModel';
  id: Scalars['ID'];
  is_user_defined: Scalars['Boolean'];
  title: Scalars['String'];
};

export type VehicleModelInput = {
  id?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
};

export type VerifyCustomerSourceInput = {
  customer_source: Scalars['String'];
  phone_number: Scalars['String'];
  verified: Scalars['Boolean'];
};

export type VerifyCustomerSourceOutput = {
  __typename?: 'VerifyCustomerSourceOutput';
  existed?: Maybe<Scalars['Boolean']>;
};

export type VerifyingPhoneNumberInput = {
  code: Scalars['String'];
  phone_number: Scalars['String'];
};

/** An implementation for virtual product cart items. */
export type VirtualCartItem = CartItemInterface & {
  __typename?: 'VirtualCartItem';
  /** Information about the booking of this item */
  booked_service?: Maybe<BookedService>;
  /** An array containing customizable options the shopper selected. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>;
  /** @deprecated Use `uid` instead. */
  id: Scalars['String'];
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>;
  /** Details about an item in the cart. */
  product: ProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float'];
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID'];
};

/** Defines a virtual product, which is a non-tangible product that does not require shipping and is not kept in inventory. */
export type VirtualProduct = CustomizableProductInterface & ProductInterface & RoutableInterface & {
  __typename?: 'VirtualProduct';
  /** @deprecated Use the `custom_attributes` field instead. */
  ampere?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  aspect_ratio?: Maybe<Scalars['Int']>;
  /** Attribute set information */
  attribute_set?: Maybe<AttributeSetInformation>;
  /**
   * The attribute set assigned to the product.
   * @deprecated The field should not be used on the storefront.
   */
  attribute_set_id?: Maybe<Scalars['Int']>;
  /** List of product attributes */
  attributes?: Maybe<Array<Maybe<CustomAttribute>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  average_duration?: Maybe<Scalars['String']>;
  /** Attributes regarding this bookable service in the given store locator. */
  bookable_service?: Maybe<BookableService>;
  /** The product brand. */
  brand?: Maybe<Brand>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
  canonical_url?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  car_batteries_ampere?: Maybe<Scalars['Int']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  color?: Maybe<Scalars['Int']>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  country_of_origin?: Maybe<Scalars['Int']>;
  /**
   * Timestamp indicating when the product was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  creation_date?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  creation_id?: Maybe<Scalars['Int']>;
  /** Crosssell Products */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /**
   * List of product custom labels
   * @deprecated Use the `custom_attributes` field instead.
   */
  custom_labels: Array<Maybe<Label>>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  /** @deprecated Use the `custom_attributes` field instead. */
  diameter?: Maybe<Scalars['Int']>;
  expected_shipping_fees?: Maybe<Scalars['Float']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  exterior_hand_wash?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_age_group?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_age_range?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_baby_food_stage?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_brand?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_capacity?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_color?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_compatible_devices?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_decor_style?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_digital_zoom?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_display_technology?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_finish?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_gemstone?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_gender?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_health_concern?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_ingredients?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_is_assembly_required?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_material?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_maximum_weight?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_megapixels?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_minimum_weight?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_model?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_number_of_licenses?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_operating_system?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_optical_zoom?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_package_quantity?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_pattern?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_depth?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_form?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_height?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_length?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_weight?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_product_width?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_recommended_use?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_resolution?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_scent?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_screen_size?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_shoe_width?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_size?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_storage_capacity?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_style?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_system_requirements?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_thread_count?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  facebook_video_game_platform?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  featured_order?: Maybe<Scalars['Int']>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  has_deal?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  hover_cleaning?: Maybe<Scalars['Int']>;
  /**
   * The ID number assigned to the product.
   * @deprecated Use the `uid` field instead.
   */
  id?: Maybe<Scalars['Int']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** @deprecated Use the `custom_attributes` field instead. */
  in_store_only?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  interior_cleaning?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  interior_vacuum_clean?: Maybe<Scalars['Int']>;
  /** Check if product is a best seller */
  is_best_seller?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  is_bookable_service?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  is_bookable_service_addon?: Maybe<Scalars['Int']>;
  /** if the product favorited by the logged in user */
  is_favorited?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  is_featured?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  is_featured_offer?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  is_november_deal?: Maybe<Scalars['Int']>;
  is_van_installment_enabled: Scalars['Boolean'];
  /** Indicates whether the product is the wiper that has the gift or not. */
  is_wiper: Scalars['Boolean'];
  /** product labels */
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * A number representing the product's manufacturer.
   * @deprecated Use the `custom_attributes` field instead.
   */
  manufacturer?: Maybe<Scalars['Int']>;
  /** An array of media gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use `media_gallery` instead.
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  mileage_warranty?: Maybe<Scalars['String']>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']>;
  /** Quantity of product left in customer's choosen source */
  only_x_left_in_source?: Maybe<Scalars['Float']>;
  /** Product stock only x left count */
  only_x_left_in_stock?: Maybe<Scalars['Float']>;
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  pattern?: Maybe<Scalars['String']>;
  /**
   * Indicates the price of an item.
   * @deprecated Use `price_range` for product price information.
   */
  price?: Maybe<ProductPrices>;
  /** The range of prices for the product */
  price_range: PriceRange;
  /** An array of `TierPrice` objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_brand_id?: Maybe<Scalars['Int']>;
  /** An array of `ProductLinks` objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  product_offer_type?: Maybe<Scalars['Int']>;
  /** The average of all the ratings given to the product. */
  rating_summary: Scalars['Float'];
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int'];
  /** Related Products */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']>;
  /** The total count of all the reviews given to the product. */
  review_count: Scalars['Int'];
  /** The list of products reviews. */
  reviews: ProductReviews;
  /** @deprecated Use the `custom_attributes` field instead. */
  serving_order?: Maybe<Scalars['Int']>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  /**
   * The beginning date that a product has a special price.
   * @deprecated The field should not be used on the storefront.
   */
  special_from_date?: Maybe<Scalars['String']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']>;
  /** Time left for expiry of special price in seconds */
  special_price_time_left?: Maybe<Scalars['Int']>;
  /** The end date for a product with a special price. */
  special_to_date?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  speed?: Maybe<Scalars['String']>;
  /** List of product attributes */
  stockQtyTerm?: Maybe<Array<Maybe<ProductStockQty>>>;
  /** Stock status of the product */
  stock_status?: Maybe<ProductStockStatus>;
  /** The file name of a swatch image. */
  swatch_image?: Maybe<Scalars['String']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  type?: Maybe<Scalars['Int']>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use `__typename` instead.
   */
  type_id?: Maybe<Scalars['String']>;
  /** The unique ID for a `ProductInterface` object. */
  uid: Scalars['ID'];
  /**
   * Timestamp indicating when the product was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']>;
  /** Upsell Products */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  width?: Maybe<Scalars['Int']>;
};


/** Defines a virtual product, which is a non-tangible product that does not require shipping and is not kept in inventory. */
export type VirtualProductAttributesArgs = {
  groupCode?: InputMaybe<Scalars['String']>;
};


/** Defines a virtual product, which is a non-tangible product that does not require shipping and is not kept in inventory. */
export type VirtualProductBookable_ServiceArgs = {
  storeLocatorId?: InputMaybe<Scalars['Int']>;
};


/** Defines a virtual product, which is a non-tangible product that does not require shipping and is not kept in inventory. */
export type VirtualProductExpected_Shipping_FeesArgs = {
  sourceCode?: InputMaybe<Scalars['String']>;
};


/** Defines a virtual product, which is a non-tangible product that does not require shipping and is not kept in inventory. */
export type VirtualProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** Defines a single product to add to the cart. */
export type VirtualProductCartItemInput = {
  /** An array that defines customizable options for the product. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  /** An object containing the `sku`, `quantity`, and other relevant information about the product. */
  data: CartItemInput;
};

/** Contains a virtual product wish list item. */
export type VirtualWishlistItem = WishlistItemInterface & {
  __typename?: 'VirtualWishlistItem';
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String'];
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars['String']>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID'];
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars['Float'];
};

export type Visit = {
  __typename?: 'Visit';
  /** Whether the visit can be invoiced */
  can_invoice?: Maybe<Scalars['Boolean']>;
  /** An array containing the comments for this visit */
  comments?: Maybe<Array<Maybe<Scalars['String']>>>;
  created_at: Scalars['String'];
  /** Information about the visit's customer */
  customer?: Maybe<BookingCustomer>;
  /** The discount for this visit */
  discount?: Maybe<Scalars['Float']>;
  /** The discount type for this visit */
  discount_type?: Maybe<DiscountType>;
  id: Scalars['ID'];
  inspection?: Maybe<Inspection>;
  /** The invoice for this visit */
  invoice?: Maybe<Invoice>;
  /** Whether the visit has been invoiced */
  is_invoiced?: Maybe<Scalars['Boolean']>;
  /** An array containing the services & products in this visit */
  items?: Maybe<Array<Maybe<VisitItem>>>;
  parent_order_number?: Maybe<Scalars['ID']>;
  /** The parent reminder initiating the appointment for this visit */
  parent_reminder?: Maybe<UpcomingVisitReminder>;
  /** An array containing the reminders for the upcoming visits */
  reminders: Array<Maybe<UpcomingVisitReminder>>;
  store_locator_id?: Maybe<Scalars['Int']>;
  store_locator_name?: Maybe<Scalars['String']>;
  substitution?: Maybe<Substitution>;
  subtotal?: Maybe<Scalars['Float']>;
  uid: Scalars['ID'];
  vehicle?: Maybe<OrderVehicle>;
  visit_number: Scalars['ID'];
  visit_status: VisitStatus;
};

export type VisitItem = {
  __typename?: 'VisitItem';
  /** Information about the booking of this item */
  booking?: Maybe<BookedService>;
  /** The price of the item. */
  price: Money;
  product?: Maybe<ProductInterface>;
  /** The name of the base product */
  product_name?: Maybe<Scalars['String']>;
  /** The SKU of the base product */
  product_sku: Scalars['String'];
  /** The number of units for this item */
  quantity?: Maybe<Scalars['Float']>;
  /** The status of this item */
  status?: Maybe<VisitItemStatus>;
  /** The unique ID for a `VisitItem` object */
  uid: Scalars['ID'];
};

export enum VisitItemStatus {
  /** @deprecated  */
  Complete = 'COMPLETE',
  /** @deprecated  */
  InProgress = 'IN_PROGRESS',
  /** @deprecated  */
  InQueue = 'IN_QUEUE',
  /** @deprecated  */
  Pending = 'PENDING'
}

export enum VisitStatus {
  /** @deprecated  */
  Canceled = 'CANCELED',
  /** @deprecated  */
  Complete = 'COMPLETE',
  /** @deprecated  */
  InGarage = 'IN_GARAGE',
  /** @deprecated  */
  InQueue = 'IN_QUEUE',
  /** @deprecated  */
  PlanningUpcomingVisit = 'PLANNING_UPCOMING_VISIT',
  /** @deprecated  */
  ReadyForPickup = 'READY_FOR_PICKUP',
  /** @deprecated  */
  WaitingOnCustomer = 'WAITING_ON_CUSTOMER'
}

export type VisitStatusCount = {
  __typename?: 'VisitStatusCount';
  count: Scalars['Int'];
  status: VisitStatus;
};

/** Deprecated. It should not be used on the storefront. Contains information about a website. */
export type Website = {
  __typename?: 'Website';
  /**
   * A code assigned to the website to identify it.
   * @deprecated The field should not be used on the storefront.
   */
  code?: Maybe<Scalars['String']>;
  /**
   * The default group ID of the website.
   * @deprecated The field should not be used on the storefront.
   */
  default_group_id?: Maybe<Scalars['String']>;
  /**
   * The ID number assigned to the website.
   * @deprecated The field should not be used on the storefront.
   */
  id?: Maybe<Scalars['Int']>;
  /**
   * Indicates whether this is the default website.
   * @deprecated The field should not be used on the storefront.
   */
  is_default?: Maybe<Scalars['Boolean']>;
  /**
   * The website name. Websites use this name to identify it easier.
   * @deprecated The field should not be used on the storefront.
   */
  name?: Maybe<Scalars['String']>;
  /**
   * The attribute to use for sorting websites.
   * @deprecated The field should not be used on the storefront.
   */
  sort_order?: Maybe<Scalars['Int']>;
};

/** An error encountered while performing operations with WishList. */
export type WishListUserInputError = {
  __typename?: 'WishListUserInputError';
  /** A wish list-specific error code. */
  code: WishListUserInputErrorType;
  /** A localized error message. */
  message: Scalars['String'];
};

/** A list of possible error types. */
export enum WishListUserInputErrorType {
  /** @deprecated  */
  ProductNotFound = 'PRODUCT_NOT_FOUND',
  /** @deprecated  */
  Undefined = 'UNDEFINED'
}

/** Contains a customer wish list. */
export type Wishlist = {
  __typename?: 'Wishlist';
  /** The unique ID for a `Wishlist` object. */
  id?: Maybe<Scalars['ID']>;
  /** @deprecated Use the `items_v2` field instead. */
  items?: Maybe<Array<Maybe<WishlistItem>>>;
  /** The number of items in the wish list. */
  items_count?: Maybe<Scalars['Int']>;
  /** An array of items in the customer's wish list. */
  items_v2?: Maybe<WishlistItems>;
  /** An encrypted code that Magento uses to link to the wish list. */
  sharing_code?: Maybe<Scalars['String']>;
  /** The time of the last modification to the wish list. */
  updated_at?: Maybe<Scalars['String']>;
};


/** Contains a customer wish list. */
export type WishlistItems_V2Args = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** Contains details about errors encountered when a customer added wish list items to the cart. */
export type WishlistCartUserInputError = {
  __typename?: 'WishlistCartUserInputError';
  /** An error code that describes the error encountered. */
  code: WishlistCartUserInputErrorType;
  /** A localized error message. */
  message: Scalars['String'];
  /** The unique ID of the `Wishlist` object containing an error. */
  wishlistId: Scalars['ID'];
  /** The unique ID of the wish list item containing an error. */
  wishlistItemId: Scalars['ID'];
};

/** A list of possible error types. */
export enum WishlistCartUserInputErrorType {
  /** @deprecated  */
  InsufficientStock = 'INSUFFICIENT_STOCK',
  /** @deprecated  */
  NotSalable = 'NOT_SALABLE',
  /** @deprecated  */
  ProductNotFound = 'PRODUCT_NOT_FOUND',
  /** @deprecated  */
  Undefined = 'UNDEFINED'
}

/** Contains details about a wish list item. */
export type WishlistItem = {
  __typename?: 'WishlistItem';
  /** The time when the customer added the item to the wish list. */
  added_at?: Maybe<Scalars['String']>;
  /** The customer's comment about this item. */
  description?: Maybe<Scalars['String']>;
  /** The unique ID for a `WishlistItem` object. */
  id?: Maybe<Scalars['Int']>;
  /** Details about the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item */
  qty?: Maybe<Scalars['Float']>;
};

/** Defines the items to add to a wish list. */
export type WishlistItemInput = {
  /** An array of options that the customer entered. */
  entered_options?: InputMaybe<Array<InputMaybe<EnteredOptionInput>>>;
  /** For complex product types, the SKU of the parent product. */
  parent_sku?: InputMaybe<Scalars['String']>;
  /** The amount or number of items to add. */
  quantity: Scalars['Float'];
  /** An array of strings corresponding to options the customer selected. */
  selected_options?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** The SKU of the product to add. For complex product types, specify the child product SKU. */
  sku: Scalars['String'];
};

/** The interface for wish list items. */
export type WishlistItemInterface = {
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String'];
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars['String']>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID'];
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars['Float'];
};

/** Defines updates to items in a wish list. */
export type WishlistItemUpdateInput = {
  /** Customer-entered comments about the item. */
  description?: InputMaybe<Scalars['String']>;
  /** An array of options that the customer entered. */
  entered_options?: InputMaybe<Array<InputMaybe<EnteredOptionInput>>>;
  /** The new amount or number of this item. */
  quantity?: InputMaybe<Scalars['Float']>;
  /** An array of strings corresponding to options the customer selected. */
  selected_options?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** The unique ID for a `WishlistItemInterface` object. */
  wishlist_item_id: Scalars['ID'];
};

/** Contains an array of items in a wish list. */
export type WishlistItems = {
  __typename?: 'WishlistItems';
  /** A list of items in the wish list. */
  items: Array<Maybe<WishlistItemInterface>>;
  /** Contains pagination metadata. */
  page_info?: Maybe<SearchResultPageInfo>;
};

/** Deprecated: Use the `Wishlist` type instead. */
export type WishlistOutput = {
  __typename?: 'WishlistOutput';
  /**
   * An array of items in the customer's wish list
   * @deprecated Use the `Wishlist.items` field instead.
   */
  items?: Maybe<Array<Maybe<WishlistItem>>>;
  /**
   * The number of items in the wish list.
   * @deprecated Use the `Wishlist.items_count` field instead.
   */
  items_count?: Maybe<Scalars['Int']>;
  /**
   * When multiple wish lists are enabled, the name the customer assigns to the wishlist.
   * @deprecated This field is related to Commerce functionality and is always `null` in Open Source.
   */
  name?: Maybe<Scalars['String']>;
  /**
   * An encrypted code that links to the wish list.
   * @deprecated Use the `Wishlist.sharing_code` field instead.
   */
  sharing_code?: Maybe<Scalars['String']>;
  /**
   * The time of the last modification to the wish list.
   * @deprecated Use the `Wishlist.updated_at` field instead.
   */
  updated_at?: Maybe<Scalars['String']>;
};

export type WorkingTimesInput = {
  working_from: Scalars['Int'];
  working_to: Scalars['Int'];
};

/** Assigns a specific `cart_id` to the empty cart. */
export type CreateEmptyCartInput = {
  /** The ID to assign to the cart. */
  cart_id?: InputMaybe<Scalars['String']>;
};

export type UpdateSosRequestLocationInput = {
  landmark?: InputMaybe<Scalars['String']>;
  lat: Scalars['Float'];
  long: Scalars['Float'];
  orderNumber: Scalars['String'];
};
